import { Injectable } from '@angular/core';
import { ApiClientHelper } from '../helpers/api-client.helper';
import { AppConfig } from '../../shared/config/app-config';
import { LocalStorageService } from './local-storage.service';
import {
    AsyncLivenessStatus,
    AsyncLivenessStatusCode,
    BrmKycBOLvl3Steps,
    BrmKycLvl1Steps,
    BrmKycLvl1StepsV2,
    BrmKycLvl1StepsV3,
    BrmKycLvl2Steps,
    BrmKycLvl2StepsV2,
    BrmKycLvl2StepsV3,
    BrmKycLvl4Step,
    BrmKycOption,
    BrmKycWBOLvl1Steps,
    BrmKycWBOLvl1StepsBBRM,
    BrmKycWBOLvl1StepsBBRMV2,
    BrmKycWBOLvl1StepsV2,
    BrmKycWBOLvl1StepsV3,
    BrmKycWBOLvl2Steps,
    BrmKycWBOLvl2StepsV2,
    BrmKycWBOLvl2StepsV3,
    BrmLivelinessType,
    BusinessAffiliateKeys,
    BusinessNameChangeStep,
    BusinessNameChangeStepV2,
    BusinessNameDetail,
    BusinessNameDetails,
    BusinessPrefix,
    BusinessQuestionnaire,
    BvnResponse,
    CustomMetaMapErrorCode,
    DefaultKycData,
    DefaultKycProgress,
    DefaultOnboardingData,
    ErrorCode,
    FailedBusinessDetailsTimeline,
    FailedSupportingDocumentTimeline,
    Index,
    KYC_IDENTITY_TYPE,
    KycBusinessDocumentDictionary,
    KycBusinessType,
    KycBusinessTypeDisplayName,
    KycBusinessTypeV2,
    KycDictionary,
    KYCFormKeys,
    KycIdentityToken,
    KYCLevel,
    KycLevel2BvnTimeline,
    KycLevel2NinTimeline,
    KycLevel4Step,
    KycLevel4StepForAffiliateFlow,
    KycLevel4StepForAffiliateFlowWithoutBusinessName,
    KycLevel4StepForAffiliateFlowWithoutBusinessNameAndTIN,
    KycLevel4StepForAffiliateFlowWithoutScuml,
    KycLevel4StepForAffiliateFlowWithoutScumlAndTIN,
    KycLevel4StepForAffiliateFlowWithoutTIN,
    KycLevel4StepWithBusinessNameFlow,
    KycLevel4Timelines,
    KYCLevelRoutes,
    KYCLevelStatusV2,
    KycLevelTransactionLimitKeys,
    KYCLevelV2,
    KYCLvl1FormSteps,
    KYCLvl1FormStepsV2,
    KYCLvl1FormStepsV3,
    KYCLvl1FormStepsV4,
    KYCLvl1Step,
    KYCLvl1StepV2,
    KYCLvl1StepV3,
    KYCLvl1StepV4,
    KYCLvl2FormSteps,
    KYCLvl2FormStepsV2,
    KYCLvl2FormStepsV3,
    KYCLvl2Step,
    KYCLvl2StepV2,
    KYCLvl2StepV3,
    KYCLvl3FormSteps,
    KYCLvl3PhysicalAddressTimelines,
    KYCLvl4StepV2,
    KYCLvl4StepV3,
    KYCLvl4StepV4,
    KYCLvl5FormSteps,
    KycLvlState,
    KYCPrimerRoutes,
    KycRoutes,
    MetaMapType,
    OnboardingAddress,
    OnboardingCreateNationality,
    OnboardingCreatePepInfo,
    OnboardingCreateSourceOfWealth,
    OnboardingFormData,
    OtpResponse,
    PepScreeningStatus,
    SignupFormStep,
    SignupFormSteps,
    SOFT_ONBOARDING_ROUTE,
    SOFT_ONBOARDING_SPLASH_SCREEN_ROUTE,
    TimelineIconName,
    TimelineStatus,
    TimelineStatusV2,
    TotalLvl1Step,
    TotalLvl1StepV2,
    TotalLvl1StepV3,
    TotalLvl2Step,
    TotalLvl2StepV2,
    TotalLvl2StepV3,
    TotalStepWBO,
    TotalStepWBOBBRM,
    TotalStepWBOKycLvl2,
    TotalStepWBOV2,
    TotalStepWOBO,
    TotalStepWOBOKycLvl2,
    TotalStepWOBOKycLvl2V2,
    KycLevelNameMap,
    BranchBrmKycLvl1StepsV3,
    BranchBrmKycWBOLvl1StepsV3,
    BrmKycLevel1Steps,
    KYCLvl1StepV5,
    KYCLvl1FormStepsV5,
    KYCLvl1FormStepsV6,
    BrmKycLvl1StepsV4,
    BranchBrmKycLvl1StepsV4,
    BranchBrmKycLvl1StepsV5,
    BranchBrmKycWBOLvl1StepsV4,
    BrmKycWBOLvl1StepsV4,
    NIGERIA_COUNTRY_CODE,
    hasNationalityStep,
    NationalityTimeline,
    KYCLvl3FormStepsV3,
    FaceVerificationStatus,
    AddressV2,
    OnboardingAddressType,
    SupportedDocumentTypes,
    PreviousBillPaymentResponse,
    AddressVerificationResponse,
    AddressV2Details,
    FaceVerificationStatusUpdate,
    SavedUserTokenData,
    OnboardingKycLevel3MixpanelEvents,
    KYCLvl3StepV3,
    KYCLvl3StepV3EventNames,
    KycLvl3LogMixpanelOptions,
    NEW_BO_KYC_LVL3_ACCOUNT_NAME_FORMAT,
    BrmKycLvl1StepsV5,
    KYCLvl1StepV6,
    BranchBrmKycWBOLvl1StepsV5,
    BrmKycWBOLvl1StepsV5,
    KycLevel1Steps,
    OnboardingAdditionalBusinessDetailsResponse,
    PhysicalVerificationDryRunPayload,
    PhysicalVerificationStrategyResponse,
    PhysicalVerificationDryRunResponse,
    PhysicalVerificationResponse,
    PhysicalVerificationPayload,
    KYCLvl1StepV7,
    KYCLvl1FormStepsV7,
    BusinessCategory,
    UpdateBusinessInformation,
    BranchBrmKycWBOLvl1StepsV6,
    BrmKycWBOLvl1StepsV6,
    BrmKycLvl1StepsV6,
    BranchBrmKycLvl1StepsV6
} from '../models/onboarding/onboarding-v2-model';
import { StorageKeys } from '../../shared/models/storage-keys';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { OnboardingService } from './onboarding.service';
import { ModalOptionsConfig, ModalService } from '../../lean-shared/components/nz-modal-service/modal.service';
import {
    DEFAULT_MODAL_KAMONA_CLASSES,
    DEFAULT_MODAL_WIDTH,
    KYC_CATEGORY_DIALOG_CLASS,
    MONIEPOINT_DESIGN_TYPE,
    UserAlias,
} from '../../shared/constants';
import { NzModalRef } from 'ng-zorro-antd/modal';
import { SelectAdaptor } from '../../kamona/components/kamona-input-field/kamona-input-field.component';
import { Datalayer, DatalayerPayload, initializeDatalayer } from '../../shared/models/data.layer.model';
import { StringHelper } from '../helpers/strings.helper';
import { DataLayerService } from './data-layer-service.service';
import { TimelineModel } from '../../shared/models/timeline.model';
import { AlertModalService } from './alert-modal.service';
import { PagedRequest } from '../../shared/models/paged-request.model';
import { Business, OwnerBusinessesModel } from '../../shared/models/business.model';
import { LoginHelperService } from './login-helper.service';
import moment from 'moment';
import { ObjectHelper } from '../helpers/object.helper';
import { NibssVerificationService } from './nibss-verification.service';
import { NibssBvnVerificationData, NibssBvnVerificationResponse } from '../models/nibss-bvn-verfication.model';
import { GeocodingResult, GeolocationType, GeometryLocation, IdentityProvider, SmileIdPayload } from '../../kamona/model/kamonal-model';
import { ConfigsModel, DefaultProvider, DefaultProviders } from '../../shared/models/configs.model';
import { CacVerificationResponse } from '../models/cac-verification.model';
import { KYC_DOCUMENT_TYPE, KYCLevelInfo, KycLvl3V3Steps, KYCRequirement, KYCStanding, ProofOfAddressDocumentType } from '../models/kyc.model';
import { MergeAccountProfileBreadCrumbs } from '../models/merge-account-profile-bredcrumbs';
import { CookieService } from 'ngx-cookie-service';
import { FROM_KYC_BANNER_KEY, getKycCorrectionRoute } from '../models/kyc-compliance.model';
import { DeviceRegistrationRequest } from '../models/login.model';
import { BOMoniebookOnboardingRequest, BOMoniebookOnboardingStatusResponse, MoniebookBusinessOnboardingStatusResponse } from '../models/onboarding/moniebook.model';
import { Response, ApiResponse } from '../../shared/models/api-response.model';
import { BvnNinHardFetchOptions, KycBvnNinMistmatchV2, PREFFERED_KYC_STORAGE_ID_FOR_MERGE_FLOW } from '@mpt-fo/common/core/models/onboarding';
import { KYC_EVENTS } from './channels/onboarding/onboarding-analytics/onboarding-analytics.model';
import { OnboardingAnalyticsService } from './channels/onboarding/onboarding-analytics/onboarding-analytics.service';
import { ClientJS } from 'clientjs';
import { LocationHelper } from '../helpers/location.helper';
import { DeviceHelperService } from './device-helper.service';

@Injectable({
    providedIn: 'root',
})
export class OnboardingV2Service {
    private configuration: ConfigsModel;
    private kycStandingData: KYCStanding | null = null;
    private businessDetails: Business | null = null;
    businessCategories: BusinessCategory[] = [];

    getConfiguration() {
        return this.configuration;
    }

    setConfiguration(configuration: ConfigsModel) {
        this.configuration = configuration;
    }

    get softOnboardingContactDetails() {
        return this._softOnboardingContactDetails;
    }

    set softOnboardingContactDetails(data) {
        this._softOnboardingContactDetails = data;
    }

    allowBrmUsePassportPhotographForBoOnboarding() {
        return this.config.ALLOW_BRM_USE_PASSPORT_PHOTOGRAPH_FOR_BO_ONBOARDING;
    }

    allowBvnForKycLevel1BusinessOnboarding() {
        const isWhitelistedLevel = this.isKycLevelZero() || !this.kycNotFound();
        if (isWhitelistedLevel) {
            return true;
        }

        return this.config.ALLOW_BVN_FOR_KYC_LEVEL_1_BUSINESS_ONBOARDING;
    }

    get isBranchBrm(): boolean {
        const branchBrm = this.localStorage.get(StorageKeys.IS_BANK_BRM);
        if (!branchBrm) {
            return false;
        }
        return JSON.parse(branchBrm);
    }

    constructor(
        private apiClientHelper: ApiClientHelper,
        public config: AppConfig,
        private localStorage: LocalStorageService,
        private router: Router,
        private onboardingService: OnboardingService,
        private modalService: ModalService,
        private dataLayerHelper: DataLayerService,
        private alertService: AlertModalService,
        private loginHelper: LoginHelperService,
        private nibssService: NibssVerificationService,
        private cookieService: CookieService,
        private route: ActivatedRoute,
        private onboardingAnalyticsService: OnboardingAnalyticsService,
		private locationHelper: LocationHelper,
        private deviceHelper: DeviceHelperService,
    ) {
        this.Config = this.config;
    }

    readonly signupStore = 'sign-up-form';
    runningModal: NzModalRef;
    readonly DEFAULT_KYC_LVL_STEP = 1;
    readonly DEFAULT_KYC_LIVELINESS_STEP = 2;
    readonly PROCESS_TOO_LONG_TEXT = 'Request may have taken too long. Please restart process.';
    readonly DASHBOARD_ROUTE = KycRoutes.BO_DASHBOARD;
    readonly SUCCESS_MODAL = '/onboarding-v2/success-modal';
    readonly LOGIN = '/login';
    readonly BUSINESS_AFFILIATE = '/onboarding-v2/kyc-business-affiliate-v2';
    readonly BUSINESS_AFFILIATE_DETAILS = '/onboarding-v2/kyc-business-affiliate-details-v2';
    readonly BRM_BUSINESS_AFFILIATE = '/onboarding-v2/brm-kyc-business-affiliate-v2';
    readonly BRM_BUSINESS_AFFILIATE_DETAILS = '/onboarding-v2/brm-kyc-business-affiliate-details-v2';
    readonly successModalRoute = KycRoutes.BO_KYC_LVL_4_SUCCESS_MODAL;
    readonly KYC_LVL5_UPLOAD_DOCUMENT = '/onboarding-v2/kyc-lvl5-re-upload-document';
    readonly REGISTERED = 'REGISTERED';
    readonly DASHBOARD = 'Dashboard';
    readonly KYC = '/onboarding-v2/kyc';
    readonly NibssBvnVerificationRoute = '/nibss-bvn-verification';
    readonly BVN_OR_NIN = 'BVN or NIN';
    readonly BVN_NIN_VERIFIED_KEY = KYCFormKeys.BVN_NIN_VERIFIED;

    Config: AppConfig;
    accountActivationToken: string;
    accountActivationStep: number;
    accountActivationProfile;
    accountActivationValidationKey: string;
    readonly SUCCESS_MODAL_TITLE = 'Account Has Been \n Created But is Pending \n Activation';
    readonly SUCCESS_MODAL_TITLE_V2 = 'Account Has Been \n Created Successfully';
    readonly SUCCESS_MODAL_TITLE_V3 = 'Account is being upgraded';
    readonly SUCCESS_MODAL_TITLE_V4 = 'Account successfully \n Upgraded';
    readonly SUCCESS_MODAL_TITLE_V5 = 'Account Upgrade \n Pending Activation';
    private bvn: string;
    private bvnDateOfBirth: any;
    private signupFormObserver = new Subject<any>();
    signupFormObserver$ = this.signupFormObserver.asObservable();
    private kycLvl1FormObserver = new Subject<any>();
    kycLvl1FormObserver$ = this.kycLvl1FormObserver.asObservable();
    private kycLvl2FormObserver = new Subject<any>();
    kycLvl2FormObserver$ = this.kycLvl2FormObserver.asObservable();
    private kycLvl3FormObserver = new Subject<any>();
    kycLvl3FormObserver$ = this.kycLvl3FormObserver.asObservable();
    private kycLvl4FormObserver = new Subject<any>();
    kycLvl4FormObserver$ = this.kycLvl4FormObserver.asObservable();
    private loaderObserver = new Subject<any>();
    loaderObserver$ = this.loaderObserver.asObservable();
    private accountActivationObserver = new Subject<any>();
    accountActivationObserverObserver$ = this.accountActivationObserver.asObservable();
    private shouldCompleteSelfOnboardingKyc: boolean;
    private userPin: boolean;
    private businessOwnerProfile: boolean;
    private validatedUserData;
    private softOnboardingFormObserver = new Subject<any>();
    softOnboardingFormObserver$ = this.softOnboardingFormObserver.asObservable();
    // tslint:disable-next-line:variable-name
    private _softOnboardingContactDetails;
    readonly WEB_MODAL_WIDTH = 496;
    readonly DEFAULT_BUSINESS_NAME_VIEW = 0;
    readonly defaultAsyncLivelinessDetail = {
        nextStep: this.DEFAULT_KYC_LIVELINESS_STEP + 1,
        previousStep: this.DEFAULT_KYC_LVL_STEP,
        restartStep: this.DEFAULT_KYC_LIVELINESS_STEP,
    };
    readonly CAC_NUMBER = 'CAC Number';
    readonly TIN = 'TIN';
    private resumeNinBvnUpgradeFlow$ = new BehaviorSubject<string>('');
    private hardRefetchBvnNin$ = new BehaviorSubject<BvnNinHardFetchOptions>({ bvn: '', nin: '', shouldHardFetch: false, identityType: '' });
    private loggedInUserGeoLocationResults: GeocodingResult[];
    private lvl3ActiveGeoCodingResult: GeocodingResult;
    private supportedlvl3DocumentTypes: SupportedDocumentTypes;
    boActualLocationInfo: { isEdited: boolean; location: GeometryLocation };

    setResumeNinBvnUpgradeFlow(value: string) {
        this.resumeNinBvnUpgradeFlow$.next(value);
    }

    getResumeNinBvnUpgradeFlow() {
        return this.resumeNinBvnUpgradeFlow$.asObservable();
    }

    setShouldHardRefetchBvnNin(data: BvnNinHardFetchOptions) {
        this.hardRefetchBvnNin$.next(data);
    }

    resetShouldHardRefetchBvnNin() {
        this.hardRefetchBvnNin$.next({ bvn: '', nin: '', shouldHardFetch: false, identityType: '' });
    }

    getShouldHardRefetchBvnNin() {
        return this.hardRefetchBvnNin$.asObservable();
    }

    setBusinessNamePreviousKey(key: number) {
        if (!key) {
            this.localStorage.deleteValue(StorageKeys.business_name_previous_key);
            return;
        }
        this.localStorage.save(StorageKeys.business_name_previous_key, JSON.stringify(key));
    }

    getBusinessNamePreviousKey() {
        const businessNamePreviousKey = this.localStorage.get(StorageKeys.business_name_previous_key);
        return businessNamePreviousKey ? JSON.parse(businessNamePreviousKey) : null;
    }

    handleBusinessNameDetailsPreviousRoute(route, view: number, isBRM = false) {
        this.setBusinessNameCurrentView(view);
        this.setBusinessNamePreviousKey(view);
        this.navigateKycLvl4Form(route);
    }

    routeToLivelinessStatusPage(nextStep: number, previousStep: number, restartStep: number) {
        this.setAsyncLivelinessStepDetails({ nextStep, previousStep, restartStep });
        this.routeToPage(`/onboarding-v2/async-liveliness-status`);
    }

    setAsyncLivelinessStepDetails(params: any) {
        this.localStorage.save('async_liveliness_step_details', JSON.stringify(params));
    }

    getAsyncLivelinessStepDetails() {
        const defaultDetails = this.defaultAsyncLivelinessDetail;
        const savedDetails = this.localStorage.get('async_liveliness_step_details');
        return savedDetails ? JSON.parse(savedDetails) : defaultDetails;
    }

    canUseAsyncLivelinessCheck() {
        return this.config.USE_ASYNC_LIVELINESS_CHECK;
    }

    livelinessInProgress(code: string) {
        return ErrorCode.LIVELINESS_IN_PROGRESS === code;
    }

    startAsyncLiveliness() {
        const kycData = this.getKycDataV2();
        const async_liveness_status: AsyncLivenessStatus = kycData?.async_liveness_status;
        return async_liveness_status.asyncLivelinessInProgress;
    }

    continueAsyncLiveliness() {
        const kyc = this.getKycDataV2();
        const async_liveness_status: AsyncLivenessStatus = kyc?.async_liveness_status;
        return (
            async_liveness_status.statusCode === AsyncLivenessStatusCode.BVN_NIN_VALID_BUT_LIVELINESS_NOT_INITIATED ||
            async_liveness_status.statusCode === AsyncLivenessStatusCode.PREVIOUSLY_FAILED_CALLBACK_PROCESSING ||
            async_liveness_status.statusCode === AsyncLivenessStatusCode.OLD_LIVELINESS_FLOW ||
            async_liveness_status.statusCode === AsyncLivenessStatusCode.ASYNC_LIVELINESS_HAS_EXCEEDED_SUBMISSION_WAIT_TIME
        );
    }

    setSelectedBusinessNameDetail(selected: BusinessNameDetail) {
        if (!selected) {
            this.localStorage.deleteValue(StorageKeys.business_name_selected_detail);
            return;
        }
        this.localStorage.save(StorageKeys.business_name_selected_detail, JSON.stringify(selected));
    }

    getSelectedBusinessNameDetail() {
        const businessNameDetail = this.localStorage.get(StorageKeys.business_name_selected_detail);
        return businessNameDetail ? JSON.parse(businessNameDetail) : null;
    }

    async getLivelinessProvider() {
        const defaultProviders: DefaultProvider = await this.getDefaultProviders();
        return defaultProviders.liveliness;
    }

    async getDefaultProviders() {
        const config = await this.getConfigurationsFromStorageOrApi();
        return config?.defaultProviders || DefaultProviders;
    }

    async getConfigurationsFromStorageOrApi() {
        let config = this.getConfiguration();
        try {
            config = config || (await this.getFrontofficeConfigurations());
            this.setConfiguration(config);
        } catch (err) {}
        return config;
    }

    getFrontofficeConfigurations(): Promise<ConfigsModel> {
        const url = this.config.MONIEPOINT_HOST + `/api/v1/configurations`;
        return this.apiClientHelper.getForPromise(url);
    }

    openDrawer() {
        const hasExitAnimation = document.getElementById('onboarding-custom-drawer-content')?.classList?.contains('animate__slideOutRight');
        hasExitAnimation ? this.replaceExitDrawerAnimation() : this.addDrawerAnimation();
        if (document.getElementById('onboarding-custom-drawer')) {
            document.getElementById('onboarding-custom-drawer').style.width = `100%`;
        }
    }

    replaceExitDrawerAnimation() {
        document.getElementById('onboarding-custom-drawer-content')?.classList?.replace('animate__slideOutRight', 'animate__slideInRight');
    }

    addDrawerAnimation() {
        document.getElementById('onboarding-custom-drawer-content')?.classList?.add('animate__slideInRight');
    }

    replaceOpenDrawerAnimation() {
        document.getElementById('onboarding-custom-drawer-content')?.classList?.replace('animate__slideInRight', 'animate__slideOutRight');
    }

    closeDrawer() {
        this.replaceOpenDrawerAnimation();
        if (document.getElementById('onboarding-custom-drawer')) {
            document.getElementById('onboarding-custom-drawer').style.width = '0';
        }
    }

    setIsBusinessNameSelected(isBusinessName: boolean) {
        if (!isBusinessName) {
            this.localStorage.deleteValue(StorageKeys.is_business_name_selected);
            return;
        }
        this.localStorage.save(StorageKeys.is_business_name_selected, JSON.stringify(isBusinessName));
    }

    isBusinessNameSelected() {
        const isBusinessNameSelected = this.localStorage.get(StorageKeys.is_business_name_selected);
        return isBusinessNameSelected ? JSON.parse(isBusinessNameSelected) : false;
    }

    getBusinessNameCurrentView() {
        const businessNameCurrentView =
            this.localStorage.get(StorageKeys.business_name_current_view) || JSON.stringify(this.DEFAULT_BUSINESS_NAME_VIEW);
        return JSON.parse(businessNameCurrentView);
    }

    setBusinessNameCurrentView(view) {
        this.localStorage.save(StorageKeys.business_name_current_view, JSON.stringify(view));
    }

    getKycLvl1Step(): KycLevel1Steps {
        if (this.useEnhancedKycLvl1Flow()) return this.kycLvlEnhancedKycEnum;
        if (this.useKycNINFlow()) return KYCLvl1StepV3;
        return this.shouldUseNewBvnFlow() ? KYCLvl1StepV2 : KYCLvl1Step;
    }

    get kycLvlEnhancedKycEnum() {
        if(this.useKycLvl1PreventHybridMerchant()) {
            return KYCLvl1StepV7
        }
        if (this.useAdditionBusinessDetailsKycLvl1()) return KYCLvl1StepV6;
        return this.useKycBvnNationality() ? KYCLvl1StepV5 : KYCLvl1StepV4;
    }

    getKycLvl2Timelines() {
        if (!this.useKycNINFlow()) return KYCLvl2FormSteps;
        return this.useSimplifiedKycLevel2Flow() ? KYCLvl2FormStepsV3 : KYCLvl2FormStepsV2;
    }

    getSaveTokenData() {
        return this.localStorage.getSaveTokenData();
    }

    getExtractedTokenData(): undefined | Partial<SavedUserTokenData> {
        const tokenData = this.getSaveTokenData();
        return tokenData ?? {};
    }

    getKycLvl3MixpanelUserEventData() {
        const tokenData = this.getExtractedTokenData();
        const { username = '', email = '', phone = '' } = tokenData;

        const client = new ClientJS();
        const browser = client.getBrowser();
        const browserVersion = client.getBrowserMajorVersion();
        const os = client.getOS();
        const osVersion = client.getOSVersion();
        const device_id = this.localStorage.get(StorageKeys.unique_device_identifier);
        const device_version = osVersion;
        const device_type = `${os} (${browser} ${browserVersion})`;

        const eventParams = {
            device_id,
            device_type,
            device_version,
            platform: 'WEB',
            app_version: '',
            app_domain: window.location.hostname,
            email,
            phone_number: phone,
            user_name: username,
        };

        return eventParams;
    }

    getKycLvl2Step() {
        if (!this.useKycNINFlow()) return KYCLvl2Step;
        return this.useSimplifiedKycLevel2Flow() ? KYCLvl2StepV3 : KYCLvl2StepV2;
    }

    getBrmKycLvl2Step() {
        if (!this.useBrmKycNINFlow()) return BrmKycLvl2Steps;
        return this.useSimplifiedBrmKycLevel2Flow() ? BrmKycLvl2StepsV3 : BrmKycLvl2StepsV2;
    }

    getKycLvl4Step() {
        const canUseBusinessNameChange = this.canUseBusinessNameChange();
        const useBusinessAffiliateVerification = this.useBusinessAffiliateFlow();
        if (useBusinessAffiliateVerification) {
            return canUseBusinessNameChange ? KYCLvl4StepV3 : KYCLvl4StepV4;
        }
        return canUseBusinessNameChange ? KYCLvl4StepV2 : BrmKycLvl4Step;
    }

    canMakeStateAndLgaOptional() {
        return this.config.CAN_MAKE_STATE_LGA_OPTIONAL;
    }

    useNewKycLevel2Step(kycLevel2Step): kycLevel2Step is typeof KYCLvl2StepV3 {
        return this.useSimplifiedKycLevel2Flow();
    }

    isSimplifiedBrmKycLevel2Step(brmKycLevel2Step): brmKycLevel2Step is typeof BrmKycLvl2StepsV3 {
        return this.useSimplifiedBrmKycLevel2Flow();
    }

    clearKycBvn() {
        const kycData = this.getKycDataV2();
        if (kycData) {
            kycData.bankVerificationNumber = '';
        }
        this.setKycDataV2(kycData);
    }

    async logIdentityVerificationEvent(event, errorMessage = null) {
        const kycData = this.getKycDataV2();
        const payload = this.getInitialIdentityVerificationEventPayload(event, errorMessage);
        this.setIdentityVerificationEventLocation(payload, kycData);
        this.setIdentityVerificationEventPersonalInformation(payload, kycData);
        payload.liveness_provider = await this.getLivelinessProvider();
        this.dataLayerHelper.logEvent(payload);
    }
    getInitialIdentityVerificationEventPayload(event, errorMessage) {
        const payload = initializeDatalayer(event);
        payload.step = KycDictionary.Meta_Map_Verification;
        payload.error_message = errorMessage ? errorMessage : '';
        return payload;
    }
    setIdentityVerificationEventLocation(payload: Datalayer, kycData) {
        payload.city = '';
        const state = kycData?.personalInformation?.localGovernment?.state?.id || '';
        const lga = kycData?.personalInformation?.localGovernment?.id || '';
        payload.state = `${state}`;
        payload.lga = `${lga}`;
    }

    setIdentityVerificationEventPersonalInformation(payload: Datalayer, kycData) {
        payload.religion = kycData?.personalInformation?.religion || '';
        payload.employment_status = kycData?.personalInformation?.employmentStatus || '';
        payload.marital_status = kycData?.personalInformation?.maritalStatus || '';
    }

    getKycLvl1TotalStep() {
        if (this.isBranchBrm) {
            return TotalStepWBOBBRM;
        }
        if (this.useEnhancedKycLvl1Flow()) {
            return TotalLvl1StepV3;
        }
        return this.shouldUseNewBvnFlow() ? TotalLvl1StepV2 : TotalLvl1Step;
    }

    getKycLvl2TotalStep() {
        if (!this.useKycNINFlow()) {
            return TotalLvl2Step;
        }
        return this.useSimplifiedKycLevel2Flow() ? TotalLvl2StepV3 : TotalLvl2StepV2;
    }

    createMobileNibssModalConfig() {
        const config = new ModalOptionsConfig();
        config.nzComponentParams.alertType = 'info';
        config.className = DEFAULT_MODAL_KAMONA_CLASSES;
        config.nzWidth = DEFAULT_MODAL_WIDTH;
        config.nzComponentParams.designType = MONIEPOINT_DESIGN_TYPE.KAMONA;
        return config;
    }

    createWebNibssModalConfig() {
        const config = new ModalOptionsConfig();
        config.nzMaskClosable = false;
        config.nzWidth = this.WEB_MODAL_WIDTH;
        config.className = KYC_CATEGORY_DIALOG_CLASS;
        return config;
    }

    getBvn() {
        return this.bvn;
    }

    shouldUseNewBvnFlow() {
        const kycData = this.getKycDataV2();
        const hasNoBvn = !kycData?.shouldUseNewBvnFlow && !kycData?.hasSubmittedBvn;
        return kycData?.shouldUseNewBvnFlow || hasNoBvn;
    }

    useKycNINFlow() {
        return this.config.USE_KYC_NIN_FLOW;
    }

    useBrmKycNINFlow() {
        return this.useKycNINFlow() && this.config.USE_BRM_KYC_NIN_FLOW;
    }

    useEnhancedKycLvl1Flow() {
        return this.config.USE_PEP_NATIONALITY_INCOME_LEVEL_1_FLOW;
    }

    useBrmEnhancedKycLvl1Flow() {
        return this.useEnhancedKycLvl1Flow() && this.config.USE_BRM_PEP_NATIONALITY_INCOME_LEVEL_1_FLOW;
    }

    useKycBvnNationality() {
        return this.config.USE_KYC_BVN_NATIONALITY;
    }

    useBrmKycBvnNationality() {
        return this.config.USE_BRM_KYC_BVN_NATIONALITY;
    }

    showKycLvl1BusinessNameDescriptionSize() {
        return this.config.SHOW_KYC_LVL1_BUSINESS_NAME_DESCRIPTION_SIZE;
    }

    useAutoAddressApproval() {
        return this.config.USE_AUTO_ADDRESS_APPROVAL && this.isAggregatorRole();
    }

    getBrmKycLevelOneStep(): BrmKycLevel1Steps {
        if (this.isBranchBrm) {
            return this.getBranchBrmKycLevelOneStep();
        }
        return this.getNonBranchBrmKycLevelOneStep();
    }

    getBranchBrmKycLevelOneStep(): BrmKycLevel1Steps {
        if (!this.useBrmEnhancedKycLvl1Flow()) {
            return BrmKycLvl1Steps;
        }
        if (this.useKycLvl1PreventHybridMerchant()){
            return BranchBrmKycLvl1StepsV6;
        }
        if (this.useBrmAdditionalBusinessDetailsKycLvl1()) {
            return BranchBrmKycLvl1StepsV5;
        }
        if (this.useBrmKycBvnNationality()) {
            return BranchBrmKycLvl1StepsV4;
        }
        return BranchBrmKycLvl1StepsV3;
    }

    getNonBranchBrmKycLevelOneStep(): BrmKycLevel1Steps {
        if (!this.useBrmEnhancedKycLvl1Flow()) {
            return BrmKycLvl1StepsV2;
        }
        if (this.useKycLvl1PreventHybridMerchant()){
            return BrmKycLvl1StepsV6;
        }
        if (this.useBrmAdditionalBusinessDetailsKycLvl1()) {
            return BrmKycLvl1StepsV5;
        }
        if (this.useBrmKycBvnNationality()) {
            return BrmKycLvl1StepsV4;
        }
        return BrmKycLvl1StepsV3;
    }

    useNibssBvnVerification() {
        return this.config.USE_NIBSS_BVN_VERIFICATION;
    }

    canHideKycLevel1Primer() {
        return this.config.CAN_HIDE_KYC_LEVEL1_PRIMER;
    }

    useSimplifiedKycLevel2Flow() {
        return this.config.USE_NEW_KYC_LEVEL2_FLOW;
    }

    useSimplifiedBrmKycLevel2Flow() {
        return this.useSimplifiedKycLevel2Flow() && this.config.USE_NEW_BRM_KYC_LEVEL2_FLOW;
    }

    useSimplifiedKycLevel3Flow() {
        return this.config.USE_NEW_KYC_LEVEL3_FLOW;
    }

    useNewBOKYCLevel3Flow() {
        return this.config.USE_NEW_BO_KYC_LEVEL3_V3_FLOW;
    }

    getOkhiApiKey() {
        return this.config.OKHI_API_KEY;
    }
    getClientVersion() {
        return AppConfig.CLIENT_VERSION;
    }
    getAppName() {
        return this.config.DOMAIN_ID;
    }

    useSimplifiedBrmKycLevel3Flow() {
        return this.useSimplifiedKycLevel3Flow() && this.config.USE_NEW_BRM_KYC_LEVEL3_FLOW;
    }

    useKycLevel2UpgradeFlow() {
        return this.config.SHOULD_USE_KYC_LVL2_UPGRADE_FLOW;
    }

    shouldUseUpgradeKycLevel2Flow() {
        return this.useKycLevel2UpgradeFlow() && (this.hasCompletedLvl1() || this.router.url.includes('lvl2'));
    }

    showBoKycLvl1BackButton() {
        return !this.config.HIDE_BO_KYC_LVL1_BACK_BUTTON;
    }

    canUseBusinessNameChange() {
        return this.getKycDataV2()?.useNewAccountNameFlowForLevelFour;
    }

    handleOldSignupUser() {
        const kycData = this.getKycDataV2();
        return kycData?.hasSubmittedBvn && !kycData?.has_completed_liveliness_verification;
    }

    setLoader(loading: boolean) {
        this.loaderObserver.next(loading);
    }

    canShowGracePeriodCountDown(endTime, defaultTimeDifferenceInDays) {
        if (!endTime) {
            return false;
        }
        const startDate = new Date();
        const endDate = new Date(endTime);
        const timeDifference = endDate.getTime() - startDate.getTime();
        const timeDifferenceInDays = timeDifference / (1000 * 3600 * 24);
        return timeDifferenceInDays < defaultTimeDifferenceInDays;
    }

    setHasAccessedDashboard(hasAccessedDashboard) {
        this.localStorage.save(StorageKeys.has_accessed_dashboard, JSON.stringify(hasAccessedDashboard));
    }

    hasAccessedDashboard() {
        const hasAccessedDashboard = this.localStorage.get(StorageKeys.has_accessed_dashboard) || 'false';
        return JSON.parse(hasAccessedDashboard);
    }

    setAccountActivationToken(token) {
        this.accountActivationToken = token;
    }

    getAccountActivationToken() {
        return this.accountActivationToken;
    }

    clearCache(forcedReload = false) {
        const isReload = this.localStorage.get('cache-cleared');
        if (isReload) {
            return;
        }
        this.localStorage.save('cache-cleared', true);
        // @ts-ignore
        window.location.reload(forcedReload);
    }

    setAccountActivationValidationKey(key) {
        this.accountActivationValidationKey = key;
    }

    getAccountActivationValidationKey() {
        return this.accountActivationValidationKey;
    }

    canOpenDigitalAccountForBO() {
        return this.config.CAN_OPEN_BO_DIGITAL_ACCOUNT;
    }

    canUseNibssBvnVerification() {
        return this.nibssService.canUseNibssBvnVerification();
    }

    setShouldCompleteSelfOnboardingKyc(param: boolean) {
        this.shouldCompleteSelfOnboardingKyc = param;
    }

    setHasUserPin(hasPin) {
        this.userPin = hasPin;
    }

    hasUserPin() {
        return this.userPin;
    }

    redirectToNibssBvnVerificationFromSelfOnboarding() {
        const bvnFormStep = SignupFormSteps[Index.TWO];
        const validationKey = this.getSignupData()?.validationKey;
        const nibssBvnVerificationData: NibssBvnVerificationData = {
            mobileHeaderText: bvnFormStep.previousTitle,
            title: bvnFormStep.title,
            subTitle: bvnFormStep.description,
            currentStep: bvnFormStep.step,
            totalSteps: Index.FOUR,
            nextSteps: SignupFormStep.PROFILE_CREATION_AFTER_NIBSS_VERIFICATION,
            validationKey,
            redirectRoute: '/onboarding-v2',
            shouldUpdateStep: true,
            storageKey: StorageKeys.current_on_boarding_step,
        };
        this.redirectToNibssBvnVerification(nibssBvnVerificationData);
    }

    private redirectToNibssBvnVerification(data?: NibssBvnVerificationData) {
        if (!StringHelper.isNullOrEmptyOrUndefined(data)) {
            this.nibssService.setNibssVerificationData(data);
            return this.router.navigateByUrl(this.NibssBvnVerificationRoute);
        }
    }

    completeSelfOnboardingKyc() {
        return this.shouldCompleteSelfOnboardingKyc;
    }

    setAccountActivationStep(step, ignoreObserver = false) {
        this.accountActivationStep = step;
        if (!StringHelper.isNullOrEmptyOrUndefined(step)) {
            this.localStorage.save('account_Activation_Step', `${step}`);
        }
        if (!ignoreObserver) {
            this.accountActivationObserver.next(step);
        }
    }

    getValidationKey() {
        return this.localStorage.get(StorageKeys.validation_key_v2);
    }

    setValidationKey(key) {
        if (StringHelper.isNullOrEmptyOrUndefined(key)) {
            this.clearValidationKey();
            return;
        }
        this.localStorage.save(StorageKeys.validation_key_v2, key);
    }

    clearValidationKey() {
        this.localStorage.deleteValue(StorageKeys.validation_key_v2);
    }

    setAccountActivationProfile(profile) {
        this.accountActivationProfile = profile;
    }

    getAccountActivationProfile() {
        return this.accountActivationProfile;
    }

    validateAccountActivationToken(resetToken): Promise<any> {
        const url = this.config.MONIEPOINT_ONBOARDING + `/api/v1/account/token/validate?token=${resetToken}`;
        return this.apiClientHelper.getForPromise(url, false);
    }

    getKycIdentityType(): Promise<KycIdentityToken> {
        const url = this.config.MONIEPOINT_ONBOARDING + `/api/v1/identity-tokens`;
        return this.apiClientHelper.getForPromise(url);
    }

    concludeBoAccount(id): Promise<any> {
        const url = this.config.MONIEPOINT_ONBOARDING + `/api/v1/business-owner-onboarding/level-1/conclude?requestId=${id}`;
        return this.apiClientHelper.postForPromise(url, {});
    }

    canUseIdentityToken() {
        return this.config.CAN_USE_IDENTITY_TOKEN;
    }

    hasSubmittedBvn() {
        const kycData = this.getKycDataV2();
        return kycData?.hasSubmittedBvn;
    }

    getBankVerificationNumberFromKyc() {
        const kycData = this.getKycDataV2();
        return kycData?.bankVerificationNumber;
    }

    getNationalIdentificationNumberFromKyc() {
        const kycData = this.getKycDataV2();
        return kycData?.nationalIdentificationNumber;
    }

    getPhoneNumberFromKycData() {
        const kycData = this.getKycDataV2();
        return kycData?.phoneNumber;
    }

    validKycLvl1Bvn(bvn: any, existingCustomer = false): Promise<NibssBvnVerificationResponse> {
        const urlPath = existingCustomer ? `/api/v2/business-kycs/bvn?existing-customer=true` : `/api/v2/business-kycs/bvn`;
        const url = this.config.MONIEPOINT_ONBOARDING + urlPath;
        this.updatePayloadWithLivelinessAsyncParameter(bvn);
        return this.apiClientHelper.postForPromise(url, bvn);
    }

    validKycLvl1BvnV2(bvn: any, existingCustomer = false): Promise<NibssBvnVerificationResponse> {
        const urlPath = `/api/v2/business-owner-onboarding/level-2/bvn${existingCustomer ? '?existing-customer=true' : ''}`;
        const url = this.config.MONIEPOINT_ONBOARDING + urlPath;
        this.updatePayloadWithLivelinessAsyncParameter(bvn);
        return this.apiClientHelper.postForPromise(url, bvn);
    }

    logLevel2IdVerification(payload, skipLog = true) {
        if (skipLog) return;
        this.onboardingAnalyticsService.trackKycLevelEvent({ event: KYC_EVENTS.LEVEL_2.ID_VERIFICATION_INITIATED, eventData: payload });
    }

    validKycBvnV3({ bvn, retryBvnNinMatch = false }: { bvn: string; retryBvnNinMatch?: boolean }) {
        const urlPath = `/api/v1/kyc-upgrade/submit/bvn`;
        const url = this.config.MONIEPOINT_ONBOARDING + urlPath;
        const payload = {
            number: bvn,
            retryBvnNinMatch,
        };
        this.logLevel2IdVerification(payload, retryBvnNinMatch);
        return this.apiClientHelper.postForPromise(url, payload);
    }

    validKycBrmBvnV3({ bvn, retryBvnNinMatch = false }) {
        const requestId = this.getKycRequestId();
        const urlPath = `/api/v1/kyc-upgrade/submit/bvn`;
        const url = this.config.MONIEPOINT_ONBOARDING + urlPath;
        const payload = {
            number: bvn,
            retryBvnNinMatch,
            requestId,
        };
        this.logLevel2IdVerification(payload, retryBvnNinMatch);
        return this.apiClientHelper.postForPromise(url, payload);
    }

    validKycNinV3({ nin, retryBvnNinMatch = false, isFromBanner = false }) {
        const urlPath = `/api/v1/kyc-upgrade/submit/nin`;
        const url = this.config.MONIEPOINT_ONBOARDING + urlPath;
        const payload = {
            number: nin,
            retryBvnNinMatch,
            isFromBanner,
        };
        this.logLevel2IdVerification(payload, retryBvnNinMatch);
        return this.apiClientHelper.postForPromise(url, payload);
    }

    validKycBrmNinV3({ nin, retryBvnNinMatch = false, isFromBanner = false }) {
        const requestId = this.getKycRequestId();
        const urlPath = `/api/v1/kyc-upgrade/submit/nin`;
        const url = this.config.MONIEPOINT_ONBOARDING + urlPath;
        const payload = {
            number: nin,
            retryBvnNinMatch,
            requestId,
            isFromBanner,
        };
        this.logLevel2IdVerification(payload, retryBvnNinMatch);
        return this.apiClientHelper.postForPromise(url, payload);
    }

    shouldRetryForMergeFlow() {
        const kycData = this.getKycDataV2();
        const requestId = kycData[PREFFERED_KYC_STORAGE_ID_FOR_MERGE_FLOW];
        const TRUE = 'true';
        const isFromMergeDuplicateProfile = kycData['isFromMergeDuplicateProfile'] === TRUE;

        if (!isFromMergeDuplicateProfile) {
            return {
                fromMergeFlow: false,
            };
        }

        return {
            fromMergeFlow: true,
            requestId,
        };
    }

    validBrmKycLvl1Bvn(bvn: any, requestId): Promise<NibssBvnVerificationResponse> {
        const url = this.config.MONIEPOINT_ONBOARDING + `/api/v2/business-kycs/bvn?requestId=${requestId}&existing-customer=true`;
        this.updatePayloadWithLivelinessAsyncParameter(bvn);
        return this.apiClientHelper.postForPromise(url, bvn);
    }

    validBrmKycLvl2BvnV2(bvn: any, requestId): Promise<NibssBvnVerificationResponse> {
        const url = `${this.config.MONIEPOINT_ONBOARDING}/api/v2/business-owner-onboarding/level-2/bvn?requestId=${requestId}&existing-customer=true`;
        this.updatePayloadWithLivelinessAsyncParameter(bvn);
        return this.apiClientHelper.postForPromise(url, bvn);
    }

    validateNationIdentityNumber(payload: any, existingCustomer = false): Promise<NibssBvnVerificationResponse> {
        const urlPath = existingCustomer ? `/api/v2/business-kycs/nin?existing-customer=true` : `/api/v2/business-kycs/nin`;
        const url = this.config.MONIEPOINT_ONBOARDING + urlPath;
        this.updatePayloadWithLivelinessAsyncParameter(payload);
        return this.apiClientHelper.postForPromise(url, payload);
    }

    handleValidateNIN(payload: any, existingCustomer: boolean) {
        if (this.shouldUseUpgradeKycLevel2Flow()) {
            this.onboardingAnalyticsService.trackKycLevelEvent({ event: KYC_EVENTS.LEVEL_2.ID_VERIFICATION_INITIATED, eventData: payload });
            return this.validKycNinV3({ nin: payload.nin, retryBvnNinMatch: payload.retryBvnNinMatch });
        }

        if (!this.useSimplifiedKycLevel2Flow()) {
            return this.validateNationIdentityNumber(payload, existingCustomer);
        }

        return this.validateNationIdentityNumberV2(payload, existingCustomer);
    }

    handleNinValidateForBrm(payload, isHardRefetch = false) {
        const shouldUseUpgradedLvl2Flow = this.shouldUseUpgradeKycLevel2Flow();
        const requestId = this.getKycRequestId();

        if (shouldUseUpgradedLvl2Flow) {
            this.onboardingAnalyticsService.trackKycLevelEvent({ event: KYC_EVENTS.LEVEL_2.ID_VERIFICATION_INITIATED, eventData: payload });
            return this.validKycBrmNinV3({ ...payload, retryBvnNinMatch: isHardRefetch });
        }

        if (!this.useSimplifiedBrmKycLevel2Flow()) {
            return this.validateNationIdentityNumberViaBrm(payload, requestId);
        }

        return this.validateNationIdentityNumberViaBrmV2(payload, requestId);
    }

    validateNationIdentityNumberV2(payload: any, existingCustomer = false): Promise<NibssBvnVerificationResponse> {
        const urlPath = `/api/v2/business-owner-onboarding/level-2/nin${existingCustomer ? '?existing-customer=true' : ''}`;
        const url = this.config.MONIEPOINT_ONBOARDING + urlPath;
        this.updatePayloadWithLivelinessAsyncParameter(payload);
        return this.apiClientHelper.postForPromise(url, payload);
    }

    validateNationIdentityNumberViaBrm(payload: any, requestId): Promise<NibssBvnVerificationResponse> {
        const url = this.config.MONIEPOINT_ONBOARDING + `/api/v2/business-kycs/nin?requestId=${requestId}&existing-customer=true`;
        this.updatePayloadWithLivelinessAsyncParameter(payload);
        return this.apiClientHelper.postForPromise(url, payload);
    }

    updateNationIdentityNumberViaV3(payload: any): Promise<NibssBvnVerificationResponse> {
        const requestId = this.getKycRequestId();
        const url = this.config.MONIEPOINT_ONBOARDING + `/api/v2/business-kycs/nin-update?requestId=${requestId}`;
        return this.apiClientHelper.postForPromise(url, payload);
    }

    validateNationIdentityNumberViaBrmV2(payload: any, requestId): Promise<NibssBvnVerificationResponse> {
        const url = `${this.config.MONIEPOINT_ONBOARDING}/api/v2/business-owner-onboarding/level-2/nin?requestId=${requestId}&existing-customer=true`;
        this.updatePayloadWithLivelinessAsyncParameter(payload);
        return this.apiClientHelper.postForPromise(url, payload);
    }

    updatePayloadWithLivelinessAsyncParameter(payload: any) {
        if (this.config.USE_ASYNC_LIVELINESS_CHECK) payload.liveness_async_flow = true;
    }

    validateNationIdentityNumberForBrm(param: any): Promise<NibssBvnVerificationResponse> {
        const url = this.config.MONIEPOINT_ONBOARDING + `/api/v1/business-owner-onboarding/level-1/brm-onboarding/nin/validation`;
        this.updatePayloadWithLivelinessAsyncParameter(param);
        return this.apiClientHelper.postForPromise(url, param);
    }

    validateNationIdentityNumberForBrmV2(param: any): Promise<NibssBvnVerificationResponse> {
        const url = this.config.MONIEPOINT_ONBOARDING + `/api/v2/business-owner-onboarding/level-1/brm-onboarding/nin/validation`;
        this.updatePayloadWithLivelinessAsyncParameter(param);
        return this.apiClientHelper.postForPromise(url, param);
    }

    getAccountActivationStep() {
        const step = this.localStorage.get('account_Activation_Step');
        if (StringHelper.isNullOrEmptyOrUndefined(step)) {
            return this.DEFAULT_KYC_LVL_STEP;
        }
        return JSON.parse(step);
    }

    savedBvnData(res) {
        if (StringHelper.isNullOrEmptyOrUndefined(res)) {
            this.localStorage.deleteValue(StorageKeys.saved_bvn_data);
            return;
        }
        this.localStorage.save(StorageKeys.saved_bvn_data, JSON.stringify(res));
    }

    getSavedBvnData() {
        const savedData = this.localStorage.get(StorageKeys.saved_bvn_data);
        if (StringHelper.isNullOrEmptyOrUndefined(savedData)) {
            return null;
        }
        return JSON.parse(savedData);
    }

    saveNinData(res) {
        if (StringHelper.isNullOrEmptyOrUndefined(res)) {
            this.clearSavedNinData();
            return;
        }
        this.localStorage.save(StorageKeys.SAVED_NIN_DATA, JSON.stringify(res));
    }

    getSavedNinData() {
        const savedData = this.localStorage.get(StorageKeys.SAVED_NIN_DATA);
        if (StringHelper.isNullOrEmptyOrUndefined(savedData)) {
            return null;
        }
        return JSON.parse(savedData);
    }

    clearSavedNinData() {
        this.localStorage.deleteValue(StorageKeys.SAVED_NIN_DATA);
    }

    getKycRoute(kycLevel, kycLevelStatus) {
        const hasNoBusiness = StringHelper.isNullOrEmptyOrUndefined(kycLevel);
        if (hasNoBusiness) {
            return KYCLevel.LVL_1;
        }
        const kycLevelObj = Object.keys(kycLevelStatus);
        const routeKey = kycLevelObj.find((lvl) => this.getCurrentLvl(kycLevelStatus[lvl]));
        return this.getPrimerRoute(routeKey);
    }

    getCurrentLvl(status) {
        return status === KycLvlState.STARTED || status === KycLvlState.NOT_STARTED;
    }

    routeToBrmOptions() {
        this.routeToPage(KycRoutes.bo_setup_step_modal);
    }

    getPrimerRoute(routeKey: string) {
        const noRouteKey = StringHelper.isNullOrEmptyOrUndefined(routeKey);
        if (noRouteKey) {
            return null;
        }
        return KYCLevelV2[routeKey];
    }

    setSelectedDirector(director: any) {
        if (!director) {
            this.localStorage.deleteValue('selected_director');
            return;
        }
        this.localStorage.save('selected_director', JSON.stringify(director));
    }

    getBusinessPrefix(businessType: string) {
        switch (businessType) {
            case 'BUSINESS_NAME':
                return 'BN';
            case 'INCORPORATED_TRUSTEES':
                return 'IT';
            case 'INCORPORATED_COMPANY_PRIVATE_A':
                return 'RC';
            case 'INCORPORATED_COMPANY_PRIVATE_B':
                return 'RC';
        }
    }

    getBusinessPrefixV2(businessType: string) {
        switch (businessType) {
            case KycBusinessType.BUSINESS_NAME:
                return BusinessPrefix.BN;
            case KycBusinessType.INCORPORATED_TRUSTEES:
                return BusinessPrefix.IT;
            case KycBusinessType.INCORPORATED_COMPANY_PRIVATE_A:
            case KycBusinessType.INCORPORATED_COMPANY_PRIVATE_B:
            case KycBusinessType.INCORPORATED_COMPANY:
                return BusinessPrefix.RC;
        }
    }

    removeBusinessNamePrefix(value) {
        if (!value) {
            return null;
        }
        value = value.replace(/ /g, '');
        return StringHelper.numbersOnly(value);
    }

    getSelectedDirector() {
        const director = this.localStorage.get('selected_director');
        if (StringHelper.isNullOrEmptyOrUndefined(director)) {
            return null;
        }
        return JSON.parse(director);
    }

    setEditMode(isEdit) {
        if (StringHelper.isNullOrEmptyOrUndefined(isEdit)) {
            this.localStorage.deleteValue(StorageKeys.isKycEditMode);
        }
        this.localStorage.save(StorageKeys.isKycEditMode, JSON.stringify(isEdit));
    }

    updateRegisteredBusinessDocuments(params): Promise<any> {
        const url = this.config.MONIEPOINT_ONBOARDING + `/api/v1/business-kycs/update-business-documents`;
        return this.apiClientHelper.newPutAsFormDataForPromise(url, params, true);
    }

    getBusinessNameDetails(id?): Promise<BusinessNameDetails> {
        const urlPath = id ? `/api/v1/business-name-details` + `?requestId=${id}` : `/api/v1/business-name-details`;
        const url = this.config.MONIEPOINT_ONBOARDING + urlPath;
        return this.apiClientHelper.getForPromise(url);
    }

    getMoniepointAgentId() {
        return this.localStorage.get(StorageKeys.moniepointAgentId) ?? this.getKycDataV2()?.agentId;
    }

    getAgentBusinessNameDetails(id): Promise<BusinessNameDetail> {
        const urlPath = `/api/v1/get-business-details/${id}`;
        const url = this.config.MONIEPOINT_ONBOARDING + urlPath;
        return this.apiClientHelper.getForPromise(url);
    }

    updateAgentBusinessName(params) {
        const urlPath = `/api/v1/update-business-details`;
        const url = this.config.MONIEPOINT_ONBOARDING + urlPath;
        return this.apiClientHelper.postForPromise(url, params);
    }

    updateBusinessNameDetails(params, id?): Promise<any> {
        const urlPath = id ? `/api/v1/attest-level-four` + `?requestId=${id}` : `/api/v1/attest-level-four`;
        const url = this.config.MONIEPOINT_ONBOARDING + urlPath;
        return this.apiClientHelper.postForPromise(url, params);
    }

    saveBusinessNameDetails(payload: BusinessNameDetails, id): Promise<BusinessNameDetails> {
        const urlPath = id ? `/api/v1/update-business-name-details` + `?requestId=${id}` : '/api/v1/update-business-name-details';
        const url = this.config.MONIEPOINT_ONBOARDING + urlPath;
        return this.apiClientHelper.putForPromise(url, payload);
    }

    saveBusinessNameDetailsCacFlow(payload: BusinessNameDetails, id: string): Promise<BusinessNameDetails> {
        const urlPath = `/api/v1/update-business-name-details?isDashboardFlow=true${id ? `&requestId=${id}` : ''}`;
        const url = this.config.MONIEPOINT_ONBOARDING + urlPath;
        return this.apiClientHelper.putForPromise(url, payload);
    }

    updateLevel5Rejection(params): Promise<any> {
        const url = this.config.MONIEPOINT_ONBOARDING + `/api/v2/business-kycs/registered-business/information`;
        return this.apiClientHelper.putForPromise(url, params);
    }

    updateLevel5RejectionViaBrm(params, id): Promise<any> {
        const url = this.config.MONIEPOINT_ONBOARDING + `/api/v2/business-kycs/registered-business/information?requestId=${id}`;
        return this.apiClientHelper.putForPromiseI(url, params);
    }

    getPhysicalAddress(): Promise<OnboardingAddress> {
        const url = this.config.MONIEPOINT_ONBOARDING + `/api/v1/physical-address-verification/onboarding-address`;
        return this.apiClientHelper.getForPromise(url);
    }

    getFaceVerificationStatus(): Promise<ApiResponse<FaceVerificationStatus>> {
        const url = this.config.MONIEPOINT_ONBOARDING + `/api/v1/kyc-level/3/face-verification-status`;
        return this.apiClientHelper.getForPromise(url);
    }

    updateFaceVerificationStatus(reference: string): Promise<ApiResponse<FaceVerificationStatusUpdate>> {
        const url = this.config.MONIEPOINT_ONBOARDING + `/api/v1/kyc-level/3/face-verification-status`;
        return this.apiClientHelper.putForPromise(url, { reference });
    }

    getBoPhysicalAddressAsBrm(agentManagerCode): Promise<OnboardingAddress> {
        const url =
            this.config.MONIEPOINT_ONBOARDING + `/api/v1/physical-address-verification/onboarding-address?agentManagerCode=${agentManagerCode}`;
        return this.apiClientHelper.getForPromise(url);
    }

    updateRegisteredBusinessDocumentsViaBrm(params, id): Promise<any> {
        const url = this.config.MONIEPOINT_ONBOARDING + `/api/v1/business-kycs/update-business-documents?requestId=${id}`;
        return this.apiClientHelper.newPutAsFormDataForPromise(url, params, true);
    }

    getBrmCurrentSteps(step, lvl: number) {
        const timeline = this.getKycTimelineByKycLevel(lvl);
        return timeline.find((x) => x?.step === step);
    }

    getBoCurrentSteps(step, lvl: number) {
        const timeline = this.getKycTimelineByKycLevel(lvl);
        return timeline.find((x) => x?.step === step);
    }

    navigateBrmKycForm(step: number, lvl: number) {
        this.setCurrentLvlStep({ step, lvl, isBrmBoOnboardingMode: true });
    }

    getFromKycHarmonizationValue() {
        const kyc = this.getKycDataV2();
        return kyc?.fromKycHarmonization ?? false;
    }

    getBrmCurrentTimeline(lvl: number) {
        return this.getKycTimelineByKycLevel(lvl);
    }

    getBoCurrentTimeline(lvl: number) {
        return this.getKycTimelineByKycLevel(lvl);
    }

    getBoKycLvl1FormParameters(key: string) {
        const formSteps = this.getBoCurrentTimeline(KYCLevel.LVL_1);
        const totalStep = formSteps?.length ?? 1;
        const kycLvl1Steps = this.getKycLvl1Step();
        const currentStep = formSteps.find((timeline) => timeline?.key === key)?.step;
        const currentFormStep = this.getBoCurrentSteps(currentStep, KYCLevel.LVL_1);
        this.updateStepper(formSteps, currentStep);
        return { totalStep, kycLvl1Steps, currentFormStep, formSteps };
    }

    getKycLvlStepFromFormKey(key: KYCFormKeys, level = KYCLevel.LVL_1) {
        const formSteps = this.getKycTimelineByKycLevel(level);
        const step = formSteps.find((timeline) => timeline?.key === key)?.step;
        return { step };
    }

    getBoKycLvl2FormParameters(key: string) {
        const totalStep = this.getKycLvl2TotalStep();
        const kycLvl2Steps = this.getKycLvl2Step();
        const formSteps = this.getBoCurrentTimeline(KYCLevel.LVL_2);
        const currentStep = formSteps.find((timeline) => timeline?.key === key)?.step;
        const currentFormStep = this.getBoCurrentSteps(currentStep, KYCLevel.LVL_2);
        this.updateStepper(formSteps, currentStep);
        return { totalStep, kycLvl2Steps, currentFormStep, formSteps };
    }

    updateStepper(timelines: TimelineModel[], currentStep, useKycData = true) {
        timelines.forEach((timeline) => {
            timeline.state = useKycData ? this.getStepperStatusV2(timeline, currentStep) : this.getTimelineStatus(timeline?.step, currentStep);
        });
    }

    updateKycTimelineWithKycData(timelines: TimelineModel[], formStep) {
        timelines.forEach((timeline) => {
            timeline.isStepCompleted = this.findKycFormStatusByKey(timeline?.key);
            timeline.state = timeline.isStepCompleted ? TimelineStatus.completed : this.getTimelineStatus(timeline?.step, formStep);
        });
    }

    findKycFormStatusByKey(key) {
        const kycData = this.getKycDataV2();
        return kycData ? this.getValueFromKeyPath(kycData, key?.split('.')) : false;
    }

    updateKycTimeline(kycLevel: KYCLevel, timelines: TimelineModel[], formStep) {
        this.updateKycTimelineWithKycData(timelines, formStep);
    }

    updateKycLevel2Timeline(timelines: TimelineModel[], formStep) {
        this.updateKycTimeline(KYCLevel.LVL_2, timelines, formStep);
        this.updateNinTimeline(timelines);
        this.updateBvnTimeline(timelines);
        this.updateIdVerificationTimeline(timelines);
    }

    updateKycLevel1Timeline(timelines: TimelineModel[], formStep) {
        this.updateKycTimeline(KYCLevel.LVL_1, timelines, formStep);
        this.updateBvnOrNinTimeline(timelines);
        this.updateFaceVerificationTimeline(timelines);
        this.updateKycHarmonizationUserTimeline(timelines);
        this.updateVerifiedIdentityTimelineDescription(timelines);
        this.updateNationalityTimeline(timelines);
    }

    updateVerifiedIdentityTimelineDescription(timelines: TimelineModel[]) {
        const verifiedIdentityTimeline = timelines.find((timeline) => timeline.key === this.BVN_NIN_VERIFIED_KEY);
        if (!verifiedIdentityTimeline) return;
        const isIdentityVerificationCompleted = this.ninVerificationCompleted() || this.bvnVerificationCompleted();
        verifiedIdentityTimeline.description = isIdentityVerificationCompleted ? this.getLivenessVerificationIdentitySource() : this.BVN_OR_NIN;
    }

    updateKycHarmonizationUserTimeline(timelines: TimelineModel[]) {
        const kycData = this.getKycDataV2();
        if (!kycData?.fromKycHarmonization) {
            return;
        }
        this.disableKycFormsForHarmonizationUser(timelines);
    }

    disableKycFormsForHarmonizationUser(timelines: TimelineModel[]) {
        timelines.forEach((timeline) => {
            const isBusinessInfoForm = timeline.key === KYCFormKeys.BUSINESS_INFORMATION;
            const isSignatureForm = timeline.key === KYCFormKeys.SIGNATURE_UPLOAD;
            if (isBusinessInfoForm || isSignatureForm) {
                timeline.disabled = true;
            }
        });
    }

    updateNinTimeline(timelines: TimelineModel[]) {
        const timeline = timelines.find((t) => t.key === KYCFormKeys.NIN_COMPLETED);
        if (!timeline) {
            return;
        }
        const hasCompletedNin = this.ninVerificationCompleted();
        timeline.isStepCompleted = hasCompletedNin;
        timeline.isStepInReview = !hasCompletedNin && this.hasSubmittedNinForm() && !this.ninVerificationFailed();
        timeline.state = this.getNinIdentityVerificationStatus()?.toLowerCase();
    }

    updateBvnOrNinTimeline(timelines: TimelineModel[]) {
        const timeline = timelines.find((t) => t.key === KYCFormKeys.BVN_NIN_VERIFIED);
        if (!timeline) {
            return;
        }
        timeline.isStepCompleted = this.ninVerificationCompleted() || this.bvnVerificationCompleted();
        timeline.state = this.getBvnIdentityVerificationStatus()?.toLowerCase() || this.getNinIdentityVerificationStatus()?.toLowerCase();
    }

    updateFaceVerificationTimeline(timelines: TimelineModel[]) {
        const timeline = timelines.find((t) => t.key === KYCFormKeys.FACE_VERIFICATION);
        if (!timeline) {
            return;
        }
        timeline.isStepCompleted = this.livelinessVerificationCompleted();
        timeline.state = this.getProviderLivelinessVerificationStatus()?.toLowerCase();
    }

    updateIdVerificationTimeline(timelines: TimelineModel[]) {
        const timeline = timelines.find((t) => t.key === KYCFormKeys.IDENTITY_VERIFICATION);
        if (!timeline) {
            return;
        }
        const hasCompletedIdVerification = this.hasCompletedIdVerification();
        timeline.isStepCompleted = hasCompletedIdVerification;
        timeline.isStepInReview = !hasCompletedIdVerification && this.hasVerifiedId();
        timeline.state = this.getProviderIdentityVerificationStatus()?.toLowerCase();
    }

    updateBvnTimeline(timelines: TimelineModel[]) {
        const timeline = timelines.find((t) => t.key === KYCFormKeys.BVN_COMPLETED);
        if (!timeline) {
            return;
        }
        const hasCompletedBvn = this.bvnVerificationCompleted();
        timeline.isStepCompleted = hasCompletedBvn;
        timeline.isStepInReview = !hasCompletedBvn && this.hasSubmittedBvnForm() && !this.bvnVerificationFailed();
        timeline.state = this.getBvnIdentityVerificationStatus()?.toLowerCase();
    }

    updateNationalityTimeline(timelines: TimelineModel[]) {
        const timeline = timelines.find((t) => t.key === KYCFormKeys.NATIONALITY);
        if (!timeline) return;

        timeline.description = NationalityTimeline.description;
        const isNigeria = this.hasSubmittedNationality() && !this.isNationalityNigeria();
        const useBvnNationality = this.isAggregatorRole() ? this.useBrmKycBvnNationality() : this.useKycBvnNationality();

        if (useBvnNationality && !this.isNinIdentitySource() && isNigeria) {
            timeline.description = 'Residence Permit';
        }
    }

    getStepperStatusV2(timeline: TimelineModel, currentStep) {
        if (timeline?.step === currentStep) {
            return TimelineStatus.active;
        }
        const kycData = this.getKycDataV2();

        const isCompleted = kycData ? this.getValueFromKeyPath(kycData, timeline?.key?.split('.')) : false;
        return isCompleted ? this.getUpdateStatue(timeline?.key, TimelineStatus.completed) : this.getTimelineStatus(timeline?.step, currentStep);
    }

    getValueFromKeyPath(kycData, keys: string[]) {
        return keys.reduce((accumulator, currentValue) => accumulator?.[currentValue] ?? null, kycData);
    }

    isNinOrBvnCompleted() {
        return this.bvnVerificationCompleted() || this.ninVerificationCompleted();
    }

    bvnVerificationCompleted() {
        return this.isSuccessStatus(this.getBvnIdentityVerificationStatus());
    }

    bvnVerificationFailed() {
        return this.getBvnIdentityVerificationStatus().toLowerCase() === TimelineStatus.FAILED.toLowerCase();
    }

    getBvnIdentityVerificationStatus() {
        const kycData = this.getKycDataV2();
        return kycData?.bvnIdentityVerificationStatus ?? TimelineStatus.PENDING;
    }

    ninVerificationCompleted() {
        const useKycNINFlow = this.isAggregatorRole() ? this.useKycNINFlow() : this.useBrmKycNINFlow();
        return useKycNINFlow && this.isSuccessStatus(this.getNinIdentityVerificationStatus());
    }

    ninVerificationFailed() {
        return this.getNinIdentityVerificationStatus().toLowerCase() === TimelineStatus.FAILED.toLowerCase();
    }

    getNinIdentityVerificationStatus() {
        const kycData = this.getKycDataV2();
        return kycData?.ninIdentityVerificationStatus;
    }

    getProviderLivelinessVerificationStatus() {
        const kycData = this.getKycDataV2();
        return kycData?.providerLivelinessVerificationStatus;
    }

    livelinessVerificationCompleted() {
        let isCompleted = this.isSuccessStatus(this.getProviderLivelinessVerificationStatus());
        const useKycNINFlow = this.isAggregatorRole() ? this.useBrmKycNINFlow() : this.useKycNINFlow();
        if (useKycNINFlow) {
            const hasCompletedNinOrBvn = this.ninVerificationCompleted() || this.bvnVerificationCompleted();
            isCompleted = isCompleted && hasCompletedNinOrBvn;
        } else {
            isCompleted = isCompleted && this.bvnVerificationCompleted();
        }
        return isCompleted;
    }

    isIdentityVerificationKey(key) {
        return this.isLivelinessKey(key) || this.isIdentityKey(key);
    }

    isLivelinessKey(key) {
        return key === KYCFormKeys.LIVELINESS;
    }

    isIdentityKey(key) {
        return key === KYCFormKeys.IDENTITY_VERIFICATION;
    }

    getUpdateStatue(key, status) {
        if (!this.isIdentityVerificationKey(key)) {
            return status;
        }
        if (!this.isNinOrBvnCompleted()) {
            return TimelineStatus.FAILED.toLowerCase();
        }
        return this.getKycVerificationStatus(key);
    }

    getKycVerificationStatus(key) {
        const kycData = this.getKycDataV2();
        return this.isLivelinessKey(key)
            ? this.getProviderVerificationStatus(kycData?.providerLivelinessVerificationStatus)
            : this.getProviderVerificationStatus(kycData?.providerIdentityVerificationStatus);
    }

    getProviderVerificationStatus(status) {
        switch (status) {
            case TimelineStatus.SUCCESS:
                return TimelineStatus.completed;
            case TimelineStatus.FAILED:
                return TimelineStatus.FAILED.toLowerCase();
            default:
                return TimelineStatus.processing;
        }
    }

    getTimelineStatus(step, currentStep) {
        let status = TimelineStatus.inactive;
        status = step < currentStep ? TimelineStatus.completed : status;
        status = step === currentStep ? TimelineStatus.active : status;
        return status;
    }

    getBrmKycTotalSteps(lvl: number) {
        const brmOption = this.getBoPresentInBrmOnboarding();
        switch (lvl) {
            case KYCLevel.LVL_1:
                return this.getBrmKycLvl1TotalStep(brmOption);
            case KYCLevel.LVL_2:
                return this.getBrmKycLvl2TotalStep(brmOption);
            default:
            // add more
        }
    }

    getBrmKycLvl1TotalStep(brmOption: boolean) {
        const useEnhancedLvl1FLow = this.useEnhancedKycLvl1Flow();
        if (brmOption) {
            return this.isBranchBrm ? TotalStepWBOBBRM : TotalStepWBO;
        } else {
            return useEnhancedLvl1FLow ? TotalStepWBOV2 : TotalStepWOBO;
        }
    }

    getBrmKycLvl2TotalStep(brmOption: boolean) {
        if (brmOption) {
            return TotalStepWBOKycLvl2;
        }
        return this.useSimplifiedKycLevel2Flow() ? TotalStepWOBOKycLvl2V2 : TotalStepWOBOKycLvl2;
    }

    setSavedRegisteredBusinessDocument(data) {
        if (!data) {
            this.localStorage.deleteValue('REGISTER_BUSINESS_DOCUMENT');
            return;
        }
        this.localStorage.save('REGISTER_BUSINESS_DOCUMENT', JSON.stringify(data));
    }

    getSavedRegisteredBusinessDocument() {
        const savedData = this.localStorage.get('REGISTER_BUSINESS_DOCUMENT');
        if (!savedData) {
            return null;
        }
        return JSON.parse(savedData);
    }

    getBusinessAffiliate(): Promise<any> {
        const url = this.config.MONIEPOINT_ONBOARDING + `/api/v1/business-kycs/business-affiliate/all`;
        return this.apiClientHelper.getForPromise(url);
    }

    getBusinessAffiliateV2(id): Promise<any> {
        const url = this.config.MONIEPOINT_ONBOARDING + `/api/v1/business-kycs/business-affiliate/all?requestId=${id}`;
        return this.apiClientHelper.getForPromise(url);
    }

    getBusinesses(params): Promise<OwnerBusinessesModel> {
        const urlString = StringHelper.toUrlString(params);
        const url = `${this.config.MONIEPOINT_DASHBOARD}/api/v2/businesses?${urlString}`;
        return this.apiClientHelper.getForPromise(url);
    }

    isEditMode() {
        const isEditMode = this.localStorage.get(StorageKeys.isKycEditMode);
        if (StringHelper.isNullOrEmptyOrUndefined(isEditMode)) {
            return false;
        }
        return JSON.parse(isEditMode);
    }

    setBusinessCreationResponse(res) {
        if (!res) {
            this.localStorage.deleteValue(StorageKeys.business_creation_response);
            return;
        }
        const savedResponse: any = this.getBusinessCreationResponse();
        if (savedResponse) {
            savedResponse.businessAccountNumber = res?.businessAccountNumber || savedResponse?.businessAccountNumber;
            savedResponse.businessAccountName = res?.businessAccountName || savedResponse?.businessAccountName;
            savedResponse.agentId = res?.agentId || savedResponse?.agentId;
            savedResponse.completedLvl = res?.completedLvl || savedResponse?.completedLvl;
            res = { ...savedResponse };
        }
        this.localStorage.save(StorageKeys.business_creation_response, JSON.stringify(res));
    }

    getBusinessCreationResponse() {
        const res = this.localStorage.get(StorageKeys.business_creation_response);
        return res ? JSON.parse(res) : null;
    }

    getBoAccountInformation(): Promise<any> {
        const url = this.config.MONIEPOINT_ONBOARDING + `/api/v1/account/information`;
        return this.apiClientHelper.getForPromise(url);
    }

    getBoAccountInformationV2(id): Promise<any> {
        const url = this.config.MONIEPOINT_ONBOARDING + `/api/v1/account/information?requestId=${id}`;
        return this.apiClientHelper.getForPromise(url);
    }

    submitAutoAddressApproval(payload: any, requestId: number, proofOfAddressType: KYC_DOCUMENT_TYPE): Promise<any> {
        if (payload) payload.shouldGenerateProofOfAddress = true;
        const url =
            this.config.MONIEPOINT_ONBOARDING + `/api/v3/business-owner-onboarding/level-3/upload-file/${proofOfAddressType}?requestId=${requestId}`;
        return this.apiClientHelper.newPutAsFormDataForPromise(url, payload);
    }

    updateBusinessOwnerProofOfAddressV2(addressType, formData): Promise<any> {
        const url = this.config.MONIEPOINT_ONBOARDING + `/api/v1/business-kycs/proof-of-address/${addressType}`;
        return this.apiClientHelper.newPutAsFormDataForPromise(url, formData);
    }

    updateBusinessOwnerProofOfAddressV4(uploadType, formData, id): Promise<any> {
        const url = this.config.MONIEPOINT_ONBOARDING + `/api/v2/business-owner-onboarding/level-3/upload-file/${uploadType}?requestId=${id}`;
        return this.apiClientHelper.newPutAsFormDataForPromise(url, formData);
    }

    updateBusinessOwnerProofOfAddressV3(addressType, formData): Promise<any> {
        const url = this.config.MONIEPOINT_ONBOARDING + `/api/v1/business-kycs/address-information/${addressType}`;
        return this.apiClientHelper.newPutAsFormDataForPromise(url, formData);
    }

    updateBusinessOwnerProofOfAddressV5(addressType, formData, id): Promise<any> {
        const url = this.config.MONIEPOINT_ONBOARDING + `/api/v1/business-kycs/address-information/${addressType}?requestId=${id}`;
        return this.apiClientHelper.newPutAsFormDataForPromise(url, formData);
    }

    updateBusinessOwnerProofOfAddressLvl3(addressType, formData): Promise<any> {
        const url = `${this.config.MONIEPOINT_ONBOARDING}/api/v2/business-owner-onboarding/level-3/upload-file/${addressType}`;
        return this.apiClientHelper.newPutAsFormDataForPromise(url, formData);
    }

    updateBusinessOwnerProofOfAddressLvl3Brm(addressType, formData, id): Promise<any> {
        const url = `${this.config.MONIEPOINT_ONBOARDING}/api/v2/business-owner-onboarding/level-3/upload-file/${addressType}?requestId=${id}`;
        return this.apiClientHelper.newPutAsFormDataForPromise(url, formData);
    }

    getIndemnity(): Promise<any> {
        const url = this.config.MONIEPOINT_ONBOARDING + `/api/v2/business-kycs/indemnity`;
        return this.apiClientHelper.getForPromise(url);
    }

    getIndemnityV2(id): Promise<any> {
        const url = this.config.MONIEPOINT_ONBOARDING + `/api/v2/business-kycs/indemnity?requestId=${id}`;
        return this.apiClientHelper.getForPromise(url);
    }

    approveIndemnityV2(): Promise<any> {
        const url = this.config.MONIEPOINT_ONBOARDING + `/api/v2/business-kycs/new-kyc-flow/indemnity`;
        return this.apiClientHelper.postForPromise(url, { indemnityAccepted: true });
    }

    verifyImageFromSmileIdVendor(payload: SmileIdPayload, id?): Promise<any> {
        const urlPath = id ? `/api/v1/smile/submit-job` + `?requestId=${id}` : `/api/v1/smile/submit-job`;
        const url = this.config.MONIEPOINT_ONBOARDING + urlPath;
        return this.apiClientHelper.postForPromise(url, payload);
    }

    setBusinessTypeDisplayName(name) {
        this.localStorage.save(StorageKeys.Business_Type_Display_Name, name);
    }

    getBusinessTypeDisplayName() {
        return this.localStorage.get(StorageKeys.Business_Type_Display_Name);
    }

    setBusinessFormQuestionnaire(questionnaire: BusinessQuestionnaire[]) {
        this.localStorage.save(StorageKeys.business_form_questionnaire, JSON.stringify(questionnaire));
    }

    getBusinessFormQuestionnaire(): any[] {
        const questionnaire = this.localStorage.get(StorageKeys.business_form_questionnaire);
        return questionnaire ? JSON.parse(questionnaire) : [];
    }

    async getBusinessFormQuestionnaireV2() {
        const questionnaires = this.getBusinessFormQuestionnaire();
        if (!questionnaires || !questionnaires.length) {
            const kycData = this.getKycDataV2();
            const businessTypes = await this.getRegisteredBusinessTypesV2();
            const businessType = kycData?.businessKycInformation?.registeredBusinessType || 'BUSINESS_NAME';
            const selectedBusinessType = businessTypes.find((x) => x.businessType === businessType);

            const businessQuestionnaire: BusinessQuestionnaire = { businessType, fields: selectedBusinessType.fields };
            let businessQuestionnaires: BusinessQuestionnaire[] = [];
            businessQuestionnaires.push(businessQuestionnaire);
            businessQuestionnaires = this.getSelectedBusinessTypeQuestionnaire(businessType, businessQuestionnaires, businessTypes);

            this.setBusinessFormQuestionnaire(businessQuestionnaires);

            return businessQuestionnaires;
        }

        return questionnaires;
    }

    launchErrorModal(params: any) {
        this.logMixpanelErrorEvent(params);
        const config = new ModalOptionsConfig();
        this.updateModalOptions(config, params);
        this.runningModal = this.modalService.alert(config);
    }

    setBusinessNamesViaKycData() {
        try {
            const savedBusinessNameDetails = this.getKycDataV2()?.businessNameDetails;
            const refineBusinessNames = savedBusinessNameDetails?.replace('/', '');
            const businessNameDetails = JSON.parse(refineBusinessNames);
            return businessNameDetails?.businessNameDetails;
        } catch (error) {
            return [];
        }
    }

    updateModalOptions(config: ModalOptionsConfig, params: any) {
        config.nzComponentParams.alertType = params?.alertType || 'error';
        config.nzComponentParams.title = params?.title || 'Request failed';
        config.className = DEFAULT_MODAL_KAMONA_CLASSES;
        config.nzWidth = DEFAULT_MODAL_WIDTH;
        if (params?.cancelName) {
            config.nzComponentParams.cancelName = params?.cancelName;
        }
        config.nzComponentParams.designType = MONIEPOINT_DESIGN_TYPE.KAMONA;
        config.nzComponentParams.callbackName = params?.callbackName || 'Close';
        config.nzComponentParams.message = params?.description;
    }

    getKycLevel4AttestationModalConfig(businessNameType = 'Business', callbackName = 'Proceed'): ModalOptionsConfig {
        const title = `${businessNameType} Name Updated successfully`;
        const description = `Your ${businessNameType} name change may experience delays in reflecting on other banks when your customers try to make payments`;
        const config = new ModalOptionsConfig();
        this.updateModalOptions(config, { alertType: 'success', title, callbackName, description });
        return config;
    }

    launchErrorModalV2(params: any): Promise<any> {
        return new Promise((resolve) => {
            this.logMixpanelErrorEvent(params);
            const config = new ModalOptionsConfig();
            this.updateModalOptions(config, params);
            config.nzComponentParams.callback = (result: any) => {
                resolve(result);
            };
            this.runningModal = this.modalService.alert(config);
        });
    }

    launchModal(params: any): Promise<any> {
        return new Promise((resolve) => {
            const config = new ModalOptionsConfig();
            this.updateModalOptions(config, params);
            config.nzComponentParams.callback = (result) => {
                resolve({ result, resolved: true });
            };
            if (params?.cancelName) {
                config.nzComponentParams.cancelCallback = (result) => {
                    resolve({ result, resolved: false });
                };
            }
            this.runningModal = this.modalService.alert(config);
        });
    }

    closeModal() {
        this.modalService.closeAll();
    }

    getSignupData() {
        const saveData = this.localStorage.get(StorageKeys.new_sign_up_data);
        return saveData ? JSON.parse(saveData) : null;
    }

    setSignupData(data: any) {
        this.localStorage.save(StorageKeys.new_sign_up_data, JSON.stringify(data));
    }

    clearSignupData() {
        this.localStorage.deleteValue(StorageKeys.new_sign_up_data);
    }

    getSoftOnboardingContactData() {
        const saveData = this.localStorage.get(StorageKeys.soft_onboarding_contact_data);
        return saveData ? JSON.parse(saveData) : null;
    }

    setSoftOnboardingContactData(data: any) {
        this.localStorage.save(StorageKeys.soft_onboarding_contact_data, JSON.stringify(data));
    }

    clearSoftOnboardingContactData() {
        this.localStorage.deleteValue(StorageKeys.soft_onboarding_contact_data);
    }

    prefillSignupStore(deviceInformation: DeviceRegistrationRequest) {
        const signupData = this.getSignupData();
        return this.fillSignupStore(signupData, deviceInformation);
    }

    updateDashboardBusinessInfo(kycData: any) {
        if (kycData) {
            if (kycData?.businessKycInformation?.businessName) {
                this.localStorage.save(StorageKeys.businessName, kycData?.businessKycInformation?.businessName);
            }

            if (kycData?.businessKycInformation?.businessType) {
                this.localStorage.save(StorageKeys.business_type, kycData?.businessKycInformation?.businessType);
            }
        }
    }

    launchRestartModal(params) {
        const config = new ModalOptionsConfig();
        config.nzComponentParams.alertType = 'error';
        config.nzComponentParams.title = 'Restart process';
        config.className = DEFAULT_MODAL_KAMONA_CLASSES;
        config.nzWidth = DEFAULT_MODAL_WIDTH;
        config.nzComponentParams.callback = () => {
            this.resetForm();
        };
        config.nzComponentParams.designType = MONIEPOINT_DESIGN_TYPE.KAMONA;
        config.nzComponentParams.callbackName = 'Restart';
        config.nzComponentParams.message = params?.description;
        this.runningModal = this.modalService.alert(config);
    }

    isProcessTooLong(error) {
        const isProcessLong = error?.error?.responseCode === ErrorCode.PROCESS_TOO_LONG;
        const isProcessLongText = StringHelper.getErrorMessageHttpErrorResponse(error) === this.PROCESS_TOO_LONG_TEXT;
        return isProcessLong || isProcessLongText;
    }

    fillSignupStore(signupData, deviceInformation: DeviceRegistrationRequest) {
        const initialData = this.getPrebuildSignupData(deviceInformation);
        const validationKey = signupData?.validationKey || '';
        const emailAddress = signupData?.emailAddress || '';
        const phoneNumber = signupData?.phoneNumber || '';
        const bvn = signupData?.bvn || '';
        const dateOfBirth = signupData?.dateOfBirth || '';
        const data = {
            ...initialData,
            validationKey,
            emailAddress,
            phoneNumber,
            bvn,
            dateOfBirth,
        };
        return this.setSignupData(data);
    }

    getPrebuildSignupData(deviceInformation: DeviceRegistrationRequest) {
        return {
            manufacturer: deviceInformation?.manufacturer,
            deviceUniqueIdentifier: deviceInformation?.deviceUniqueIdentifier,
            model: deviceInformation?.model,
            deviceType: deviceInformation?.model?.toUpperCase(),
        };
    }

    routeToKycLevel(kycLevelLevel: KYCLevel) {
        const isBrm = this.isAggregatorRole();
        const route = isBrm ? this.getBrmKycLevelRoute(kycLevelLevel) : this.getBoKycLevelRoute(kycLevelLevel);
        this.routeToPage(`${route}`).finally(() => {
            console.log(`routed to ${route}`);
        });
    }

    getBrmKycLevelRoute(kycLevel: KYCLevel) {
        return KYCLevelRoutes.find((x) => x.level === kycLevel)?.brmRoute;
    }

    getBoKycLevelRoute(kycLevel: KYCLevel) {
        return KYCLevelRoutes.find((x) => x.level === kycLevel)?.route;
    }

    routeToKycPrimer(kYCLevel: KYCLevel) {
        const route = KYCPrimerRoutes.find((x) => x.level === kYCLevel)?.route;
        this.router.navigateByUrl(`${route}`);
    }

    async getMetaMapReference(params = MetaMapType.IDENTITY, identityProvider = IdentityProvider.METAMAP): Promise<any> {
        const deviceInformation = this.deviceHelper.getDeviceInformation();
        const customHeaders = await this.addCustomGeoHeaders();
        const url =
            this.config.MONIEPOINT_ONBOARDING +
            `/api/v1/business-kycs/identity/start?verificationType=${params}&verificationProvider=${identityProvider}&deviceIdentifier=${deviceInformation?.deviceUniqueIdentifier}`;
        return this.apiClientHelper.postForPromise(url, {}, true, false, true, 'WEB', customHeaders);
    }

    async getMetaMapReferenceV2(pendingRequestId, verificationType = MetaMapType.IDENTITY, identityProvider = IdentityProvider.METAMAP): Promise<any> {
        const deviceInformation = this.deviceHelper.getDeviceInformation();
        const customHeaders = await this.addCustomGeoHeaders();
        const url =
            this.config.MONIEPOINT_ONBOARDING +
            `/api/v1/identity/start?verificationType=${verificationType}&requestId=${pendingRequestId}&verificationProvider=${identityProvider}&deviceIdentifier=${deviceInformation?.deviceUniqueIdentifier}`;
        return this.apiClientHelper.postForPromise(url, {}, true, false, true, 'WEB', customHeaders);
    }

    updateNextOfKinV2(payload): Promise<any> {
        const url = this.config.MONIEPOINT_ONBOARDING + `/api/v1/business-kycs/next-of-kin`;
        return this.apiClientHelper.putForPromiseI(url, payload);
    }

    updateNextOfKinV3(payload): Promise<any> {
        const url = this.config.MONIEPOINT_ONBOARDING + `/api/v2/business-owner-onboarding/level-2/next-of-kin`;
        return this.apiClientHelper.putForPromiseI(url, payload);
    }

    submitNextOfKinV4(payload): Promise<any> {
        const isBrm = this.isAggregatorRole();
        const url =
            this.config.MONIEPOINT_ONBOARDING + `/api/v1/kyc-upgrade/submit/next-of-kin${isBrm ? '?requestId=' + this.getKycRequestId() : ''}`;
        return this.apiClientHelper.postForPromise(url, payload);
    }

    getVerificationIdFlowId() {
        return this.config.META_MAP_FLOW_ID;
    }

    getLivelinessFlowId() {
        return this.config.META_MAP_LOW_LEVEL_ACCOUNT_FLOW_ID;
    }

    handleIncompleteVerification(data?: any, desc?: string) {
        const title = data?.title || 'Verification Incomplete';
        const description = desc || data?.title || 'Meta map verification was not completed.' + ' Please try again';
        const alertType = 'warning';
        const callbackName = data.callbackName || 'Retry Verification';
        this.launchErrorModal({ title, description, alertType, callbackName });
    }

    getLivelinessPersonalFlowId() {
        return this.config.META_MAP_PERSONAL_INFO_FLOW_ID;
    }

    getIdVerificationFlowId() {
        return this.config.META_MAP_FLOW_ID;
    }

    getKycRequestId() {
        const kycData = this.getKycDataV2();
        return kycData?.id;
    }

    getIdVerificationFlowIdV2() {
        const flowId = this.localStorage.get('id_verification_flow_id_v2');
        if (StringHelper.isNullOrEmptyOrUndefined(flowId)) {
            this.getIdVerificationFlowId();
        }
        return flowId;
    }

    saveIdVerificationFlowIdV2(id) {
        if (StringHelper.isNullOrEmptyOrUndefined(id)) {
            this.localStorage.deleteValue('id_verification_flow_id_v2');
            return;
        }
        this.localStorage.save('id_verification_flow_id_v2', id);
    }

    saveMetaMapReference(reference: string) {
        if (StringHelper.isNullOrEmptyOrUndefined(reference)) {
            this.localStorage.deleteValue('META_MAP_REF');
            return;
        }
        this.localStorage.save('META_MAP_REF', reference);
    }

    saveUserPhotoLink(url: string) {
        if (StringHelper.isNullOrEmptyOrUndefined(url)) {
            this.localStorage.deleteValue('User_Photo_Link');
            return;
        }
        this.localStorage.save('User_Photo_Link', url);
    }

    saveUserPhotoLinkHash(hash: string) {
        if (StringHelper.isNullOrEmptyOrUndefined(hash)) {
            this.localStorage.deleteValue('User_Photo_Link_Hash');
            return;
        }
        this.localStorage.save('User_Photo_Link_Hash', hash);
    }

    getSavedUserPhotoLinkHash() {
        return this.localStorage.get('User_Photo_Link_Hash');
    }

    getSavedUserPhotoLink() {
        return this.localStorage.get('User_Photo_Link');
    }

    getSavedMetaMapReference() {
        return this.localStorage.get('META_MAP_REF');
    }

    getSignupResponse() {
        const res = this.localStorage.get('sign_up_Response');
        if (!res) {
            return null;
        }
        return JSON.parse(res);
    }

    setSignupResponse(response) {
        if (!response) {
            this.localStorage.deleteValue('sign_up_Response');
            return;
        }
        return this.localStorage.save('sign_up_Response', JSON.stringify(response));
    }

    getBvnDateOfBirth() {
        return this.bvnDateOfBirth;
    }

    resetForm() {
        this.navigateSignupForm(SignupFormStep.CONTACT_DETAILS);
    }

    setBvn(bvn: string) {
        this.bvn = bvn;
    }

    generateOTP(data): Promise<any> {
        return this.onboardingService.generateOTP(data);
    }

    generateSoftOnboardingOTP(data): Promise<any> {
        const url = this.config.MONIEPOINT_ONBOARDING + `/api/v1/onboarding/generate-otp`;
        return this.apiClientHelper.postForPromise(url, data, false);
    }

    onboardUserV2(data, clientType): Promise<any> {
        return this.onboardingService.onboardUserV2(data, clientType);
    }

    handleOtpSuspension(error) {
        const suspensionReleaseTime = error?.error?.suspensionReleaseTime;
        const description = StringHelper.getErrorMessageHttpErrorResponse(error);
        const time = new Date(`${suspensionReleaseTime}`).getTime();
        this.alertService.setOTPSuspensionTimer(`${time}`);
        this.alertService.setRoute(`/onboarding-v2`);
        this.alertService.setModalMessage(description);
        this.router.navigateByUrl('/onboarding-v2/failed-otp-modal');
    }

    isSuspended(error: any) {
        return error?.error?.code === ErrorCode.OTP_SUSPENSION || error?.error?.code === ErrorCode.OTP_SUSPENSION_V2;
    }

    isProcessToolong(error: any) {
        return error?.error?.code === ErrorCode.PROCESS_TOO_LONG_V3 || error?.error?.code === ErrorCode.PROCESS_TOO_LONG_V3;
    }

    profileFound(error: any) {
        return error?.error?.code === ErrorCode.PROFILE_FOUND || error?.error?.responseCode === ErrorCode.PROFILE_FOUND;
    }

    setCurrentOnBoardingStep(step) {
        if (step === null) {
            this.localStorage.deleteValue(StorageKeys.current_on_boarding_step);
            return;
        }
        this.localStorage.save(StorageKeys.current_on_boarding_step, `${step}`);
    }

    getCurrentOnBoardingStep() {
        const currentStep = this.localStorage.get(StorageKeys.current_on_boarding_step);
        if (currentStep && !this.shouldUseNewBvnFlow()) {
            return currentStep && Number(currentStep) === SignupFormStep.PROFILE_CREATION_AFTER_NIBSS_VERIFICATION
                ? SignupFormStep.PROFILE_CREATION_AFTER_NIBSS_VERIFICATION
                : Index.ZERO;
        }
        return JSON.parse(currentStep);
    }

    routeToSoftOnBoarding() {
        this.router.navigateByUrl(SOFT_ONBOARDING_ROUTE);
    }

    routeToSoftOnBoardingSplashScreen() {
        this.router.navigateByUrl(SOFT_ONBOARDING_SPLASH_SCREEN_ROUTE);
    }

    setCurrentSoftOnBoardingStep(step) {
        if (step === null) {
            this.localStorage.deleteValue(StorageKeys.current_soft_on_boarding_step);
            return;
        }
        this.localStorage.save(StorageKeys.current_soft_on_boarding_step, `${step}`);
    }

    getCurrentSoftOnBoardingStep() {
        const currentStep = this.localStorage.get(StorageKeys.current_soft_on_boarding_step);
        if (!currentStep) {
            return Index.ZERO;
        }
        return JSON.parse(currentStep);
    }

    setCurrentKycLvl1Step(step) {
        if (StringHelper.isNullOrEmptyOrUndefined(step)) {
            this.localStorage.deleteValue(StorageKeys.current_kyc_lvl1_step);
            return;
        }
        this.localStorage.save(StorageKeys.current_kyc_lvl1_step, `${step}`);
    }

    getCurrentKycLvl1Step() {
        const currentStep = this.localStorage.get(StorageKeys.current_kyc_lvl1_step);
        if (StringHelper.isNullOrEmptyOrUndefined(currentStep)) {
            return this.DEFAULT_KYC_LVL_STEP;
        }
        return JSON.parse(currentStep);
    }

    setCurrentKycLvl2Step(step) {
        if (StringHelper.isNullOrEmptyOrUndefined(step)) {
            this.localStorage.deleteValue(StorageKeys.current_kyc_lvl_2_step);
            return;
        }
        this.localStorage.save(StorageKeys.current_kyc_lvl_2_step, `${step}`);
    }

    setCurrentKycStep(lvl: number) {
        const currentKycStep = this.getCurrentKycStep(lvl);
        switch (lvl) {
            case KYCLevel.LVL_1:
                this.setCurrentKycLvl1Step(currentKycStep);
                break;
            case KYCLevel.LVL_2:
                this.setCurrentKycLvl2Step(currentKycStep);
                break;
            case KYCLevel.LVL_3:
                this.setCurrentKycLvl3Step(currentKycStep);
                break;
            case KYCLevel.LVL_4:
                this.setCurrentKycLvl4Step(currentKycStep);
                break;
        }
    }

    getCurrentKycStep(lvl: number) {
        return this.getKycLvlStep(this.getKycTimelineByKycLevel(lvl));
    }

    getCurrentKycLvl2Step() {
        const currentStep = this.localStorage.get(StorageKeys.current_kyc_lvl_2_step);
        if (StringHelper.isNullOrEmptyOrUndefined(currentStep)) {
            return this.DEFAULT_KYC_LVL_STEP;
        }
        return JSON.parse(currentStep);
    }

    setCurrentKycLvl3Step(step) {
        if (StringHelper.isNullOrEmptyOrUndefined(step)) {
            this.localStorage.deleteValue(StorageKeys.current_kyc_lvl_3_step);
            return;
        }
        this.localStorage.save(StorageKeys.current_kyc_lvl_3_step, `${step}`);
    }

    getCurrentKycLvl3Step() {
        const currentStep = this.localStorage.get(StorageKeys.current_kyc_lvl_3_step);
        if (StringHelper.isNullOrEmptyOrUndefined(currentStep)) {
            return this.DEFAULT_KYC_LVL_STEP;
        }
        return JSON.parse(currentStep);
    }

    setCurrentKycLvl4Step(step) {
        if (StringHelper.isNullOrEmptyOrUndefined(step)) {
            this.localStorage.deleteValue(StorageKeys.current_kyc_lvl_4_step);
            return;
        }
        this.localStorage.save(StorageKeys.current_kyc_lvl_4_step, `${step}`);
    }

    getCurrentKycLvl4Step() {
        const currentStep = this.localStorage.get(StorageKeys.current_kyc_lvl_4_step);
        if (StringHelper.isNullOrEmptyOrUndefined(currentStep)) {
            return this.DEFAULT_KYC_LVL_STEP;
        }
        return JSON.parse(currentStep);
    }

    validateOTP(data): Promise<OtpResponse> {
        return this.onboardingService.validateOTP(data);
    }

    validateOTPV2(data): Promise<any> {
        const url = `https://onboarding.mab.development.moniepoint.com/api/v1/self-onboarding/verifications/phone-number/complete`;
        return this.apiClientHelper.postForPromise(url, data, false);
    }

    validateSoftOnboardingOTP(data): Promise<any> {
        const url = this.config.MONIEPOINT_ONBOARDING + `/api/v1/onboarding/validate-otp`;
        return this.apiClientHelper.postForPromise(url, data, false);
    }

    validateBVNV3(data, requestId = ''): Promise<any> {
        const urlPath = requestId
            ? `/api/v1/business-owner-onboarding/level-1/brm-onboarding/bvn/validation?requestId=${requestId}`
            : `/api/v1/business-owner-onboarding/level-1/brm-onboarding/bvn/validation`;
        const url = this.config.MONIEPOINT_ONBOARDING + urlPath;
        return this.apiClientHelper.postForPromise(url, data);
    }

    checkBvnExistence(bvn): Promise<BvnResponse> {
        const url = this.config.MONIEPOINT_ONBOARDING + `/api/v1/business-owner-onboarding/level-1/brm-onboarding/bvn/validation/exists`;
        return this.apiClientHelper.postForPromise(url, bvn);
    }

    sendNibssBvnLink(params): Promise<BvnResponse> {
        const url = this.config.MONIEPOINT_ONBOARDING + `/api/v2/business-owner-onboarding/level-1/brm-onboarding/bvn/validation`;
        return this.apiClientHelper.postForPromise(url, params);
    }

    setNibssBvnResponse(params) {
        if (StringHelper.isNullOrEmptyOrUndefined(params)) {
            this.localStorage.deleteValue('Nibss-bvn-response');
            return;
        }
        this.localStorage.save('Nibss-bvn-response', JSON.stringify(params));
    }

    getNibssBvnResponse(): BvnResponse {
        const res = this.localStorage.get('Nibss-bvn-response');
        const defaultResponse: BvnResponse = {
            reference: '',
        };
        if (StringHelper.isNullOrEmptyOrUndefined(res)) {
            return defaultResponse;
        }
        return JSON.parse(res);
    }

    validateBVNV4(bvnData): Promise<any> {
        if (this.validatedUserData && this.validatedUserData?.bvnData?.bvn === bvnData.bvn) {
            return Promise.resolve(this.validatedUserData);
        }
        const url = this.config.MONIEPOINT_ONBOARDING + `/api/v1/business-owner-onboarding/level-1/brm-onboarding/bvn/validation`;
        return this.apiClientHelper.postForPromise(url, bvnData).then((response) => {
            this.validatedUserData = { ...response, bvnData };
            return response;
        });
    }

    validateBVN(data): Promise<any> {
        return this.onboardingService.validateBVN(data);
    }

    validateUserName(data): Promise<any> {
        return this.onboardingService.validateUserName(data);
    }

    updateResidentialAddress(payload): Promise<any> {
        const url = this.config.MONIEPOINT_ONBOARDING + `/api/v1/business-kycs/personal-information`;
        return this.apiClientHelper.putForPromiseI(url, payload);
    }

    updateResidentialAddressViaBrm(payload, id): Promise<any> {
        const url = this.config.MONIEPOINT_ONBOARDING + `/api/v1/business-owner-onboarding/level-1/personal-information?requestId=${id}`;
        return this.apiClientHelper.putForPromiseI(url, payload);
    }

    updateBAHarmonizeUser(payload) {
        const url = this.config.MONIEPOINT_ONBOARDING + `/api/v1/business-owner-onboarding/level-1/business-address`;
        return this.apiClientHelper.putForPromiseI(url, payload);
    }

    updateBAHarmonizeUserViaBrm(payload, id) {
        const url = this.config.MONIEPOINT_ONBOARDING + `/api/v1/business-owner-onboarding/level-1/business-address?requestId=${id}`;
        return this.apiClientHelper.putForPromiseI(url, payload);
    }

    updateBusinessInformation(payload: UpdateBusinessInformation): Promise<any> {
        const url = this.config.MONIEPOINT_ONBOARDING + `/api/v1/business-kycs/business-details`;
        return this.apiClientHelper.putForPromiseI(url, payload);
    }

    savePassportViaBrm(payload, id): Promise<any> {
        const url = this.config.MONIEPOINT_ONBOARDING + `/api/v1/business-owner-onboarding/level-1/passport?requestId=${id}`;
        return this.apiClientHelper.postForPromise(url, payload);
    }

    savePassportViaBrmV2(payload, id): Promise<any> {
        const url = this.config.MONIEPOINT_ONBOARDING + `/api/v2/business-owner-onboarding/level-1/passport?requestId=${id}`;
        return this.apiClientHelper.postForPromise(url, payload);
    }

    updateBusinessInformationViaBrm(payload, id): Promise<any> {
        const url = this.config.MONIEPOINT_ONBOARDING + `/api/v1/business-owner-onboarding/level-1/business-details?requestId=${id}`;
        return this.apiClientHelper.putForPromiseI(url, payload);
    }

    updateLvl4BusinessInformation(payload): Promise<any> {
        this.updateBusinessInformationPayload(payload);
        const url = this.config.MONIEPOINT_ONBOARDING + `/api/v2/business-kycs/business-details/registered`;
        return this.apiClientHelper.putForPromiseI(url, payload);
    }

    updateLvl4BusinessInformationViaBrm(payload, id): Promise<any> {
        this.updateBusinessInformationPayload(payload);
        const url = this.config.MONIEPOINT_ONBOARDING + `/api/v1/business-owner-onboarding/level-4/business-details/registered?requestId=${id}`;
        return this.apiClientHelper.putForPromiseI(url, payload);
    }

    updateBusinessInformationPayload(payload) {
        if (this.canUseBusinessNameChange() && payload) {
            payload.levelFourAccountNameFlow = true;
        }
    }

    handleFailedRequest(error: any) {
        const description = StringHelper.getErrorMessageHttpErrorResponse(error);
        this.launchErrorModal({ description });
    }

    finalOnboarding(params) {
        const url = this.config.MONIEPOINT_ONBOARDING + `/api/v2/self-onboarding/steps/complete-business-owner-onboarding`;
        return this.apiClientHelper.postForPromise(url, params);
    }

    finalOnboardingV2(params, id) {
        const url = this.config.MONIEPOINT_ONBOARDING + `/api/v2/self-onboarding/steps/complete-business-owner-onboarding?requestId=${id}`;
        return this.apiClientHelper.postForPromise(url, params);
    }

    updateBoContactInformation(payload, id): Promise<any> {
        const url = this.config.MONIEPOINT_ONBOARDING + `/api/v1/business-owner-onboarding/level-1/contact-details?requestId=${id}`;
        return this.apiClientHelper.postForPromise(url, payload);
    }

    updateBoNextOfKin(payload, id): Promise<any> {
        const url = this.config.MONIEPOINT_ONBOARDING + `/api/v1/business-owner-onboarding/level-2/next-of-kin?requestId=${id}`;
        return this.apiClientHelper.putForPromiseI(url, payload);
    }

    updateBoNextOfKinViaBrm(payload, id): Promise<any> {
        const url = `${this.config.MONIEPOINT_ONBOARDING}/api/v2/business-owner-onboarding/level-2/next-of-kin?requestId=${id}`;
        return this.apiClientHelper.putForPromiseI(url, payload);
    }

    uploadDocument(documentType, params, contentType): Promise<any> {
        const url = this.config.MONIEPOINT_ONBOARDING + `/api/v1/business-kycs/upload-file/${documentType}?contentType=${contentType}`;
        return this.apiClientHelper.newPutAsFormDataForPromise(url, params);
    }

    uploadDocumentV3({ documentType, file, contentType, id }): Promise<any> {
        const url =
            this.config.MONIEPOINT_ONBOARDING + `/api/v1/business-kycs/upload-file/${documentType}?contentType=${contentType}&requestId=${id}`;
        return this.apiClientHelper.newPutAsFormDataForPromise(url, file);
    }

    harmonizeUser(id): Promise<any> {
        const url = this.config.MONIEPOINT_ONBOARDING + `/api/v1/business-owner-onboarding/level-1/complete?requestId=${id}`;
        return this.apiClientHelper.postForPromise(url, {});
    }

    harmonizeUserV2(): Promise<any> {
        const url = this.config.MONIEPOINT_ONBOARDING + `/api/v1/business-owner-onboarding/level-1/complete`;
        return this.apiClientHelper.postForPromise(url, {});
    }

    createTransactionPinV3(params) {
        const url = this.config.MONIEPOINT_ONBOARDING + `/api/v2/self-onboarding/set-user-pin`;
        return this.apiClientHelper.postForPromise(url, params);
    }

    validateBusinessName(params, requestId = ''): Promise<any> {
        const urlPath = requestId
            ? `/api/v1/uniqueness-validation/business-name?requestId=${requestId}`
            : `/api/v1/uniqueness-validation/business-name`;
        const url = this.config.MONIEPOINT_ONBOARDING + urlPath;
        return this.apiClientHelper.postForPromise(url, params);
    }

    saveKycDataFromAttestation(agentId, businessAccountName) {
        const kycData = this.getKycDataV2() ?? { businessKycInformation: null };
        const businessKycInformation = kycData?.businessKycInformation ?? { kycLevel: null };
        businessKycInformation.kycLevel = KYCLevel.LVL_1;
        businessKycInformation.businessAccountName = businessAccountName;
        kycData.businessKycInformation = businessKycInformation;
        kycData.agentId = agentId;
        kycData.has_uploaded_signature_file = true;
        this.setKycDataV2(kycData);
    }

    login() {
        this.router.navigateByUrl(this.LOGIN);
    }

    loginV2() {
        return this.router.navigateByUrl(this.LOGIN);
    }

    navigateKycLvl1Form(nextStep, isBrmBoOnboardingMode = false) {
        this.setCurrentKycLvl1Step(nextStep);
        this.kycLvl1FormObserver.next({ nextStep, isBrmBoOnboardingMode });
    }

    navigateKycLvl2Form(nextStep, isBrmBoOnboardingMode = false) {
        this.setCurrentKycLvl2Step(nextStep);
        this.kycLvl2FormObserver.next({ nextStep, isBrmBoOnboardingMode });
    }

    getBusinessPOAReference() {
        const businessKycInformation = this.getKycDataV2()?.businessKycInformation;
        return businessKycInformation.proofOfAddressReference;
    }

    getResidentialPOAReference() {
        const personalInformation = this.getKycDataV2()?.personalInformation;
        return personalInformation?.proofOfAddressReference;
    }

    updateBusinessAddressStatus() {
        const kycData = this.getKycDataV2();
        kycData[KYCFormKeys.BUSINESS_PROOF_OF_ADDRESS] = true;
        this.setKycDataV2(kycData);
    }

    updateResidentialAddressStatus() {
        const kycData = this.getKycDataV2();
        kycData[KYCFormKeys.PROOF_OF_ADDRESS] = true;
        this.setKycDataV2(kycData);
    }

    navigateKycLvl3Form(nextStep, isBrmBoOnboardingMode = false, sourceStep = null, metadata={}, allStepsDone = false) {
        this.setCurrentKycLvl3Step(nextStep);
        this.kycLvl3FormObserver.next({ nextStep, isBrmBoOnboardingMode, sourceStep, metadata, allStepsDone });
    }

    navigateKycLvl4Form(nextStep) {
        const isBrmBoOnboardingMode = this.isAggregatorRole();
        this.setCurrentKycLvl4Step(nextStep);
        this.kycLvl4FormObserver.next({ nextStep, isBrmBoOnboardingMode });
    }

    navigateSignupForm(nextForm) {
        this.setCurrentOnBoardingStep(nextForm);
        this.signupFormObserver.next(nextForm);
    }

    navigateSoftOnboardingForm(nextForm) {
        this.setCurrentSoftOnBoardingStep(nextForm);
        this.softOnboardingFormObserver.next(nextForm);
    }

    setOnboardingFormData(onboardingFormData: OnboardingFormData) {
        if (StringHelper.isNullOrEmptyOrUndefined(onboardingFormData)) {
            return this.localStorage.deleteValue(StorageKeys.on_boarding_form_data);
        }
        this.localStorage.save(StorageKeys.on_boarding_form_data, JSON.stringify(onboardingFormData));
    }

    setKycRegisteredBusinessDocumentStatus(params) {
        if (StringHelper.isNullOrEmptyOrUndefined(params)) {
            this.localStorage.deleteValue(StorageKeys.kycRegisteredBusinessDocumentStatus);
            return;
        }
        this.localStorage.save(StorageKeys.kycRegisteredBusinessDocumentStatus, JSON.stringify(params));
    }

    canUseSoftOnboarding() {
        return this.config.CAN_USE_SOFT_ONBOARDING;
    }

    getKycRegisteredBusinessDocumentStatus() {
        const params = this.localStorage.get(StorageKeys.kycRegisteredBusinessDocumentStatus);
        return params ? JSON.parse(params) : null;
    }

    getKYCDataV2() {
        const url = this.config.MONIEPOINT_ONBOARDING + `/api/v1/business-kycs`;
        return this.apiClientHelper.getForPromise(url);
    }

    activateAccount(params) {
        const url = this.config.MONIEPOINT_ONBOARDING + `/api/v1/account/activate`;
        return this.apiClientHelper.postForPromise(url, params);
    }

    getKYCDataV3(id) {
        const url = this.config.MONIEPOINT_ONBOARDING + `/api/v1/business-kycs?requestId=${id}`;
        return this.apiClientHelper.getForPromise(url);
    }

    getFailedKycSteps() {
        const lvl2: TimelineModel[] = this.getUpdatedKycLvl2Timeline().filter((x) => x.canBeRejected);
        const lvl3: TimelineModel[] = this.getUpdatedKycLvl3Timeline().filter((x) => x.canBeRejected);
        const lvl4: TimelineModel[] = FailedBusinessDetailsTimeline;
        const lvl5: TimelineModel[] = FailedSupportingDocumentTimeline;
        const result: any[] = [];
        result.push(this.setFailedKycSteps(lvl2, KYCLevel.LVL_2));
        result.push(this.setFailedKycSteps(lvl3, KYCLevel.LVL_3));
        result.push(this.setFailedKycSteps(lvl4, KYCLevel.LVL_4));
        result.push(this.setFailedKycSteps(lvl5, KYCLevel.LVL_5));
        return result.filter((x) => x.timeline.length);
    }

    routeToDashboardV2(): Promise<any> {
        return new Promise(async (resolve, reject) => {
            const hasAccessedDashboard = this.hasAccessedDashboard();
            const isBrm = this.isAggregatorRole();
            if (hasAccessedDashboard || isBrm) {
                this.routeToBODashboard();
                resolve(true);
                return;
            }
            const params: PagedRequest = new PagedRequest();
            params.pageSize = 100;
            let businesses;
            try {
                businesses = await this.getBusinesses(params);
                return this.handleBusinessResponse(businesses?.content);
            } catch (error) {
                reject(error);
            }
        });
    }

    continueToDashboard() {
        this.loginHelper.navigateUserAccordingly(true);
    }

    handleBusinessResponse(res: any[]): Promise<any> {
        return new Promise((resolve) => {
            const business = res[Index.ZERO];
            if (!business) {
                resolve(true);
                return;
            }
            const accessToken = this.localStorage.get(StorageKeys.token);
            const params = { access_token: accessToken };
            this.loginHelper.setUserRoles(params);
            this.saveBusinessDetails(business);
            this.continueToDashboard();
            resolve(true);
        });
    }

    saveBusinessDetails(res) {
        const hasNoBusiness = StringHelper.isNullOrEmptyOrUndefined(res);
        if (hasNoBusiness) {
            return;
        }
        this.localStorage.saveBusinessDetails(res);
    }

    setFailedKycSteps(timeline: any[], lvl) {
        const kycData = this.getKycDataV2();
        const kycLevelStatus = kycData?.kycLevelStatus;
        if (!kycLevelStatus) {
            return { lvl, timeline: [] };
        }
        const isRejected = kycLevelStatus[KYCLevelV2[lvl]] === KycLvlState.REJECTED;
        if (!isRejected) {
            return { lvl, timeline: [] };
        }
        return { lvl, timeline };
    }

    getKycFormsForReview(isBrm = true) {
        const result: any[] = [];
        result.push(this.setProcessingKycSteps(this.getLvl2ReviewForms(), KYCLevel.LVL_2, 'assets/images/svgs/kyc-lvl2-primer-icon.svg'));
        result.push(this.setProcessingKycSteps(this.getLvl3ReviewForms(isBrm), KYCLevel.LVL_3, 'assets/images/svgs/kyc-lvl3-primer-icon.svg'));
        result.push(this.setProcessingKycSteps(this.getLvl4ReviewForms(isBrm), KYCLevel.LVL_4, 'assets/images/svgs/kyc-lvl4-primer-icon.svg'));
        result.push(
            this.setProcessingKycSteps(
                this.getLvl5DocumentForms(isBrm, KycLvlState.PENDING),
                KYCLevel.LVL_5,
                'assets/images/svgs/kyc-lvl5-primer-icon.svg',
            ),
        );
        return result.filter((x) => x.timeline?.length);
    }

    getKycFormsForRejection(isBrm = true) {
        const result: any[] = [];
        result.push(this.setRejectedKycSteps(this.getLvl2RejectionForms(isBrm), KYCLevel.LVL_2, 'assets/images/svgs/kyc-lvl2-primer-icon.svg'));
        result.push(this.setRejectedKycSteps(this.getLvl3RejectionForms(isBrm), KYCLevel.LVL_3, 'assets/images/svgs/kyc-lvl3-primer-icon.svg'));
        result.push(this.setRejectedKycSteps(this.getLvl4RejectionForms(isBrm), KYCLevel.LVL_4, 'assets/images/svgs/kyc-lvl4-primer-icon.svg'));
        result.push(
            this.setRejectedKycSteps(
                this.getLvl5DocumentForms(isBrm, KycLvlState.REJECTED),
                KYCLevel.LVL_5,
                'assets/images/svgs/kyc-lvl5-primer-icon.svg',
            ),
        );
        return result.filter((x) => x.timeline?.length);
    }

    initializeKycLvl5Details(lvl5Data = [], kycData) {
        const documentStatus = [];
        this.updateLvl5DocumentStatus(documentStatus, kycData);
        const timeline = this.getLvl5DocumentFormsV2(documentStatus);
        lvl5Data.push({ lvl: KYCLevel.LVL_5, timeline, imageLink: 'assets/images/svgs/kyc-lvl5-primer-icon.svg' });
    }

    updateLvl5DocumentStatus(documentStatus: any[], kycData) {
        const kycDashboardRegisteredBusinessDocumentStatus = kycData?.kycDashboardData?.kycDashboardRegisteredBusinessDocumentStatus;
        if (!kycDashboardRegisteredBusinessDocumentStatus) {
            return;
        }
        for (const [key, value] of Object.entries(kycDashboardRegisteredBusinessDocumentStatus)) {
            const document = { name: key, value };
            documentStatus.push(document);
        }
    }

    getLvl2RejectionForms(isBrm): TimelineModel[] {
        const result = [];
        const kycData = this.getKycDataV2();
        const isRejectedIdVerification = this.isRejected(kycData?.providerIdentityVerificationStatus);
        if (isRejectedIdVerification) {
            const pendingIdVerificationTimeline: TimelineModel = {
                description: 'Id verification',
                iconName: 'location',
                iconLink: 'assets/images/svgs/kyc-lvl2-primer-icon.svg',
                route: isBrm ? KycRoutes.BRM_KYC_ID_REJECTION_ROUTE : KycRoutes.BO_KYC_ID_REJECTION_ROUTE,
            };
            result.push(pendingIdVerificationTimeline);
        }
        return result;
    }

    getLvl2ReviewForms(): TimelineModel[] {
        const result = [];
        const kycData = this.getKycDataV2();
        const isPendingIdVerification = this.isPendingStatus(kycData?.providerIdentityVerificationStatus);
        if (isPendingIdVerification) {
            const pendingIdVerificationTimeline: TimelineModel = {
                description: 'Id verification',
                iconName: 'location',
                iconLink: 'assets/images/svgs/kyc-lvl2-primer-icon.svg',
            };
            result.push(pendingIdVerificationTimeline);
        }
        return result;
    }

    getLvl3ReviewForms(isBrm): TimelineModel[] {
        const result = [];
        const kycData = this.getKycDataV2();
        const kycDashboardData = kycData?.kycDashboardData;
        const isPersonalAddressForBusiness = kycData?.businessKycInformation?.isPersonalAddressForBusiness;
        const kycVerificationStatus = isPersonalAddressForBusiness ? TimelineStatus.SUCCESS : kycDashboardData?.kycVerificationStatus;
        const params = {
            kycVerificationStatus,
            businessOwnerUtilityVerificationStatus: kycDashboardData?.businessOwnerUtilityVerificationStatus,
            status: KycLvlState.SUBMITTED,
            isBrm,
        };
        this.setResidentialProofAddressTimelineV2(result, params);
        this.setBusinessProofAddressTimeline(result, params);
        return result;
    }

    getLvl3RejectionForms(isBrm: boolean): TimelineModel[] {
        const result = [];
        const kycData = this.getKycDataV2();
        const kycDashboardData = kycData?.kycDashboardData;
        const params = {
            kycVerificationStatus: kycDashboardData?.kycVerificationStatus,
            businessOwnerUtilityVerificationStatus: kycDashboardData?.businessOwnerUtilityVerificationStatus,
            residentialPhysicalAddressVerificationStatus: kycData?.residentialPhysicalAddressVerificationStatus,
            status: KycLvlState.REJECTED,
            isBrm,
        };
        if (!this.isAggregatorRole() && this.useNewBOKYCLevel3Flow()) {
            this.getTimelineForNewBOKYCLvl3Flow(result, params);
            return result;
        }
        this.setResidentialProofAddressTimeline(result, params);
        this.setBusinessProofAddressTimeline(result, params);
        return result;
    }

    async getTimelineForNewBOKYCLvl3Flow(result: any[], params) {
        const kycStanding = this.getKYCStanding();
        if (!kycStanding) return;
        const kycLvl3Data = this.getKycRequirementsByLevel(KYCLevel.LVL_3, kycStanding);
        const canContinue =
        params?.status === KycLvlState.SUBMITTED
            ? this.isPendingStatus(kycLvl3Data?.status)
            : this.isRejected(kycLvl3Data?.status);
        if (!canContinue) {
            return;
        }
        const residentialProofAddressTimeline = this.getProofOfAddressTimeline(false, params?.isBrm, params?.status);
        result.push(residentialProofAddressTimeline);
    }

    setBusinessProofAddressTimeline(result: any[], params) {
        const canContinue =
            params?.status === KycLvlState.SUBMITTED
                ? this.isPendingStatus(params?.kycVerificationStatus)
                : this.isRejected(params?.kycVerificationStatus);
        if (!canContinue) {
            return;
        }
        const businessProofAddressTimeline = this.getProofOfAddressTimeline(true, params?.isBrm, params?.status);
        result.push(businessProofAddressTimeline);
    }

    setResidentialProofAddressTimeline(result: any[], params) {
        const canContinue =
            params?.status === KycLvlState.SUBMITTED
                ? this.isPendingStatus(params?.residentialPhysicalAddressVerificationStatus)
                : this.isRejected(params?.residentialPhysicalAddressVerificationStatus);
        if (!canContinue) {
            return;
        }
        const residentialProofAddressTimeline = this.getProofOfAddressTimeline(false, params?.isBrm, params?.status);
        result.push(residentialProofAddressTimeline);
    }

    setResidentialProofAddressTimelineV2(result: any[], params) {
        const canContinue =
            params?.status === KycLvlState.SUBMITTED
                ? this.isPendingStatus(params?.businessOwnerUtilityVerificationStatus)
                : this.isRejected(params?.businessOwnerUtilityVerificationStatus);
        if (!canContinue) {
            return;
        }
        const residentialProofAddressTimeline = this.getProofOfAddressTimeline(false, params?.isBrm, params?.status);
        result.push(residentialProofAddressTimeline);
    }

    getProofOfAddressTimeline(isBusinessAddress: boolean, isBrm, status) {
        const rejectionRoute = isBrm
            ? KycRoutes.BRM_KYC_POA_REJECTION_ROUTE
            : this.useNewBOKYCLevel3Flow() && !this.isAggregatorRole()
            ? KycRoutes.BO_LVL_3_ROUTE
            : KycRoutes.BO_KYC_POA_REJECTION_ROUTE;
        const route = status === KycLvlState.REJECTED ? rejectionRoute : '';
        return this.getTimeline({
            description: isBusinessAddress ? 'Proof of Business Address' : 'Proof of Residential Address',
            iconName: 'location',
            route,
        });
    }

    getTimeline({ description, iconName, route }): TimelineModel {
        return {
            description,
            iconName,
            route,
        };
    }

    getLvl4ReviewForms(isBrm: boolean): TimelineModel[] {
        const result = [];
        const kycData = this.getKycDataV2();
        const params = {
            cacVerificationStatus: kycData?.cacVerificationStatus,
            status: KycLvlState.SUBMITTED,
            isBrm,
            cacAffiliatesVerificationStatus: kycData?.cacAffiliatesVerificationStatus,
        };
        this.setCacNumberTimeline(result, params);
        this.setCacAffiliateTimeline(result, params);
        return result;
    }

    setTINRejection(rejections: any[]) {
        const hasNoRejection = !this.isTINVerificationRequired() || this.isBusinessNameRegisteredBusinessType();
        if (hasNoRejection) {
            return;
        }

        const hasVerificationFailed = this.getTINVerificationFailedStatus();
        if (!hasVerificationFailed) {
            return;
        }

        rejections.push(this.createTINRejectionTimeline());
    }

    setBusinessAffiliateRejection(rejections: any[]) {
        if (!this.getAffiliateFailedStatus()) {
            return;
        }

        rejections.push(this.createAffiliateRejectionTimeline());
    }

    getRejectionRouteByRole() {
        let route = this.isAggregatorRole() ? KycRoutes.BRM_LVL_4_ROUTE : KycRoutes.BO_LVL_4_ROUTE;
        route += `?${FROM_KYC_BANNER_KEY}=true`;
        return route;
    }

    createTINRejectionTimeline() {
        const route = this.getRejectionRouteByRole();
        const description = this.TIN;
        const tinTimeline = this.getUpdatedKycLvl4Timeline().find((timeline) => timeline.key === KYCFormKeys.TIN_DETAIL);

        return tinTimeline ? { ...tinTimeline, route, description } : null;
    }

    createAffiliateRejectionTimeline() {
        const route = this.getRejectionRouteByRole();
        const tinTimeline = this.getUpdatedKycLvl4Timeline().find((timeline) => timeline.key === KYCFormKeys.AFFILIATE_DETAIL);
        return tinTimeline ? { ...tinTimeline, route } : null;
    }

    createCACRejectionTimeline() {
        const route = this.getRejectionRouteByRole();
        const description = this.CAC_NUMBER;
        const iconName = TimelineIconName.supportingDocuments;
        const tinTimeline = this.getUpdatedKycLvl4Timeline().find((timeline) => timeline.key === KYCFormKeys.BUSINESS_DETAIL);
        return tinTimeline ? { ...tinTimeline, route, description, iconName } : null;
    }

    getLvl4RejectionForms(isBrm: boolean): TimelineModel[] {
        const result = [];
        this.setCACRejection(result);
        this.setTINRejection(result);
        this.setBusinessAffiliateRejection(result);
        return result;
    }

    setCACRejection(rejections: any[]) {
        const kycData = this.getKycDataV2();

        const hasRejection = this.hasRejectedCACVerification(kycData) || this.hasFailedCACVerification(kycData);
        if (!hasRejection) {
            return;
        }

        rejections.push(this.createCACRejectionTimeline());
    }

    setCacNumberTimeline(result: any[], params) {
        const canContinue =
            params?.status === KycLvlState.SUBMITTED
                ? this.isPendingStatus(params?.cacVerificationStatus)
                : this.isRejected(params?.cacVerificationStatus);
        if (!canContinue) {
            return;
        }
        const route = this.getBusinessDetailsRejectionRoute();
        const cACNumberTimeline = this.getTimeline({ description: 'CAC Number', iconName: 'supportingDocuments', route });
        result.push(cACNumberTimeline);
    }

    getBusinessDetailsRejectionRoute() {
        return this.isAggregatorRole() ? KycRoutes.BRM_KYC_BUSINESS_DETAILS_REJECTION : KycRoutes.BO_KYC_BUSINESS_DETAILS_REJECTION;
    }

    setCacAffiliateTimeline(result: any[], params) {
        const canContinue =
            params?.status === KycLvlState.SUBMITTED
                ? this.isPendingStatus(params?.cacAffiliatesVerificationStatus)
                : this.isRejected(params?.cacAffiliatesVerificationStatus);
        if (!canContinue) {
            return;
        }
        const route = this.getBusinessDetailsRejectionRoute();
        const cacAffiliateTimeline = this.getTimeline({
            description: 'CAC Affiliate',
            iconName: 'supportingDocuments',
            route,
        });
        result.push(cacAffiliateTimeline);
    }

    getKycRejectedLvl() {
        const kycLevelStatus = this.getUpdateKycLevelStatus();
        if (kycLevelStatus.length === 0) {
            return false;
        }
        return kycLevelStatus.find((key) => this.isRejected(key.value));
    }

    getKycReviewLvl() {
        const kycLevelStatus = this.getUpdateKycLevelStatus();
        if (kycLevelStatus.length === 0) {
            return false;
        }
        return kycLevelStatus.find((key) => this.isInReviewLvl(key?.value));
    }

    isPendingStatus(param: string) {
        return param === TimelineStatus.PENDING || param === TimelineStatus.IN_REVIEW || param === TimelineStatus.AWAITING_APPROVAL;
    }

    isRejected(param: string) {
        return param === KycLvlState.REJECTED || param === KycLvlState.FAILED || param === TimelineStatus.NOT_DONE;
    }

    isSuccessStatus(param: string) {
        return param === TimelineStatus.SUCCESS || param === TimelineStatus.APPROVED;
    }

    getLvl5DocumentFormsV2(documentStatus): TimelineModel[] {
        const result = [];
        // MockSupportingDocStatus; //
        documentStatus.forEach((doc) => {
            const timeline: TimelineModel = {
                description: KycBusinessDocumentDictionary[doc?.name],
                iconName: 'supportingDocuments',
                extraStatus: doc?.value,
            };
            result.push(timeline);
        });
        return result;
    }

    getLvl5DocumentForms(isBrm, status): TimelineModel[] {
        const result = [];
        const kycDashboardData = this.getKycDataV2()?.kycDashboardData;
        let supportingDocuments: any[] = [];
        const documentStatus = kycDashboardData?.kycDashboardRegisteredBusinessDocumentStatus; // MockSupportingDocStatus; //
        if (!StringHelper.isNullOrEmptyOrUndefined(documentStatus)) {
            const keys = Object.keys(documentStatus);
            supportingDocuments = keys.filter((x) => documentStatus[x] === status);
        }
        const route = isBrm ? KycRoutes.BRM_KYC_SUPPORTING_DOCUMENT_REJECTION : KycRoutes.BO_KYC_SUPPORTING_DOCUMENT_REJECTION;
        supportingDocuments.forEach((doc) => {
            const timeline = this.getTimeline({
                description: KycBusinessDocumentDictionary[doc],
                iconName: 'supportingDocuments',
                route,
            });
            result.push(timeline);
        });
        return result;
    }

    setProcessingKycSteps(timeline: any[], lvl, imageLink) {
        const kycData = this.getKycDataV2();
        const kycLevelStatus = kycData?.kycLevelStatus;
        if (!kycLevelStatus) {
            return { lvl, timeline: [] };
        }
        const inReview = kycLevelStatus[KYCLevelV2[lvl]] === KycLvlState.SUBMITTED;
        if (!inReview) {
            return { lvl, timeline: [] };
        }
        return { lvl, timeline, imageLink };
    }

    setRejectedKycSteps(timeline: any[], lvl, imageLink) {
        const kycData = this.getKycDataV2();
        const kycLevelStatus = kycData?.kycLevelStatus;
        if (!kycLevelStatus) {
            return { lvl, timeline: [] };
        }
        const isRejected = kycLevelStatus[KYCLevelV2[lvl]] === KycLvlState.REJECTED;
        if (!isRejected) {
            return { lvl, timeline: [] };
        }
        return { lvl, timeline, imageLink };
    }

    readonly NIN_TEXT = 'NIN';
    readonly SELECT_NIN = 'Please select NIN';

    updateTimelineWithAllowBvnConfiguration(timelines: TimelineModel[]) {
        if (!this.allowBvnForKycLevel1BusinessOnboarding()) {
            const timeline = timelines.find((timeline) => timeline.key === KYCFormKeys.BVN_NIN_VERIFIED);
            timeline.description = this.NIN_TEXT;
            timeline.mobileNote = this.SELECT_NIN;
            timeline.extraDescription = '';
        }
    }

    getKycTimelineByKycLevel(kycLevel: KYCLevel) {
        if (!kycLevel) {
            kycLevel = KYCLevel.LVL_1;
        }
        const obj = {
            1: this.getUpdateKycLvl1Timeline,
            2: this.getUpdatedKycLvl2Timeline,
            3: this.getUpdatedKycLvl3Timeline,
            4: this.getUpdatedKycLvl4Timeline,
            5: this.getUpdatedKycLvl5Timeline,
        };
        const timeline = obj[kycLevel]();
        this.updateTimelineWithAllowBvnConfiguration(timeline);
        return timeline;
    }

    getUpdateKycLvl1Timeline = () => {
        const isBrmBoOnboardingMode = this.isAggregatorRole();
        const timelines = isBrmBoOnboardingMode ? this.getBrmLevel1Timeline() : this.getBoKycLevel1Timeline();
        this.updateKycLevel1Timeline(timelines, this.DEFAULT_KYC_LVL_STEP);
        return timelines;
    };

    getBoKycLevel1Timeline() {
        let timelines = this.shouldUseNewBvnFlow() ? KYCLvl1FormStepsV2 : KYCLvl1FormSteps;
        if (this.useKycNINFlow()) {
            timelines = KYCLvl1FormStepsV3;
        }
        if (this.useEnhancedKycLvl1Flow()) {
            timelines = KYCLvl1FormStepsV4;
        }
        if (this.useKycBvnNationality()) {
            timelines = KYCLvl1FormStepsV5;
        }
        if (this.useAdditionBusinessDetailsKycLvl1()) {
            timelines = KYCLvl1FormStepsV6;
        }
        if (this.useKycLvl1PreventHybridMerchant()) {
            timelines = KYCLvl1FormStepsV7
        }
        return timelines;
    }

    getUpdatedLvlStep(timeline: TimelineModel[], { step, allowStep }) {
        if (allowStep) {
            return step;
        }
        const form = timeline.find((x) => x?.step === step);
        if (!form?.isStepCompleted) {
            return step;
        }
        return this.getNextLvlStep(timeline);
    }

    getNextLvlStep(timeline: TimelineModel[]) {
        const unfilledSteps = timeline.find((x) => !x.isStepCompleted && !x.isStepInReview);
        return unfilledSteps?.step || this.getLastLvlStep(timeline); // refactor this
    }

    getLastLvlStep(timeline: TimelineModel[]) {
        if (timeline.length === Index.ZERO) {
            return Index.ONE;
        }
        return timeline[timeline.length - Index.ONE]?.step;
    }

    setCurrentLvlStep(params) {
        const timelines = this.getKycTimelineByKycLevel(params?.lvl);
        params.step = this.getUpdatedLvlStep(timelines, params);
        this.navigateKycLvlForm(params);
    }

    resetKycLvlStep(lvl: number) {
        switch (lvl) {
            case KYCLevel.LVL_1:
                this.setCurrentKycLvl1Step(this.DEFAULT_KYC_LVL_STEP);
                break;
            case KYCLevel.LVL_2:
                this.setCurrentKycLvl2Step(this.DEFAULT_KYC_LVL_STEP);
                break;
            case KYCLevel.LVL_3:
                this.setCurrentKycLvl3Step(this.DEFAULT_KYC_LVL_STEP);
                break;
            case KYCLevel.LVL_4:
                this.setCurrentKycLvl2Step(this.DEFAULT_KYC_LVL_STEP);
                break;
        }
    }

    getIdentityVerificationStatusV2(route): Promise<any> {
        const url = this.config.MONIEPOINT_ONBOARDING + `${route}`;
        return this.apiClientHelper.getForPromise(url);
    }

    getBvnVerificationStatus(route): Promise<any> {
        const url = this.config.MONIEPOINT_ONBOARDING + `${route}`;
        return this.apiClientHelper.postForPromise(url, {});
    }

    getUpdatedKycLvl2Timeline = () => {
        const lvl2Steps = this.isAggregatorRole() ? this.getBrmLevel2Timeline() : this.getUpdatedKycLevel2Timeline();
        this.updateKycLevel2Timeline(lvl2Steps, this.DEFAULT_KYC_LVL_STEP);
        return lvl2Steps;
    };

    getUpdatedKycLevel2Timeline() {
        if (!this.useKycNINFlow()) {
            return KYCLvl2FormSteps;
        }
        const steps = this.useSimplifiedKycLevel2Flow() ? KYCLvl2FormStepsV3 : KYCLvl2FormStepsV2;
        return this.getKycLevel2TimelineUpdatedWithNinFlow(steps);
    }

    getKycLevel2TimelineUpdatedWithNinFlow(formTimelines: TimelineModel[]) {
        const timelines = formTimelines;
        this.isNinIdentitySource() ? this.getKycLevel2TimelineUpdatedWithBvn(timelines) : this.getKycLevel2TimelineUpdatedWithNin(timelines);
        return timelines;
    }

    isNinIdentitySource() {
        return this.getLivenessVerificationIdentitySource() === KYC_IDENTITY_TYPE.NIN;
    }

    openNinPage() {
        window.open('https://nimc.gov.ng/sms-service', '_blank');
    }

    getLivenessVerificationIdentitySource() {
        const kycData = this.getKycDataV2();
        return kycData?.livenessVerificationIdentitySource ?? KYC_IDENTITY_TYPE.BVN;
    }

    getKycLevel2TimelineUpdatedWithNin(timelines: TimelineModel[]) {
        timelines.forEach((timeline) => {
            if (timeline.key === KYCFormKeys.BVN_COMPLETED) {
                timeline.key = KycLevel2NinTimeline.key;
                timeline.description = KycLevel2NinTimeline.description;
                timeline.mobileNote = KycLevel2NinTimeline.mobileNote;
            }
        });
    }

    getKycLevel2TimelineUpdatedWithBvn(timelines: TimelineModel[]) {
        timelines.forEach((timeline) => {
            if (timeline?.step === 1) {
                timeline.key = KycLevel2BvnTimeline.key;
                timeline.description = KycLevel2BvnTimeline.description;
                timeline.mobileNote = KycLevel2BvnTimeline.mobileNote;
            }
        });
    }

    getUpdatedKycLvl3Timeline = () => {
        const kycData = this.getKycDataV2();
        if (!this.isAggregatorRole() && this.useNewBOKYCLevel3Flow()) {
            return this.getNewBOKycLvl3Timeline();
        }
        const lvl3Steps = this.isAggregatorRole() ? this.getBrmKycLvl3Timeline() : this.getKycLvl3FormSteps();
        if (this.usePhysicalAddressVerificationForKyc()) {
            return lvl3Steps;
        }
        this.handleKycLvl3StatusV2(lvl3Steps, kycData);
        this.handleKycLvl3Failure(lvl3Steps, kycData);
        return lvl3Steps;
    };

    getKycLvl3PhysicalAddressTimeline = () => {
        const timelines: TimelineModel[] = [];
        KYCLvl3PhysicalAddressTimelines.forEach((timeline) => {
            timelines.push(this.createNewTimeline(timeline, timeline?.step));
        });
        this.updateResidentialPhysicalAddressTimeline(timelines);
        this.updateIndemnityTimeline(timelines);
        return timelines;
    };

    updateIndemnityTimeline(timelines: TimelineModel[]) {
        const indemnityTimelineTimeline = timelines.find((timeline) => timeline.key === KYCFormKeys.INDEMNITY);
        if (this.hasSubmittedIndemnity()) {
            indemnityTimelineTimeline.state = TimelineStatus.completed;
            indemnityTimelineTimeline.isStepCompleted = true;
        }
    }

    updateResidentialPhysicalAddressTimeline(timelines: TimelineModel[]) {
        const conditionFunctionPairs = this.getResidentialPhysicalAddressFunctionPairs();
        const addressStatus = this.getResidentialPhysicalAddressVerificationStatus();
        const conditionFunctionPair = conditionFunctionPairs.find((fn) => fn.key === addressStatus);
        const residentialAddressTimeline = timelines.find((timeline) => timeline.key === KYCFormKeys.PROOF_OF_ADDRESS);
        if (conditionFunctionPair?.hasStatus && conditionFunctionPair?.hasStatus.call(this)) {
            conditionFunctionPair.action.call(this, residentialAddressTimeline);
        }
    }

    updateTimelineWithApprovedStatus(timeline: TimelineModel) {
        timeline.state = TimelineStatus.completed;
        timeline.isStepCompleted = true;
    }

    updateTimelineWithRejectedStatus(timeline: TimelineModel) {
        timeline.state = TimelineStatusV2.FAILED;
        timeline.isStepFailed = true;
    }

    updateTimelineWithAwaitingApprovalStatus(timeline: TimelineModel) {
        timeline.state = TimelineStatus.processing;
        timeline.isStepInReview = true;
    }

    updateTimelineWithNotDoneStatus(timeline: TimelineModel) {
        timeline.state = TimelineStatus.active;
    }

    getResidentialPhysicalAddressFunctionPairs() {
        const conditionFunctionPairs = [
            {
                key: TimelineStatus.REJECTED_TERMINAL,
                hasStatus: this.hasResidentialPhysicalAddressRejectedTerminal,
                action: this.updateTimelineWithRejectedStatus,
            },
            { key: TimelineStatus.APPROVED, hasStatus: this.hasResidentialPhysicalAddressApproved, action: this.updateTimelineWithApprovedStatus },
            { key: TimelineStatus.REJECTED, hasStatus: this.hasResidentialPhysicalAddressRejected, action: this.updateTimelineWithRejectedStatus },
            {
                key: TimelineStatus.AWAITING_APPROVAL,
                hasStatus: this.hasResidentialPhysicalAddressAwaitingApproval,
                action: this.updateTimelineWithAwaitingApprovalStatus,
            },
            { key: TimelineStatus.NOT_DONE, hasStatus: this.hasResidentialPhysicalAddressNotDone, action: this.updateTimelineWithNotDoneStatus },
        ];
        return conditionFunctionPairs;
    }

    async setCurrentKYCStanding(kycStanding) {
        this.kycStandingData = kycStanding;
    }

    async setCurrentBusinessOwnerDetails(businessDetails: Business) {
        this.businessDetails = businessDetails;
    }

    getCurrentBusinessOwnerDetails() {
        return this.businessDetails;
    }

    getLvl3SupportedDocumentTypes(): SupportedDocumentTypes {
      return this.supportedlvl3DocumentTypes;
    }

    setLvl3SupportedDocumentTypes(documentTypes: SupportedDocumentTypes) {
      this.supportedlvl3DocumentTypes = documentTypes;
    }

    getProofOfAddressTypeV2(): Promise<SupportedDocumentTypes> {
        const url = `${this.config.MONIEPOINT_AVS}/api/v1/document-verifications/document-types`;
        return this.apiClientHelper.getForPromise(url,true,true,false, this.getAvsHeaderParams(true));
    }

    fetchKYCStanding(): Promise<KYCStanding> {
        const url = `${this.config.MONIEPOINT_ONBOARDING}/api/v1/kyc-standing`;
        return this.apiClientHelper.getForPromise(url);
    }

    getSampleDocumentAsBlob(url:string): Promise<any> {
		return this.apiClientHelper.getAsBlobForPromise(url);
	}

    setBoActualLocationInfo(infoData: {isEdited: boolean, location: GeometryLocation}){

        this.boActualLocationInfo = infoData;
    }

    getBoActualLocationInfo(){
        return this.boActualLocationInfo
    }

    hideNoteForNewLvl3Flow(lvl: KYCLevel) {
        return this.useNewBOKYCLevel3Flow() && lvl === KYCLevel.LVL_3 && !this.isAggregatorRole();
    }

    formatAddressV2(res: any) {
        const addressLineOne = res?.addressLineOne;
        const city = res?.area;
        const lga = res?.localGovernmentCode;
        const state = res?.city;
        return this.mergeAddressDetails(addressLineOne, city, lga, state);
    }

    getUserAddress(params): Promise<AddressV2> {
        const username = this.getCurrentUserName()
        const urlParams = StringHelper.toUrlString(params);
        const url = `${this.config.MONIEPOINT_AVS}/api/v1/addresses/user/${username}?${urlParams}`;
        return this.apiClientHelper.getForPromise(url,true,true,false, this.getAvsHeaderParams(true));
    }

    getAvsHeaderParams(addClientVersion:boolean = false) {
        return {
            ...(addClientVersion && { 'client-version': AppConfig.CLIENT_VERSION }),
            'agent-code': this.getCurrentBusinessOwnerDetails()?.code,
            'banking-domain': 'BUSINESS'
        };
    }

    fetchPreviousBillPayments(): Promise<PreviousBillPaymentResponse> {
        const username  = this.getCurrentUserName()
        const url = `${this.config.MONIEPOINT_AVS}/api/v1/bill-payments/user/${username}`;
        return this.apiClientHelper.getForPromise(url,true,true,false, this.getAvsHeaderParams(true));
    }

    initiateAddressVerification(params: { addressVerificationUrl: string; payload: Record<string, any> }): Promise<AddressVerificationResponse> {
        const { addressVerificationUrl, payload } = params;
        const url = this.config.MONIEPOINT_AVS + addressVerificationUrl;
        return this.apiClientHelper.postForPromise(url, payload,true,true,true,this.config.clientId, this.getAvsHeaderParams());
    }

    getKYCStanding() {
        return this.kycStandingData;
    }

    fetchPhysicalVerificationStrategy(addressReference: string): Promise<PhysicalVerificationStrategyResponse> {
        const url = `${this.config.MONIEPOINT_AVS}/api/v1/physical-verifications/address/${addressReference}`;
        return this.apiClientHelper.getForPromise(url,true,true,false, this.getAvsHeaderParams(true));
    }

    initiatePhysicalVerificationDryRun(addressReference: string, payload: PhysicalVerificationDryRunPayload): Promise<PhysicalVerificationDryRunResponse> {
        const url = `${this.config.MONIEPOINT_AVS}/api/v1/dry-runs/physical-verifications/address/${addressReference}`;
        return this.apiClientHelper.postForPromise(url, payload,true,true,true,this.config.clientId, this.getAvsHeaderParams());
    }

    initiatePhysicalVerificationn(addressReference: string, payload: PhysicalVerificationPayload): Promise<PhysicalVerificationResponse> {
        const url = `${this.config.MONIEPOINT_AVS}/api/v1/physical-verifications/address/${addressReference}`;
        return this.apiClientHelper.putForPromise(url, payload,true,true,this.config.clientId, this.getAvsHeaderParams());
    }

    setCurrentUserGeoCodingResults(result: GeocodingResult []) {
        this.loggedInUserGeoLocationResults = result;
    }

    filterOutPlusCodeResults(geoCodingResults: GeocodingResult[]) {
        return geoCodingResults.filter((result) => !result.addressComponents.some((component) => component.types.includes(GeolocationType.plus_code.toUpperCase())));
    }

    getCurrentUserGeoCodingResults():GeocodingResult[] {
        return this.loggedInUserGeoLocationResults || [];
    }

    getLvl3ActiveUserGeoCodingResult() {
        return this.lvl3ActiveGeoCodingResult ;
    }

    setLvl3ActiveUserGeoCodingResult(result: GeocodingResult) {
        this.lvl3ActiveGeoCodingResult = result;
    }

    getKycRequirementsByLevel(lvl: number, kycStandingData: KYCStanding): KYCLevelInfo {
        const { levels } = kycStandingData;
        let matchedLevel;

        levels.forEach((level) => {
            if (level.level === lvl) {
                matchedLevel = level;
            }
        });
        return matchedLevel;
    }

    mapAddressV2ToOnboardingAddress(addressDetails: any): OnboardingAddress {
        const { addressLineOne, addressLineTwo, city, localGovernmentCode, type, countryCode } = addressDetails;

        return {
            state: { code: '', name: city },
            lga: { code: '', name: localGovernmentCode },
            country: { code: countryCode, name: 'Nigeria' },
            city,
            addressLineOne,
            addressLineTwo,
            type: type as OnboardingAddressType,
            canVerifyBusinessWithResidentialAddress: true,
            proofOfAddressSubmitted: false,
        };
    }

    addKYCLvl3RejectionMessage(timeline: TimelineModel, requirementMessage: string) {
        timeline.data = requirementMessage;
    }

    mapStatusReceivedToTimelineStatus(timeline: TimelineModel, matchingRequirement: KYCRequirement) {
        const status = matchingRequirement.status;
        switch (true) {
            case this.isKYCStageRejected(status):
                this.addKYCLvl3RejectionMessage(timeline, matchingRequirement.message);
                this.updateTimelineWithRejectedStatus(timeline);
                return;
            case this.isKYCStageApproved(status):
                return this.updateTimelineWithApprovedStatus(timeline);
            case this.isKYCStageProcessing(status):
                this.updateTimelineWithAwaitingApprovalStatus(timeline);
                return;
            default:
                return this.updateTimelineWithNotDoneStatus(timeline);
        }
    }

    isKYCStageRejected(status: string): boolean {
        const rejectedStatuses = [
            TimelineStatusV2.REJECTED.toLowerCase(),
            TimelineStatusV2.FAILED.toLowerCase(),
            TimelineStatusV2.REJECTED_TERMINAL.toLowerCase(),
        ];
        return rejectedStatuses.includes(status.toLowerCase());
    }

    isKYCStagePending(status: string): boolean {
        const pendingStatuses = [
            TimelineStatusV2.PENDING.toLowerCase(),
            TimelineStatusV2.VERIFICATION_NOT_DONE.toLowerCase(),
            TimelineStatusV2.NOT_DONE.toLowerCase(),
        ];
        return pendingStatuses.includes(status.toLowerCase());
    }

    isKYCStageApproved(status: string): boolean {
        const approvedStatuses = [
            TimelineStatusV2.APPROVED.toLowerCase(),
            TimelineStatusV2.SUCCESS.toLowerCase(),
            TimelineStatusV2.COMPLETED.toLowerCase(),
        ];
        return approvedStatuses.includes(status.toLowerCase());
    }

    isKYCStageProcessing(status: string): boolean {
        const processingStatuses = [
            TimelineStatusV2.AWAITING_APPROVAL.toLowerCase(),
            TimelineStatusV2.IN_REVIEW.toLowerCase(),
            TimelineStatusV2.REVIEWING.toLowerCase(),
            TimelineStatusV2.PROCESSING.toLowerCase(),
            TimelineStatusV2.ATTEMPTED.toLowerCase(),
        ];
        return processingStatuses.includes(status.toLowerCase());
    }

    getLevel3TimelinesBasedOnRequirements(kycLevelRequirements: KYCRequirement[]) {
        const requirementCodes: Record<string, number> = kycLevelRequirements.reduce((acc, requirement, index) => {
            acc[requirement.code] = index;
            return acc;
        }, {});
        const kycLevel3Timeline = [];
        let stepIndex = 1;
        KYCLvl3FormStepsV3.forEach((step) => {
            if (step.key in requirementCodes) {
                kycLevel3Timeline.push(this.createNewTimeline(step, stepIndex));
                stepIndex++;
            }
        });
        return kycLevel3Timeline;
    }

    updateKYCLevel3TimeLine(kycLevel3Timeline: TimelineModel[], kycRequirements: KYCRequirement[]) {
        const updatedTimeline = kycLevel3Timeline.map((step) => {
            const matchingRequirement = kycRequirements.find((req: KYCRequirement) => req.code === step.key);

            if (matchingRequirement) {
                this.mapStatusReceivedToTimelineStatus(step, matchingRequirement);
            }

            return step;
        });

        return updatedTimeline;
    }

    getNewBOKycLvl3Timeline() {
        // Get user event data
        const kycLvl3MixpanelUserEventData = this.getKycLvl3MixpanelUserEventData();

        // Log mixpanel event
        this.logMixpanelEvent({
            ...kycLvl3MixpanelUserEventData,
            event: OnboardingKycLevel3MixpanelEvents.kycl3_face_verification_required_initiated,
        });

        const storedKYCStanding = this.getKYCStanding();

        if (storedKYCStanding === null) {
            return [];
        }

        const { requirements } = this.getKycRequirementsByLevel(KYCLevel.LVL_3, storedKYCStanding);
        const faceVerificationRequirement = requirements.find((req: KYCRequirement) => req.code === KYCLvl3StepV3.FACE_VERIFICATION);

        if (!faceVerificationRequirement) {
            // Log mixpanel event
            this.logMixpanelEvent({
                event: OnboardingKycLevel3MixpanelEvents.kycl3_face_verification_required_failed,
                ...kycLvl3MixpanelUserEventData,
                api_code_error: '',
                api_error_message: 'Face verification requirement not provided by KYC standing',
            });
        } else {
            // Determine if face verification is required
            const isFaceVerificationRequired = faceVerificationRequirement.status === TimelineStatusV2.PENDING;

            // Log mixpanel event
            this.logMixpanelEvent({
                event: OnboardingKycLevel3MixpanelEvents.kycl3_face_verification_required_success,
                ...kycLvl3MixpanelUserEventData,
                face_verification_required_status: isFaceVerificationRequired,
            });
        }

        const kycLevel3Timeline = this.getLevel3TimelinesBasedOnRequirements(requirements);
        const updatedLvl3Timeline = this.updateKYCLevel3TimeLine(kycLevel3Timeline, requirements);
        return updatedLvl3Timeline;
    }

    updateStoredKYCDataNameFormat() {
        const kycData = this.getKycDataV2();
        const updatedKycData = {
            ...kycData,
            accountNameFormat: NEW_BO_KYC_LVL3_ACCOUNT_NAME_FORMAT,
        };
        this.setKycDataV2(updatedKycData);
    }

    getBOKYCLvl3StepsValues(timeLine: TimelineModel[]): Partial<KycLvl3V3Steps> {
        const newBOycLvl3Steps: Partial<KycLvl3V3Steps> = {};
        timeLine.forEach((step, index) => {
            newBOycLvl3Steps[step.key] = index + 1;
        });
        return newBOycLvl3Steps;
    }

    getKycLvl3FormSteps() {
        if (this.usePhysicalAddressVerificationForKyc()) {
            return this.getKycLvl3PhysicalAddressTimeline();
        }
        const step = KYCLvl3FormSteps;
        if (this.useSimplifiedKycLevel3Flow()) {
            step[0].description = KYCLvl3PhysicalAddressTimelines[0].description;
        }
        return step;
    }

    handleKycLvl3Status(lvl3Steps: TimelineModel[], kycData) {
        const hasVerifiedAddress = this.isBusinessAddressApproved() && this.isResidentialAddressApproved();
        lvl3Steps.forEach((e) => {
            const isAddressVerification = e?.key === KYCFormKeys.PROOF_OF_ADDRESS_VERIFICATION;
            e.isStepCompleted = isAddressVerification ? hasVerifiedAddress : kycData[e?.key];
        });
    }

    handleKycLvl3StatusV2(lvl3Steps: TimelineModel[], kycData) {
        const hasVerifiedAddress = this.isBusinessAddressApproved() && this.isResidentialAddressApproved();
        const addressVerificationKey = this.isAggregatorRole() ? KYCFormKeys.PROOF_OF_ADDRESS : KYCFormKeys.PROOF_OF_ADDRESS_VERIFICATION;
        lvl3Steps.forEach((e) => {
            const isAddressVerification = e?.key === addressVerificationKey;
            e.isStepCompleted = isAddressVerification ? hasVerifiedAddress : kycData[e?.key];
        });
    }

    handleKycLvl3Failure(lvl3Steps: TimelineModel[], kycData: any) {
        const kycLevelStatus = kycData?.kycLevelStatus;
        if (!kycLevelStatus || lvl3Steps?.length === 0) {
            return;
        }
        const key = KYCLevelV2[KYCLevel.LVL_3];
        lvl3Steps[Index.ZERO].isStepFailed = kycLevelStatus[key] === KycLvlState.REJECTED;
    }

    updateKycLevelWithBusinessNameChange(timelines: TimelineModel[]) {
        if (!this.canUseBusinessNameChange()) {
            return;
        }
        this.addBusinessNameChangeStepToKycLvl4(timelines);
        this.updateKycLevel4SummaryStatus(timelines);
    }

    updateKycLevel4SummaryStatus(timelines: TimelineModel[]) {
        timelines.find((timeline) => this.isKycLevel4SummaryForm(timeline.key)).disabled = false;
    }

    isKycLevel4SummaryForm(key) {
        return key === KYCFormKeys.SUPPORTING_DOCUMENTS_SUMMARY;
    }

    addBusinessNameChangeStepToKycLvl4(timelines: TimelineModel[]) {
        const businessNameStep = timelines.find((timeline) => timeline.key === KYCFormKeys.BUSINESS_NAME_CHANGE);
        if (businessNameStep) {
            return;
        }
        timelines.splice(
            this.useBusinessAffiliateFlow() ? 5 : 2,
            0,
            this.useBusinessAffiliateFlow() ? BusinessNameChangeStepV2 : BusinessNameChangeStep,
        );
        this.updateKycLevel4TimeLineAfterBusinessNameChange(timelines);
    }

    updateKycLevel4TimeLineAfterBusinessNameChange(timelines: TimelineModel[]) {
        timelines.find((timeline) => timeline.key === KYCFormKeys.SUPPORTING_DOCUMENTS_SUMMARY).step = this.useBusinessAffiliateFlow() ? 7 : 4;
        timelines.find((timeline) => timeline.key === KYCFormKeys.SUPPORTING_DOCUMENTS_SUMMARY).title = this.useBusinessAffiliateFlow()
            ? 'Step 7'
            : 'Step 4';
    }

    getBlockedKycSteps() {
        if (this.isFromKYCBannerOnKycLevel4()) return [];
        const blacklistedSteps = [];

        this.appendIfNot(KYCFormKeys.SCUML_DETAILS, this.hasScuml(), blacklistedSteps);
        this.appendIfNot(KYCFormKeys.TIN_DETAIL, this.isTINVerificationRequired(), blacklistedSteps);
        this.appendIfNot(KYCFormKeys.BUSINESS_NAME_CHANGE, this.canUseBusinessNameChange(), blacklistedSteps);
        this.handleBusinessAffiliateFlow(this.useBusinessAffiliateFlow(), blacklistedSteps);

        return blacklistedSteps;
    }

    appendIfNot(measurable: KYCFormKeys, condition: boolean, list: any[]) {
        if (!condition) {
            list.push(measurable);
        }
    }

    handleBusinessAffiliateFlow(condition: boolean, list: any[]) {
        if (!condition) {
            this.appendBusinessAffiliateKeys(list);
        }
    }

    appendBusinessAffiliateKeys(kycBlacklistedSteps: string[]) {
        BusinessAffiliateKeys.forEach((key) => {
            kycBlacklistedSteps.push(key);
        });
    }

    isTINVerificationRequired() {
        const kycData = this.getKycDataV2();
        const businessKycInformation = kycData?.businessKycInformation;
        const registeredBusinessType = businessKycInformation?.registeredBusinessType;
        return registeredBusinessType !== KycBusinessType.INCORPORATED_TRUSTEES;
    }

    getKycLevel4TimelineByKey(key: KYCFormKeys) {
        const timelines = this.getUpdatedKycLvl4Timeline();
        return timelines.find((timeline) => timeline.key === key);
    }

    getUpdatedKycLvl4Timeline = () => {
        const timelines: TimelineModel[] = [];
        const blacklistedSteps = this.getBlockedKycSteps();

        this.updateTimelinesWithBlacklistedSteps(timelines, blacklistedSteps);

        this.updateKycLevel4TimelineWithFormStatus(timelines);

        this.updateLvl4TimelineLabel(timelines);

        if (this.isFromKYCBannerOnKycLevel4()) {
            return this.updateKycLevel4TimelineWithRejectedStep(timelines);
        }

        return timelines;
    };

    updateLvl4TimelineLabel(timelines: TimelineModel[]) {
        timelines.forEach((timeline) => {
            timeline.previousTitle = this.useRegisterBusinessPrimerLabel() ? KycLevelNameMap[4] : timeline.previousTitle;
        });
    }

    updateKycLevel4TimelineWithRejectedStep(timelines: TimelineModel[]): TimelineModel[] {
        const currentKycLvl4Step = this.getCurrentKycLvl4Step();
        const rejectionTimeline = timelines.find((timeline) => timeline?.step === currentKycLvl4Step);

        if (rejectionTimeline) {
            const newTimeline = this.createNewTimeline(rejectionTimeline, currentKycLvl4Step);
            return [newTimeline];
        }

        return timelines;
    }

    updateKycLevel4TimelineWithFormStatus(timelines: TimelineModel[]) {
        this.updateKycLevel4TimelineCompletedStatus(timelines);
        this.updateKycLevel4TimelineProcessingStatus(timelines);
        this.updateKycLevel4TimelineWithFailedStatus(timelines);
    }

    private updateTimelinesWithBlacklistedSteps(timelines: TimelineModel[], blacklistedSteps: string[]) {
        let index = 1;
        KycLevel4Timelines.forEach((timeline) => {
            if (!blacklistedSteps.includes(timeline.key)) {
                timelines.push(this.createNewTimeline(timeline, index));
                index += 1;
            }
        });
    }

    private createNewTimeline(timeline: TimelineModel, step: number) {
        const title = `Step ${step}`;
        return { ...timeline, step, title };
    }

    private createNewTimelineV2(timeline: TimelineModel, step: number) {
        const title = `Step ${step}`;
        const previousTitle = step > 0 ? `Step ${step - 1}` : 'Level 0';
        return { ...timeline, step, title, previousTitle };
    }

    updateKycLevel4TimelineCompletedStatus(timeline: TimelineModel[]) {
        const statusFunctions = this.getKycLevel4CompletedStatusFunctions();
        timeline.forEach((step) => {
            const key = step?.key;
            const hasFunction = statusFunctions.has(key);
            const fn = statusFunctions.get(key);
            step.isStepCompleted = hasFunction ? fn() : this.isCompletedForm(key);
            if (step.isStepCompleted) {
                step.state = TimelineStatus.completed;
            }
        });
    }

    updateKycLevel4TimelineProcessingStatus(timeline: TimelineModel[]) {
        const statusFunctions = this.getKycLevel4ProcessingStatusFunctions();
        timeline.forEach((step) => {
            const key = step?.key;
            const hasFunction = statusFunctions.has(key);
            const fn = statusFunctions.get(key);
            step.isStepInReview = hasFunction ? fn() : false;
            if (step.isStepInReview) {
                step.state = TimelineStatus.processing;
            }
        });
    }

    updateKycLevel4TimelineWithFailedStatus(timeline: TimelineModel[]) {
        const statusFunctions = this.getKycLevel4FailedStatusFunctions();
        timeline.forEach((step) => {
            const key = step?.key;
            const hasFunction = statusFunctions.has(key);
            const fn = statusFunctions.get(key);
            step.isStepFailed = hasFunction ? fn() : false;
            if (step.isStepFailed) {
                step.state = TimelineStatus.failed;
            }
        });
    }

    getKycLevel4CompletedStatusFunctions() {
        const statusFunctions = new Map<string, () => boolean>();
        statusFunctions.set(KYCFormKeys.BUSINESS_DETAIL, this.getLevel4CacCompletionStatus);
        statusFunctions.set(KYCFormKeys.TIN_DETAIL, this.getTINVerificationCompletionStatus);
        statusFunctions.set(KYCFormKeys.AFFILIATE_DETAIL, this.getAffiliateCompletionStatus);
        return statusFunctions;
    }

    getKycLevel4ProcessingStatusFunctions() {
        const statusFunctions = new Map<string, () => boolean>();
        statusFunctions.set(KYCFormKeys.BUSINESS_DETAIL, this.getLevel4CacProcessingStatus);
        statusFunctions.set(KYCFormKeys.TIN_DETAIL, this.getTINVerificationProcessingStatus);
        statusFunctions.set(KYCFormKeys.AFFILIATE_DETAIL, this.getAffiliateProcessingStatus);
        return statusFunctions;
    }

    getKycLevel4FailedStatusFunctions() {
        const statusFunctions = new Map<string, () => boolean>();
        statusFunctions.set(KYCFormKeys.BUSINESS_DETAIL, this.getLevel4CacFailedStatus);
        statusFunctions.set(KYCFormKeys.TIN_DETAIL, this.getTINVerificationFailedStatus);
        statusFunctions.set(KYCFormKeys.AFFILIATE_DETAIL, this.getAffiliateFailedStatus);
        return statusFunctions;
    }

    updateKycDataForLevel4() {
        this.setInitialDisplayBusinessName();
        this.markBusinessFormsAsInactiveIfUnRegisteredBusinessType();
    }

    setInitialDisplayBusinessName() {
        const kycData = this.getKycDataV2();
        const businessKycInformation = kycData?.businessKycInformation;
        const registeredBusinessType = businessKycInformation?.registeredBusinessType || KycBusinessType.BUSINESS_NAME;
        const businessDisplayName = KycBusinessTypeDisplayName[registeredBusinessType];
        this.setBusinessTypeDisplayName(businessDisplayName);
    }

    markBusinessFormsAsInactiveIfUnRegisteredBusinessType() {
        const kycData = this.getKycDataV2();
        const isUnRegisteredBusinessType = this.isUnRegisteredBusinessType(kycData?.businessKycInformation);
        if (!isUnRegisteredBusinessType) {
            return;
        }

        kycData[KYCFormKeys.BUSINESS_DETAIL] = false;
        kycData[KYCFormKeys.SUPPORTING_DOCUMENTS] = false;
        this.setKycDataV2(kycData);
    }

    isCompletedForm(formKey: string) {
        const formData = this.getKycDataV2();
        if (!formData) {
            return false;
        }
        return formData[formKey] ?? false;
    }

    getLevel4CacCompletionStatus = () => {
        const kycData = this.getKycDataV2();
        return this.hasCompletedCACForm(kycData);
    };

    getLevel4CacProcessingStatus = () => {
        const kycData = this.getKycDataV2();
        return this.hasSubmittedCACForm(kycData);
    };

    getLevel4CacFailedStatus = () => {
        const kycData = this.getKycDataV2();
        return this.hasFailedCACVerification(kycData);
    };

    getTINVerificationCompletionStatus = () => {
        const kycData = this.getKycDataV2();
        const tinStatus = kycData?.taxIdentificationNumberStatus;
        return tinStatus === TimelineStatus.VERIFIED || tinStatus === TimelineStatus.VERIFICATION_NOT_DONE;
    };

    getTINVerificationProcessingStatus = () => {
        const kycData = this.getKycDataV2();
        const tinStatus = kycData?.taxIdentificationNumberStatus;
        return tinStatus === TimelineStatus.IN_PROGRESS || tinStatus === TimelineStatus.PENDING;
    };

    getTINVerificationFailedStatus = () => {
        const kycData = this.getKycDataV2();
        const tinStatus = kycData?.taxIdentificationNumberStatus;
        return tinStatus === TimelineStatus.FAILED || tinStatus === TimelineStatus.REJECTED;
    };

    getAffiliateCompletionStatus = () => {
        const kycData = this.getKycDataV2();
        const affiliateStatus = kycData?.bvnNinAffiliatesCheckStatus;
        return affiliateStatus === TimelineStatus.SUCCESS;
    };

    getAffiliateProcessingStatus = () => {
        const kycData = this.getKycDataV2();
        const affiliateStatus = kycData?.bvnNinAffiliatesCheckStatus;
        return affiliateStatus === TimelineStatus.IN_PROGRESS;
    };

    getAffiliateFailedStatus = () => {
        const kycData = this.getKycDataV2();
        const affiliateStatus = kycData?.bvnNinAffiliatesCheckStatus;
        return affiliateStatus === TimelineStatus.FAILED || affiliateStatus === TimelineStatus.REJECTED;
    };

    hasCompletedCACForm(kycData: any) {
        const isUnRegisteredBusinessType = this.isUnRegisteredBusinessType(kycData?.businessKycInformation);
        if (isUnRegisteredBusinessType) {
            return false;
        }

        return (
            this.hasCompletedCacVerification(kycData?.cacVerificationStatus) &&
            this.hasCompletedCacVerification(kycData?.cacAffiliatesVerificationStatus)
        );
    }

    hasSubmittedCACForm(kycData: any) {
        const isUnRegisteredBusinessType = this.isUnRegisteredBusinessType(kycData?.businessKycInformation);
        if (isUnRegisteredBusinessType) {
            return false;
        }

        return (
            kycData?.cacAffiliatesVerificationStatus === TimelineStatus.IN_PROGRESS || kycData?.cacVerificationStatus === TimelineStatus.IN_PROGRESS
        );
    }

    hasFailedCACVerification(kycData: any) {
        const isUnRegisteredBusinessType = this.isUnRegisteredBusinessType(kycData?.businessKycInformation);
        if (isUnRegisteredBusinessType) {
            return false;
        }

        return kycData?.cacAffiliatesVerificationStatus === TimelineStatus.FAILED || kycData?.cacVerificationStatus === TimelineStatus.FAILED;
    }

    hasRejectedCACVerification(kycData: any) {
        const isUnRegisteredBusinessType = this.isUnRegisteredBusinessType(kycData?.businessKycInformation);
        if (isUnRegisteredBusinessType) {
            return false;
        }
        return kycData?.cacAffiliatesVerificationStatus === TimelineStatus.REJECTED || kycData?.cacVerificationStatus === TimelineStatus.REJECTED;
    }

    hasCompletedCacVerification(status) {
        return status === TimelineStatus.SUCCESS;
    }

    getSupportingDocumentStatus(kycData) {
        const businessType = kycData?.businessKycInformation?.businessType;
        return businessType === KycBusinessTypeV2.REGISTERED ? kycData[KYCFormKeys.SUPPORTING_DOCUMENTS] : false;
    }

    getUpdatedKycLvl5Timeline = () => {
        const kycData = this.getKycDataV2();
        const cacVerificationStatus = kycData?.cacVerificationStatus === TimelineStatus.SUCCESS;
        const lvl5Steps = this.isAggregatorRole() ? this.getBrmTimeline(KYCLevel.LVL_5) : KYCLvl5FormSteps;
        lvl5Steps.forEach((step) => {
            if (step?.key === KYCFormKeys.SUPPORTING_DOCUMENTS) {
                step.isStepCompleted = this.getSupportingDocumentStatus(kycData);
            } else {
                const isCacForm = step?.key === KYCFormKeys.CAC_NUMBER;
                const isCompleted = kycData ? kycData[step?.key] || false : false;
                step.isStepCompleted = isCacForm ? cacVerificationStatus : isCompleted;
            }
        });
        return lvl5Steps;
    };

    setResidentAddressRejected(isRejected) {
        this.localStorage.save(StorageKeys.residentAddressRejected, JSON.stringify(isRejected));
    }

    setBusinessAddressRejected(isRejected) {
        this.localStorage.save(StorageKeys.businessAddressRejected, JSON.stringify(isRejected));
    }

    setKycAddressAccepted(isAddressAccepted) {
        this.localStorage.save(StorageKeys.kycAddressAccepted, JSON.stringify(isAddressAccepted));
    }

    isKycAddressAccepted() {
        const accepted = this.localStorage.get(StorageKeys.kycAddressAccepted) || 'false';
        return JSON.parse(accepted);
    }

    isResidentAddressRejected() {
        const rejected = this.localStorage.get(StorageKeys.residentAddressRejected) || 'false';
        return JSON.parse(rejected);
    }

    getBusinessAddressRejected() {
        const rejected = this.localStorage.get(StorageKeys.businessAddressRejected) || 'false';
        return JSON.parse(rejected);
    }

    getFullName() {
        const kycData = this.getKycDataV2();
        return `${kycData?.customerFirstName ?? ''} ${kycData?.customerLastName ?? ''}`;
    }

    isUserFromKycHarmonization() {
        const kycData = this.getKycDataV2();
        const isNotFromKycHarmonization = !kycData?.fromKycHarmonization;
        if (isNotFromKycHarmonization) {
            return false;
        }
        return this.isKycLevelZero();
    }

    hasCompletedKyc() {
        const kycLevelFiveStatus = this.getKycDataV2()?.kycLevelStatus?.kycLevelFiveStatus;
        if (StringHelper.isNullOrEmptyOrUndefined(kycLevelFiveStatus)) {
            return false;
        }
        return kycLevelFiveStatus === KycLvlState.COMPLETED;
    }

    hasCompletedBusinessNameReview() {
        return this.getKycDataV2()?.has_reviewed_all_businesses ?? false;
    }

    getUpdateKycLevelStatus(): any[] {
        const arr = [];
        const kycLevelStatus = this.getKycDataV2()?.kycLevelStatus;
        this.updateKycLevelStatus(arr, {
            status: KYCLevelStatusV2.kycLevelOneStatus,
            kycLevelStatus,
            lvl: KYCLevel.LVL_1,
        });
        this.updateKycLevelStatus(arr, {
            status: KYCLevelStatusV2.kycLevelTwoStatus,
            kycLevelStatus,
            lvl: KYCLevel.LVL_2,
        });
        this.updateKycLevelStatus(arr, {
            status: KYCLevelStatusV2.kycLevelThreeStatus,
            kycLevelStatus,
            lvl: KYCLevel.LVL_3,
        });
        this.updateKycLevelStatus(arr, {
            status: KYCLevelStatusV2.kycLevelFourStatus,
            kycLevelStatus,
            lvl: KYCLevel.LVL_4,
        });
        this.updateKycLevelStatus(arr, {
            status: KYCLevelStatusV2.kycLevelFiveStatus,
            kycLevelStatus,
            lvl: KYCLevel.LVL_5,
        });
        return arr;
    }

    updateKycLevelStatus(arr: any[], params) {
        if (StringHelper.isNullOrEmptyOrUndefined(params?.status)) {
            return;
        }
        const value = params?.kycLevelStatus ? params?.kycLevelStatus[params?.status] : '';
        arr.push({ name: params?.status, value, lvl: params?.lvl });
    }

    setKycDataV2(kycData: any) {
        if (!kycData) {
            this.localStorage.deleteValue(StorageKeys.kyc_lvl_form_data);
            return;
        }
        this.localStorage.save(StorageKeys.kyc_lvl_form_data, JSON.stringify(kycData));
    }

    saveFullName() {
        if (!this.canUseCustomerNameFromKycData()) {
            return;
        }
        const kycData = this.getKycDataV2();
        const firstName = kycData?.customerFirstName ?? this.localStorage.get('firstName');
        const lastName = kycData?.customerLastName ?? this.localStorage.get('lastName');
        this.localStorage.save('firstName', firstName);
        this.localStorage.save('lastName', lastName);
        this.localStorage.save(StorageKeys.fullname, `${firstName} ${lastName}`);
    }

    canUseCustomerNameFromKycData() {
        if (this.hasSubmittedBvn()) {
            return true;
        }
        return this.useKycNINFlow() ? this.hasSubmittedNin() : false;
    }

    handleFailedMetaMap(error, route) {
        this.setKycFormProgress(KYCFormKeys.providerIdentityVerificationStatus, TimelineStatus.FAILED);
        const description = error ?? KycDictionary.unable_to_verify_identity;
        this.alertService.setModalTitle(KycDictionary.Oops);
        this.alertService.setModalMessage(description);
        this.alertService.setRoute(route);
        this.routeToPage(KycRoutes.FAILED_MODAL);
    }

    handleVerifiedIdentity(route, params = null) {
        return new Promise(async (resolve) => {
            this.setKycFormProgress(KYCFormKeys.IDENTITY_VERIFICATION, true);
            this.setKycFormProgress(KYCFormKeys.bvnIdentityVerificationStatus, TimelineStatus.SUCCESS);
            this.setKycFormProgress(KYCFormKeys.providerIdentityVerificationStatus, TimelineStatus.SUCCESS);
            this.alertService.setModalTitle(params?.title || KycDictionary.Identity_Verified);
            this.alertService.setModalMessage(params?.description || KycDictionary.verified_successfully);
            this.alertService.setRoute(route);
            this.routeToPage(KycRoutes.SUCCESS_MODAL).then(() => {
                resolve(true);
            });
        });
    }

    handleVerificationInReview($event, route, callbackName = 'Close') {
        return new Promise(async (resolve) => {
            const description = $event || 'Your details have been collected but we will need to review it manually.';
            this.alertService.setModalTitle('Manual Review Needed');
            this.setKycFormProgress(KYCFormKeys.providerIdentityVerificationStatus, TimelineStatus.IN_REVIEW);
            this.alertService.setModalMessage(description);
            this.alertService.setCallbackName(callbackName);
            this.alertService.setRoute(route);
            this.routeToPage(`/onboarding-v2/manual-review-modal`).then(() => {
                resolve(true);
            });
        });
    }

    setKycFormProgress(key, value) {
        const kycData = this.getKycDataV2() || {};
        kycData[key] = value;
        this.setKycDataV2(kycData);
    }

    hasCompletedStep(key) {
        const kycData = this.getKycDataV2();
        return kycData ? kycData[key] : false;
    }

    uploadDocumentV2(params): Promise<any> {
        const url = this.config.MONIEPOINT_ONBOARDING + `/api/v2/business-kycs/registered-business/document/upload`;
        return this.apiClientHelper.newPutAsFormDataForPromise(url, params);
    }

    getKycDataV2(): any {
        const kycFormData = this.localStorage.get(StorageKeys.kyc_lvl_form_data);
        if (!kycFormData) {
            return DefaultKycData;
        }
        return JSON.parse(kycFormData);
    }

    isKycLevelZero() {
        const kycData = this.getKycDataV2();
        const kycLevel = kycData?.businessKycInformation?.kycLevel;
        return kycLevel === KYCLevel.LVL_0;
    }

    isKycLevelOne() {
        const kycData = this.getKycDataV2();
        const kycLevel = kycData?.businessKycInformation?.kycLevel;
        return kycLevel === KYCLevel.LVL_1;
    }

    isKycLevelTwo() {
        const kycData = this.getKycDataV2();
        const kycLevel = kycData?.businessKycInformation?.kycLevel;
        return kycLevel === KYCLevel.LVL_2;
    }

    isKycLevelThree() {
        const kycData = this.getKycDataV2();
        const kycLevel = kycData?.businessKycInformation?.kycLevel;
        return kycLevel === KYCLevel.LVL_3;
    }

    shouldTriggerKycLvl3UpgradeFlow(includePending = true): boolean {
        const isKycLevel2or3 = this.isKycLevelTwo() || this.isKycLevelThree();
        const canUseNewBOKYCLevel3Flow = this.useNewBOKYCLevel3Flow() && !this.isAggregatorRole();
    
        if (!includePending) {
            return isKycLevel2or3 && canUseNewBOKYCLevel3Flow;
        }
    
        const isKycLevel3Pending = this.getKycDataV2()?.kycDashboardData?.kycLevelStatus?.kycLevelThreeStatus !== KycLvlState.COMPLETED;
        
        return isKycLevel2or3 && canUseNewBOKYCLevel3Flow && isKycLevel3Pending;
    }

    isAccountCreated() {
        return this.isKycLevelZero() || !this.kycNotFound();
    }

    kycNotFound() {
        const kycData = this.getKycDataV2();
        const kycLevel = kycData?.businessKycInformation?.kycLevel;
        return StringHelper.isNullOrEmptyOrUndefined(kycLevel);
    }

    hasCompletedNin() {
        const kycData = this.getKycDataV2();
        return kycData?.has_completed_nin || false;
    }

    hasSubmittedNin() {
        const kycData = this.getKycDataV2();
        return kycData?.hasSubmittedNin || false;
    }

    hasSubmittedResidentialProofOfAddress() {
        const kycData = this.getKycDataV2();
        return kycData?.has_proof_of_address || false;
    }

    canSkipKycResidentialAddressStep() {
        if (this.canReUploadPhysicalProofOfAddress()) {
            return false;
        }

        return (
            this.hasResidentialPhysicalAddressApproved() ||
            this.hasResidentialPhysicalAddressAwaitingApproval() ||
            this.hasResidentialPhysicalAddressRejectedTerminal()
        );
    }

    canReUploadPhysicalProofOfAddress() {
        return this.isResidentialAddressRejected() || this.hasResidentialPhysicalAddressRejected();
    }

    hasResidentialPhysicalAddressApproved() {
        const addressVerificationStatus = this.getResidentialPhysicalAddressVerificationStatus();
        return addressVerificationStatus === TimelineStatus.APPROVED;
    }

    hasResidentialPhysicalAddressRejectedTerminal() {
        const addressVerificationStatus = this.getResidentialPhysicalAddressVerificationStatus();
        return addressVerificationStatus === TimelineStatus.REJECTED_TERMINAL;
    }

    getResidentialPhysicalAddressVerificationStatus() {
        const kycData = this.getKycDataV2();
        return kycData?.residentialPhysicalAddressVerificationStatus;
    }

    hasResidentialPhysicalAddressRejected() {
        const addressVerificationStatus = this.getResidentialPhysicalAddressVerificationStatus();
        return addressVerificationStatus === TimelineStatus.REJECTED;
    }

    hasResidentialPhysicalAddressAwaitingApproval() {
        const addressVerificationStatus = this.getResidentialPhysicalAddressVerificationStatus();
        return addressVerificationStatus === TimelineStatus.AWAITING_APPROVAL;
    }

    hasResidentialPhysicalAddressNotDone() {
        const addressVerificationStatus = this.getResidentialPhysicalAddressVerificationStatus();
        return addressVerificationStatus === TimelineStatus.NOT_DONE;
    }

    hasSubmittedBusinessProofOfAddress() {
        const kycData = this.getKycDataV2();
        return kycData?.has_business_proof_of_address || false;
    }

    hideResidentialProofOfAddress() {
        if (!this.hasSubmittedResidentialProofOfAddress()) return false;
        return this.isResidentialAddressAwaitingApproval() || this.isResidentialAddressApproved();
    }

    hideBusinessProofOfAddress() {
        if (!this.hasSubmittedBusinessProofOfAddress()) return false;
        return this.isBusinessAddressAwaitingApproval() || this.isBusinessAddressApproved();
    }

    hasSubmittedNinForm() {
        return this.hasCompletedNin() || this.hasSubmittedNin();
    }

    hasSubmittedBvnOrNin() {
        return this.hasSubmittedNinForm() || this.hasSubmittedBvnForm();
    }

    hasSubmittedBvnForm() {
        return this.hasCompletedBvn() || this.hasSubmittedBvn();
    }

    hasCompletedBvn() {
        const kycData = this.getKycDataV2();
        return kycData?.has_completed_bvn || false;
    }

    saveKycLevel1BvnData(bvn: string) {
        const kycData = this.getKycDataV2();
        kycData.bvn = bvn;
        kycData.livenessVerificationIdentitySource = KYC_IDENTITY_TYPE.BVN;
        kycData.hasSubmittedBvn = true;
        kycData.bankVerificationNumber = bvn;
        this.setKycDataV2(kycData);
    }

    getBusinessKycInformation() {
        return this.getKycDataV2()?.businessKycInformation;
    }

    hasBusinessNameVerified() {
        const kycData = this.getKycDataV2();
        const businessName = kycData?.businessKycInformation?.businessName?.trim();
        return (
            !!businessName &&
            kycData?.cacVerificationStatus &&
            kycData?.cacAffiliatesVerificationStatus &&
            kycData?.cacVerificationStatus === KycLvlState.SUCCESS &&
            kycData?.cacAffiliatesVerificationStatus === KycLvlState.SUCCESS
        );
    }

    async getKycDataV3() {
        const kycData = this.getKycDataV2();
        if (!kycData) {
            return await this.getKYCDataV2();
        }

        return kycData;
    }

    getSuccessModalTitle(hasProfile?) {
        const kycData = this.getKycDataV2();
        hasProfile = hasProfile ?? kycData?.hasProfile;
        return !hasProfile ? this.SUCCESS_MODAL_TITLE : this.SUCCESS_MODAL_TITLE_V2;
    }

    getSuccessModalTitleV2(status, hasProfile?) {
        const kycData = this.getKycDataV2();
        hasProfile = hasProfile ?? kycData?.hasProfile;
        if (!hasProfile) {
            return this.SUCCESS_MODAL_TITLE_V5;
        }
        const completed = status === KycLvlState.SUBMITTED || status === KycLvlState.COMPLETED;
        return completed ? this.SUCCESS_MODAL_TITLE_V4 : this.SUCCESS_MODAL_TITLE_V3;
    }

    hasVerifiedId() {
        const kycData = this.getKycDataV2();
        return kycData?.has_completed_identity_verification;
    }

    hasSubmittedIndemnity() {
        const kycData = this.getKycDataV2();
        return kycData[KYCFormKeys.INDEMNITY];
    }

    hasSubmittedLiveliness() {
        const kycData = this.getKycDataV2();
        return kycData[KYCFormKeys.LIVELINESS];
    }

    hasCompletedLiveliness() {
        const kycData = this.getKycDataV2();
        const hasDoneLiveliness = this.isNinOrBvnCompleted();
        const providerLivelinessVerificationStatus = this.isSuccessStatus(kycData?.providerLivelinessVerificationStatus);
        const hasCompletedLivelinessVerificationForm = kycData?.has_completed_liveliness_verification;
        return hasDoneLiveliness && hasCompletedLivelinessVerificationForm && providerLivelinessVerificationStatus;
    }

    hasCompletedIdVerification() {
        return this.isSuccessStatus(this.getProviderIdentityVerificationStatus());
    }

    getProviderIdentityVerificationStatus() {
        const kycData = this.getKycDataV2();
        return kycData?.providerIdentityVerificationStatus;
    }

    handleHasProfile() {
        const fromKycHarmonization = this.isUserFromKycHarmonization();
        const brmKycLvl1Steps = this.getBrmKycLevelOneStep();
        if (fromKycHarmonization) {
            return brmKycLvl1Steps.RESIDENTIAL_ADDRESS;
        }
        if (this.useBrmKycBvnNationality() && hasNationalityStep(brmKycLvl1Steps)) {
            return brmKycLvl1Steps.NATIONALITY;
        }
        const hasProfile = this.getKycDataV2()?.has_completed_contact_details;
        return hasProfile ? brmKycLvl1Steps.RESIDENTIAL_ADDRESS : brmKycLvl1Steps.CUSTOMER_INFORMATION;
    }

    savedDataRejection(kycData, isPersonalAddress) {
        if (isPersonalAddress) {
            kycData.kycDashboardData.businessOwnerUtilityVerificationStatus = KycLvlState.AWAITING_APPROVAL;
            return;
        }
        kycData.kycDashboardData.kycVerificationStatus = KycLvlState.AWAITING_APPROVAL;
        this.setKycDataV2(kycData);
    }

    saveBusinessDetailsV2(params, businessTypes: any[]) {
        this.saveSelectedBusinessType(params.registeredBusinessType, businessTypes);
        const kycData = this.getKycDataV2();
        const businessKycInformation = kycData.businessKycInformation;
        this.updateBusinessKycInformation(businessKycInformation, params);
        kycData.businessKycInformation = businessKycInformation;
        kycData.cacVerificationStatus = TimelineStatus.SUCCESS;

        if (!this.useBusinessAffiliateFlow()) {
            kycData.cacAffiliatesVerificationStatus = TimelineStatus.SUCCESS;
        }

        this.setKycDataV2(kycData);
    }

    updateBusinessKycInformation(businessKycInformation, params) {
        businessKycInformation.registeredBusinessType = params.registeredBusinessType;
        businessKycInformation.cacbusinessRegistrationNumber = params?.cacNumber;
        businessKycInformation.businessName = params?.businessName;
        businessKycInformation.businessType = KycBusinessTypeV2.REGISTERED;
    }

    getCacbusinessRegistrationNumber() {
        const kycData = this.getKycDataV2();
        const businessKycInformation = kycData?.businessKycInformation;
        return businessKycInformation?.cacbusinessRegistrationNumber;
    }

    saveSelectedBusinessType(businessType, businessTypes: any[]) {
        businessType = businessType || KycBusinessType.BUSINESS_NAME;
        const selectedBusinessType = businessTypes.find((x) => x.businessType === businessType);
        this.setBusinessTypeDisplayName(selectedBusinessType.displayName);
        const businessQuestionnaire: BusinessQuestionnaire = { businessType, fields: selectedBusinessType.fields };
        let businessQuestionnaires: BusinessQuestionnaire[] = [];
        businessQuestionnaires.push(businessQuestionnaire);
        businessQuestionnaires = this.updateSelectedBusinessType(businessType, businessQuestionnaires, businessTypes);
        this.setBusinessFormQuestionnaire(businessQuestionnaires);
    }

    saveIncorporatedBusinessType(businessTypes: any[]) {
        const selectedBusinessType = businessTypes.find((x) => x.businessType === KycBusinessType.INCORPORATED_COMPANY);
        this.setBusinessTypeDisplayName(KycBusinessTypeDisplayName.INCORPORATED_COMPANY);
        const businessQuestionnaire: BusinessQuestionnaire = {
            businessType: KycBusinessType.INCORPORATED_COMPANY,
            fields: selectedBusinessType.fields,
        };
        const businessQuestionnaires: BusinessQuestionnaire[] = [];
        businessQuestionnaires.push(businessQuestionnaire);
        this.setBusinessFormQuestionnaire(businessQuestionnaires);
    }

    updateSelectedBusinessType(businessType, businessQuestionnaires, businessTypes: any[]) {
        if (businessType !== KycBusinessType.INCORPORATED_COMPANY_PRIVATE_A && businessType !== KycBusinessType.INCORPORATED_COMPANY_PRIVATE_B) {
            return businessQuestionnaires;
        }
        const additionBusinessTypes = businessTypes.filter(
            (x) =>
                x.businessType === KycBusinessType.INCORPORATED_COMPANY_PRIVATE_A ||
                x.businessType === KycBusinessType.INCORPORATED_COMPANY_PRIVATE_B,
        );
        const additionBusinessQuestionnaire: BusinessQuestionnaire[] = additionBusinessTypes.map((additionBusinessType) => ({
            businessType: additionBusinessType.businessType,
            fields: additionBusinessType.fields,
        }));
        businessQuestionnaires.push(...additionBusinessQuestionnaire);
        return businessQuestionnaires;
    }

    getSelectedBusinessTypeQuestionnaire(businessType, businessQuestionnaires, businessTypes: any[]) {
        if (businessType !== KycBusinessType.INCORPORATED_COMPANY_PRIVATE_B) {
            return businessQuestionnaires;
        }
        const additionBusinessType = businessTypes.find((x) => x.businessType === KycBusinessType.INCORPORATED_COMPANY_PRIVATE_A);
        const additionBusinessQuestionnaire: BusinessQuestionnaire = {
            businessType: KycBusinessType.INCORPORATED_COMPANY_PRIVATE_A,
            fields: additionBusinessType.fields,
        };
        businessQuestionnaires.push(additionBusinessQuestionnaire);
        return businessQuestionnaires;
    }

    setDirectorsFieldName(directorsFieldName) {
        this.localStorage.save('directorsFieldName', directorsFieldName);
    }

    getDirectorsFieldName() {
        return this.localStorage.get('directorsFieldName');
    }

    getDirectors() {
        const directors = this.localStorage.get('directors');
        if (directors && JSON.parse(directors).length) {
            return JSON.parse(directors);
        }
        return [];
    }

    businessAffiliate(params, type): Promise<any> {
        const url = this.config.MONIEPOINT_ONBOARDING + `/api/v1/business-kycs/business-affiliate/${type}`;
        return this.apiClientHelper.newPostAsFormDataForPromise(url, params);
    }

    businessBrmAffiliate(params, type, requestId): Promise<any> {
        const url = this.config.MONIEPOINT_ONBOARDING + `/api/v2/business-kycs/business-affiliate/${type}?requestId=${requestId}`;
        return this.apiClientHelper.postForPromise(url, params);
    }

    verifyCAC(params): Promise<any> {
        const url = this.config.MONIEPOINT_ONBOARDING + `/api/v1/business-owner-onboarding/level-4/cac-verification`;
        return this.apiClientHelper.postForPromise(url, params);
    }

    verifyCACViaBrm(params, requestId): Promise<any> {
        const url = this.config.MONIEPOINT_ONBOARDING + `/api/v1/business-owner-onboarding/level-4/cac-verification?requestId=${requestId}`;
        return this.apiClientHelper.postForPromise(url, params);
    }

    verifyCACFromDashboard(params, requestId?: string): Promise<BusinessNameDetails> {
        const url =
            this.config.MONIEPOINT_ONBOARDING +
            `/api/v2/business-owner-onboarding/level-4/cac-verification?isDashboardFlow=true` +
            (requestId ? `&requestId=${requestId}` : '');
        return this.apiClientHelper.postForPromise(url, params);
    }

    getCACVerificationStatus(): Promise<CacVerificationResponse> {
        const requestId = this.getKycRequestIdForBrmOnboardedUser();
        let url = this.config.MONIEPOINT_ONBOARDING + `/api/v1/business-owner-onboarding/level-4/cac-verification-status`;
        if (requestId) {
            url = `${url}?requestId=${requestId}`;
        }
        return this.apiClientHelper.getForPromise(url);
    }

    getCACVerificationStatusViaBrm(requestId: string): Promise<CacVerificationResponse> {
        const url = this.config.MONIEPOINT_ONBOARDING + `/api/v1/business-owner-onboarding/level-4/cac-verification-status?requestId=${requestId}`;
        return this.apiClientHelper.getForPromise(url);
    }

    confirmCacBusinessName(requestId?: string) {
        const url =
            this.config.MONIEPOINT_ONBOARDING +
            `/api/v1/business-owner-onboarding/level-4/confirm-business` +
            (requestId ? `?requestId=${requestId}` : '');
        return this.apiClientHelper.postForPromise(url, null);
    }

    declineCacBusinessName(requestId?: string) {
        const url =
            this.config.MONIEPOINT_ONBOARDING +
            `/api/v1/business-owner-onboarding/level-4/decline-business` +
            (requestId ? `?requestId=${requestId}` : '');
        return this.apiClientHelper.postForPromise(url, null);
    }

    upDateSupportingDocument(params): Promise<any> {
        const url = this.config.MONIEPOINT_ONBOARDING + `/api/v2/business-kycs/registered-business/information`;
        return this.apiClientHelper.putForPromiseI(url, params);
    }

    deleteDirector(id, directors) {
        const index = directors.map((value) => value.id).indexOf(id);
        if (index > -1) {
            directors.splice(index, 1);
        }
        this.localStorage.save('directors', JSON.stringify(directors));
    }

    deleteAffiliate(id): Promise<any> {
        const url = this.config.MONIEPOINT_ONBOARDING + `/api/v1/business-kycs/business-affiliate/${id}`;
        return this.apiClientHelper.delete(url);
    }

    getSoftOnboardingContactDetails() {
        if (this.softOnboardingContactDetails) {
            return Promise.resolve(this.softOnboardingContactDetails);
        }
        const url = this.config.MONIEPOINT_USER_URL + `/api/v2/user-management/user-profile`;
        return this.apiClientHelper.getForPromise(url).then((res) => {
            this.softOnboardingContactDetails = res;
            return res;
        });
    }

    updateSoftOnboardingContactDetails(params) {
        const url = this.config.MONIEPOINT_ONBOARDING + `/api/v1/soft-onboarding/business/contact-information`;
        return this.apiClientHelper.postForPromise(url, params);
    }

    async routeToPage(route: string) {
        return this.router.navigateByUrl(route);
    }

    routeToKyc() {
        this.router.navigateByUrl(this.KYC);
    }

    routeToKycV2() {
        return this.router.navigateByUrl(this.KYC);
    }

    isBrmOnboardedAccount() {
        return this.isAggregatorRole();
    }

    allowSignup() {
        return this.config.ALLOW_SIGN_UP;
    }

    allowSignupForBrm() {
        return this.config.ALLOW_SIGN_UP_FOR_BRM;
    }

    routeToBODashboard() {
        this.router.navigateByUrl(this.DASHBOARD_ROUTE);
    }

    routeToBODashboardV2() {
        return this.router.navigateByUrl(this.DASHBOARD_ROUTE);
    }

    routeToBrmDashboard() {
        this.router.navigateByUrl(KycRoutes.BRM_DASHBOARD);
    }

    routeToBrmDashboardV2() {
        return this.router.navigateByUrl(KycRoutes.BRM_DASHBOARD);
    }

    isVerifiedAddress() {
        return this.isBusinessAddressApproved() && this.isResidentialAddressApproved();
    }

    isBusinessAddressApproved() {
        const isPersonalAddressForBusiness = this.isPersonalAddressForBusiness();
        if (isPersonalAddressForBusiness) {
            return this.isResidentialAddressApproved();
        }
        const kycDashboardData = this.getKycDashboardData();
        return this.isCompletedLvl(kycDashboardData?.kycVerificationStatus);
    }

    getKycDashboardData() {
        const kycData = this.getKycDataV2();
        return kycData?.kycDashboardData;
    }

    isPersonalAddressForBusiness() {
        const kycData = this.getKycDataV2();
        const businessKycInformation = kycData?.businessKycInformation;
        return businessKycInformation?.isPersonalAddressForBusiness || false;
    }

    isResidentialAddressApproved() {
        const kycData = this.getKycDataV2();
        const residentialPhysicalAddressVerificationStatus = kycData?.residentialPhysicalAddressVerificationStatus;
        return this.isCompletedLvl(residentialPhysicalAddressVerificationStatus);
    }

    isResidentialAddressRejected() {
        const kycDashboardData = this.getKycDashboardData();
        const businessOwnerUtilityVerificationStatus = kycDashboardData?.businessOwnerUtilityVerificationStatus;
        return (
            businessOwnerUtilityVerificationStatus === TimelineStatus.REJECTED ||
            businessOwnerUtilityVerificationStatus === TimelineStatus.REJECTED_TERMINAL
        );
    }

    isResidentialAddressAwaitingApproval() {
        const kycData = this.getKycDataV2();
        const residentialPhysicalAddressVerificationStatus = kycData?.residentialPhysicalAddressVerificationStatus;
        return this.isAwaitingApproval(residentialPhysicalAddressVerificationStatus);
    }

    isBusinessAddressAwaitingApproval() {
        const isPersonalAddressForBusiness = this.isPersonalAddressForBusiness();
        if (isPersonalAddressForBusiness) {
            return this.isResidentialAddressAwaitingApproval();
        }
        const kycDashboardData = this.getKycDashboardData();
        return this.isAwaitingApproval(kycDashboardData?.kycVerificationStatus);
    }

    markResidentialProofOfAddressAsApproved() {
        const kycData = this.getKycDataV2();
        const kycDashboardData = kycData?.kycDashboardData ?? { businessOwnerUtilityVerificationStatus: null };
        kycDashboardData.businessOwnerUtilityVerificationStatus = KycLvlState.APPROVED;
        kycData.kycDashboardData = kycDashboardData;
        this.setKycDataV2(kycData);
    }

    markBusinessProofOfAddressAsApproved() {
        const kycData = this.getKycDataV2();
        const kycDashboardData = kycData?.kycDashboardData ?? { kycVerificationStatus: null };
        kycDashboardData.kycVerificationStatus = KycLvlState.APPROVED;
        kycData.kycDashboardData = kycDashboardData;
        this.setKycDataV2(kycData);
    }

    routeToBusinessOwnerListDashboard() {
        this.router.navigateByUrl(KycRoutes.BUSINESS_OWNER_LIST_DASHBOARD);
    }

    routeToBusinessOwnerListNonCompliant() {
        this.router.navigateByUrl(KycRoutes.BUSINESS_OWNER_LIST_NON_COMPLIANT);
    }

    routeToBrmKycLvl2LastPage() {
        const kycData = this.getKycDataV2();
        const hasPassedIdVerification =
            kycData?.bvnIdentityVerificationStatus === TimelineStatus.SUCCESS &&
            kycData?.providerIdentityVerificationStatus === TimelineStatus.SUCCESS;
        const route = hasPassedIdVerification ? KycRoutes.BRM_KYC_LVL_2_SUCCESS_MODAL : KycRoutes.BRM_LVL_2_MANUAL_REVIEW;
        return this.routeToPage(route);
    }

    getDefaultKycLvlStatus() {
        return {
            kycLevelOneStatus: KycLvlState.NOT_STARTED,
            kycLevelTwoStatus: KycLvlState.NOT_STARTED,
            kycLevelThreeStatus: KycLvlState.NOT_STARTED,
            kycLevelFourStatus: KycLvlState.NOT_STARTED,
            kycLevelFiveStatus: KycLvlState.NOT_STARTED,
        };
    }

    getKycProgress() {
        const kycData = this.getKycDataV2();
        const kycLevelStatus = kycData?.kycLevelStatus;
        const kycProgress = DefaultKycProgress;
        kycProgress.forEach((e) => {
            e.state = this.getKycProgressWithName(e.lvl, kycLevelStatus);
        });

        if (this.isUpgradingFromPartnerMfe()) {
           const filterdProgress = kycProgress.filter(p => p.lvl <= 3);
           return filterdProgress;
        }

        return kycProgress;
    }

    upgradeKyc() {
        const currentLvl = this.getCurrentBusinessKycLvl();
        this.routeToKycPrimer(currentLvl);
    }

    getCurrentBusinessKycLvl() {
        const kycData = this.getKycDataV2();
        const kycLevelStatus = kycData?.kycLevelStatus;
        if (!kycLevelStatus) {
            return KYCLevel.LVL_1;
        }
        return this.getUpdatedCurrentLvl(kycLevelStatus);
    }

    getCurrentBusinessKycLvlV2() {
        return this.getKycDataV2()?.businessKycInformation?.kycLevel;
    }

    hasCompletedLvl1() {
        const kycData = this.getKycDataV2();
        const status = kycData?.kycLevelStatus?.kycLevelOneStatus;
        return this.isCompletedLvl(status);
    }

    isCompletedLvl(status) {
        return status === KycLvlState.COMPLETED || status === KycLvlState.APPROVED;
    }

    isAwaitingApproval(status) {
        return status === KycLvlState.AWAITING_APPROVAL;
    }

    isUnCompletedLvl(status) {
        return status === KycLvlState.STARTED || status === KycLvlState.NOT_STARTED;
    }

    isInReviewLvl(status) {
        return status === KycLvlState.SUBMITTED;
    }

    updateProgressWithPreviousLvl(previousLvlStatus, currentLvlStatus) {
        if (currentLvlStatus !== KycLvlState.NOT_STARTED) {
            return currentLvlStatus;
        }
        return previousLvlStatus === KycLvlState.COMPLETED ? KycLvlState.STARTED : currentLvlStatus;
    }

    getKycProgressWithName(lvl, kycLevelStatus) {
        if (!kycLevelStatus) {
            return KycLvlState.NOT_STARTED;
        }
        switch (lvl) {
            case KYCLevel.LVL_1:
                return kycLevelStatus?.kycLevelOneStatus === !kycLevelStatus?.kycLevelOneStatus
                    ? KycLvlState.NOT_STARTED
                    : kycLevelStatus?.kycLevelOneStatus;
            case KYCLevel.LVL_2:
                return this.updateProgressWithPreviousLvl(kycLevelStatus?.kycLevelOneStatus, kycLevelStatus?.kycLevelTwoStatus);
            case KYCLevel.LVL_3:
                return this.updateProgressWithPreviousLvl(kycLevelStatus?.kycLevelTwoStatus, kycLevelStatus?.kycLevelThreeStatus);
            case KYCLevel.LVL_4:
                return this.updateProgressWithPreviousLvl(kycLevelStatus?.kycLevelThreeStatus, kycLevelStatus?.kycLevelFourStatus);
            case KYCLevel.LVL_5:
                return this.updateProgressWithPreviousLvl(kycLevelStatus?.kycLevelFourStatus, kycLevelStatus?.kycLevelFiveStatus);
        }
    }

    getLimitWithLvl(lvl: number, childKey: string) {
        const kycData = this.getKycDataV2();
        const kycLevelTransactionLimit = kycData?.kycLevelTransactionLimit;
        if (!kycLevelTransactionLimit) {
            return '';
        }
        const key = KycLevelTransactionLimitKeys.find((x) => x.lvl === lvl)?.key;
        const kycLevelTransLimit = kycLevelTransactionLimit[key];
        return this.getLimit(kycLevelTransLimit[childKey]);
    }

    getLimit(value) {
        if (value === '0' || value === 0) {
            return 'Unlimited';
        }
        return StringHelper.numbersOnly(value) ? `₦${StringHelper.formatNumberToThousands(value)}` : value;
    }

    getPreviousPrimerRoute() {
        const route = this.localStorage.get(StorageKeys.kyc_group_primer_route);
        if (!route) {
            return KYCPrimerRoutes.find((x) => x.level === KYCLevel.LVL_1)?.route;
        }
        return route;
    }

    handleNoKycPendingInfo() {
        const isBrm = this.isAggregatorRole();
        const route = isBrm ? KycRoutes.BRM_DASHBOARD : KycRoutes.BO_DASHBOARD;
        this.setPreviousPrimerRoute(route);
        this.routeToPage(KycRoutes.BO_GENERAL_KYC_PRIMER);
    }

    handleNoKycPendingInfoV2() {
        const isBrm = this.isAggregatorRole();
        const route = isBrm ? KycRoutes.BRM_DASHBOARD : KycRoutes.BO_DASHBOARD;
        this.setPreviousPrimerRoute(route);
        return this.routeToPage(KycRoutes.BO_GENERAL_KYC_PRIMER);
    }

    setPreviousPrimerRoute(route) {
        if (!route) {
            this.localStorage.deleteValue(StorageKeys.kyc_group_primer_route);
        }
        this.localStorage.save(StorageKeys.kyc_group_primer_route, route);
    }

    setBlackListedBusinessName(name) {
        if (!name) {
            this.localStorage.deleteValue(StorageKeys.black_listed_name);
        }
        this.localStorage.save(StorageKeys.black_listed_name, name);
    }

    getBlackListedBusinessName() {
        const name = this.localStorage.get(StorageKeys.black_listed_name);
        if (StringHelper.isNullOrEmptyOrUndefined(name)) {
            return null;
        }
        return name;
    }

    setAllowedBlackListedName(name) {
        if (!name) {
            this.localStorage.deleteValue(StorageKeys.allow_black_listed_name);
        }
        this.localStorage.save(StorageKeys.allow_black_listed_name, name);
    }

    getAllowedBlackListedName() {
        const name = this.localStorage.get(StorageKeys.allow_black_listed_name);
        if (StringHelper.isNullOrEmptyOrUndefined(name)) {
            return '';
        }
        return name;
    }

    setPreviousBusinessInfoRoute(route) {
        if (!route) {
            this.localStorage.deleteValue(StorageKeys.business_info_route);
        }
        this.localStorage.save(StorageKeys.business_info_route, route);
    }

    getPreviousBusinessInfoRoute() {
        const route = this.localStorage.get(StorageKeys.business_info_route);
        if (StringHelper.isNullOrEmptyOrUndefined(route)) {
            return;
        }
        return route;
    }

    setBlacklistedNameVerificationRedirectRoute(route?: string | null) {
        if (!route) {
            this.localStorage.deleteValue(StorageKeys.business_name_metamap_verification_redirect_route);
        }
        this.localStorage.save(StorageKeys.business_name_metamap_verification_redirect_route, route);
    }

    getBlacklistedNameVerificationRedirectRoute(): string | null {
        const route = this.localStorage.get(StorageKeys.business_name_metamap_verification_redirect_route);
        if (StringHelper.isNullOrEmptyOrUndefined(route)) {
            return;
        }
        return route;
    }

    usePartnerMfeUpgradeFlow() {
        return AppConfig.SHOW_PARTNER_UPGRADE_MFE;
    }

    isUpgradingFromPartnerMfe() {
        if (this.usePartnerMfeUpgradeFlow()) {  
            const isFromPartnerMfeUpgrade = this.localStorage.get(StorageKeys.PARTNER_MFE_UPGRADE);
            return !!isFromPartnerMfeUpgrade;
        }
        return false;
    }

    hasPartnerRole() {
        const roles = JSON.parse(this.localStorage.get(StorageKeys.roles)) ?? [];
        return roles.some((role) => role === UserAlias.aggregator || role === UserAlias.marketer || role === UserAlias.kioskMarketer);
    }

    shouldTreatPartnerAsAggregator() {
        const roles = JSON.parse(this.localStorage.get(StorageKeys.roles)) ?? [];
        if (roles.length) {
            const isPartner = this.hasPartnerRole();
            const isBO = roles.some((role) => role === UserAlias.agentManager);
            const bothBOAndPartner = isPartner && isBO;
            if (bothBOAndPartner) {
                return this.isUpgradingFromPartnerMfe();
            }
            return isPartner;
        }
        return false;
    }

    isAggregatorRole() {
        const role = this.localStorage.getUserRole();
        if (this.usePartnerMfeUpgradeFlow()) {
            return this.shouldTreatPartnerAsAggregator();
        }
        return role === UserAlias.aggregator;
    }

    getCurrentUserEmail() {
        const email = this.localStorage.get(StorageKeys.email);
        return email;
    }

    getCurrentUserName() {
        const username = this.localStorage.get(StorageKeys.username)
        return username;
    }

    getAccountName() {
        const kycData = this.getKycDataV2();
        return kycData?.accountName || '';
    }

    setAdaptor(selectAdaptor: SelectAdaptor[], arr: any[]) {
        selectAdaptor = [];
        arr.forEach((e) => {
            const label = e?.name || e?.key || e;
            const value = e?.id || e?.documentType || e?.value || e;
            const icon = e?.icon || e?.sample;
            selectAdaptor.push({ label, value, icon });
        });
        return selectAdaptor;
    }

    updateBusinessAffiliate(params, id): Promise<any> {
        const url = this.config.MONIEPOINT_ONBOARDING + `/api/v1/business-kycs/business-affiliate/${id}`;
        return this.apiClientHelper.newPutAsFormDataForPromise(url, params, true);
    }

    updateBrmBusinessAffiliate(params, id, requestId): Promise<any> {
        const url = this.config.MONIEPOINT_ONBOARDING + `/api/v1/business-kycs/business-affiliate/${id}?requestId=${requestId}`;
        return this.apiClientHelper.newPutAsFormDataForPromise(url, params);
    }

    getProofOfAddressType(): Promise<any> {
        const url = this.config.MONIEPOINT_ONBOARDING + `/api/v2/business-kycs/proof-of-address-types`;
        return this.apiClientHelper.getForPromise(url, true);
    }

    getIdentificationType(): Promise<any> {
        const url = this.config.MONIEPOINT_ONBOARDING + `/api/v2/business-kycs/id-types`;
        return this.apiClientHelper.getForPromise(url, true);
    }

    addDirector(value) {
        value.id = Math.floor(Math.random() * 10);
        let directors = JSON.parse(this.localStorage.get('directors'));
        if (directors && directors.length) {
            directors.push(value);
        } else {
            directors = [];
            directors = [value];
        }
        this.localStorage.save('directors', JSON.stringify(directors));
    }

    getOnboardingFormData(): OnboardingFormData {
        const onboardingFormData = this.localStorage.get(StorageKeys.on_boarding_form_data);
        if (!onboardingFormData) {
            return DefaultOnboardingData;
        }
        return JSON.parse(onboardingFormData);
    }

    setPhoneNumberValidationKey(key) {
        if (!key) {
            this.localStorage.deleteValue(StorageKeys.phone_number_validation_key);
            return;
        }
        this.localStorage.save(StorageKeys.phone_number_validation_key, key);
    }

    getPhoneNumberValidationKey() {
        return this.localStorage.get(StorageKeys.phone_number_validation_key) || null;
    }

    setBvnDateOfBirth(dateOfBirth) {
        this.bvnDateOfBirth = dateOfBirth;
    }

    getRegisteredBusinessTypes(): Promise<any> {
        const url = this.config.MONIEPOINT_ONBOARDING + `/api/v1/business-kycs/registered-business-types`;
        return this.apiClientHelper.getForPromise(url);
    }

    getRegisteredBusinessTypesV2(): Promise<any> {
        const url = this.config.MONIEPOINT_ONBOARDING + `/api/v1/business-owner-onboarding/level-4/registered-business-types`;
        return this.apiClientHelper.getForPromise(url);
    }

    isRegisteredBusinessType() {
        const businessKycInformation = this.getKycDataV2()?.businessKycInformation;
        return businessKycInformation?.businessType === KycBusinessTypeV2.REGISTERED;
    }

    isUnRegisteredBusinessType(businessKycInformation) {
        return businessKycInformation?.businessType === KycBusinessTypeV2.UNREGISTERED;
    }

    isRejectionLevel(level: KYCLevelStatusV2) {
        const kycLevelStatus = this.getKycDataV2()?.kycLevelStatus;
        return kycLevelStatus ? kycLevelStatus[level] === 'REJECTED' : false;
    }

    getBusinessAffiliatePayload(form, identificationFile, proofOfAddressFile) {
        return {
            emailAddress: form.emailAddress,
            firstName: form.firstName,
            lastName: form.lastName,
            phoneNumber: form.phoneNumber,
            percentageOwned: Number(form.percentageOwned),
            dateOfBirth: moment(form.dateOfBirth).format('YYYY-MM-DD'),
            identityDocumentType: form.identityDocumentType,
            documentNumber: form.documentNumber,
            houseAddress: form.houseAddress,
            localGovernmentId: form.lga,
            identityDocumentReference: identificationFile,
            proofOfAddressReference: proofOfAddressFile,
            proofOfAddressDocumentType: form?.proofOfAddressDocumentType,
        };
    }

    async initializeRegisteredBusinessTypes() {
        const businessTypes = await this.getRegisteredBusinessTypesV2();
        const businessKycInformation = this.getKycDataV2()?.businessKycInformation;
        const selectedType = businessKycInformation?.registeredBusinessType;
        if (selectedType === KycBusinessType.INCORPORATED_COMPANY) {
            this.handleIncorporatedCompany(businessTypes);
            return;
        }
        this.saveSelectedBusinessType(selectedType, businessTypes);
    }

    handleIncorporatedCompany(businessTypes: any[]) {
        this.saveIncorporatedBusinessType(businessTypes);
    }

    getMetaMapPersonalInfoReferenceObservable(): Observable<any> {
        const url = this.config.MONIEPOINT_HOST + `/api/v1/metamap-verification/generate-reference`;
        return this.apiClientHelper.getForObservable(url);
    }

    getMetaMapPersonalLivelinessReferenceStatus(reference: string): Observable<any> {
        const url = this.config.MONIEPOINT_HOST + `/api/v1/metamap-verification/${reference}/status/`;
        return this.apiClientHelper.getForObservable(url);
    }

    getCurrentKey(key, kycLevelStatus) {
        return kycLevelStatus[key] === KycLvlState.STARTED || kycLevelStatus[key] === KycLvlState.NOT_STARTED;
    }

    saveBoPresentInBrmOnboarding(present: number) {
        if (StringHelper.isNullOrEmptyOrUndefined(present)) {
            this.localStorage.deleteValue(StorageKeys.BO_PRESENT_IN_BRM_ONBOARDING);
            return;
        }
        this.localStorage.save(StorageKeys.BO_PRESENT_IN_BRM_ONBOARDING, JSON.stringify(present));
    }

    setHasProfile(hasProfile) {
        this.businessOwnerProfile = hasProfile;
    }

    hasProfile() {
        return this.businessOwnerProfile;
    }

    startedLvl(lvl) {
        if (StringHelper.isNullOrEmptyOrUndefined(lvl)) {
            this.localStorage.deleteValue('started_lvl');
        }
        this.localStorage.save('started_lvl', `${lvl}`);
    }

    getStartedLvl() {
        const startedLvl = this.localStorage.get('started_lvl');
        if (StringHelper.isNullOrEmptyOrUndefined(startedLvl)) {
            return null;
        }
        return JSON.parse(startedLvl);
    }

    setBrmLivenessType(livelinessType) {
        if (StringHelper.isNullOrEmptyOrUndefined(`${livelinessType}`)) {
            this.localStorage.deleteValue(StorageKeys.BRM_LIVELINESS_TYPE);
            return;
        }
        this.localStorage.save(StorageKeys.BRM_LIVELINESS_TYPE, livelinessType);
    }

    getBrmLivenessType() {
        const present = this.localStorage.get(StorageKeys.BRM_LIVELINESS_TYPE);
        if (StringHelper.isNullOrEmptyOrUndefined(present)) {
            return BrmLivelinessType.PASSPORT;
        }
        return JSON.parse(present);
    }

    getBoPresentInBrmOnboarding() {
        const present = this.localStorage.get(StorageKeys.BO_PRESENT_IN_BRM_ONBOARDING);
        if (StringHelper.isNullOrEmptyOrUndefined(present)) {
            return BrmKycOption.BRM_WITHOUT_BO;
        }
        return JSON.parse(present);
    }

    handleFailedReferenceRequest(error, route = '/onboarding-v2/kyc-lvl1', verificationType = MetaMapType.LIVELINESS) {
        return new Promise(async (resolve) => {
            const description = error?.error?.responseMessage || StringHelper.getErrorMessageHttpErrorResponse(error);
            const responseCode = error?.error?.responseCode;
            const title = this.getErrorTitle(responseCode);
            const alertType = this.getAlertTypeByResponseCode(responseCode);
            const callbackName = this.getModalCallbackNameByResponseCode(responseCode);
            const params = { description, title, alertType, callbackName };
            const hasDoneMetamap =
                verificationType === MetaMapType.LIVELINESS ? this.hasDoneLiveliness(responseCode) : this.hasDoneIdentity(responseCode);
            if (hasDoneMetamap) {
                this.updateKycData({ responseCode, verificationType });
                this.handleDoneLivelinessError(responseCode, params, error?.callbackName ?? params?.callbackName).then(() => {
                    resolve(CustomMetaMapErrorCode.META_MAP_DONE);
                });
            } else {
                const suspensionReleaseTime = error?.error?.suspensionReleaseTime;
                if (suspensionReleaseTime) {
                    this.handleSuspensionError(params, suspensionReleaseTime, route);
                    resolve(CustomMetaMapErrorCode.USER_SUSPENDED);
                } else {
                    this.launchErrorModal(params);
                    resolve(CustomMetaMapErrorCode.META_MAP_ERROR);
                }
            }
        });
    }

    updateKycData({ responseCode, verificationType }) {
        const status = verificationType === MetaMapType.LIVELINESS ? this.getLivelinessStatus(responseCode) : this.getIdentityStatus(responseCode);
        verificationType === MetaMapType.LIVELINESS ? this.updateKycLivelinessData(status) : this.updateKycIdentityData(status);
    }

    getLivelinessStatus(responseCode) {
        let status = TimelineStatus.PENDING;
        if (this.successfulLiveliness(responseCode)) {
            status = TimelineStatus.SUCCESS;
        }
        return this.livelinessInReview(responseCode) ? TimelineStatus.IN_REVIEW : status;
    }

    getIdentityStatus(responseCode) {
        let status = TimelineStatus.PENDING;
        if (this.successfulIdentity(responseCode)) {
            status = TimelineStatus.SUCCESS;
        }
        return this.identityInReview(responseCode) ? TimelineStatus.IN_REVIEW : status;
    }

    updateKycLivelinessData(status) {
        this.setKycFormProgress(KYCFormKeys.LIVELINESS, true);
        this.updateKycDataWithBvnOrNinStatus();
        this.updateKycDataVerificationStatusWithIdentitySource(status);
        this.setKycFormProgress(KYCFormKeys.providerLivelinessVerificationStatus, status);
    }

    updateKycDataVerificationStatusWithIdentitySource(status) {
        const useKycNINFlow = this.isAggregatorRole() ? this.useBrmKycNINFlow() : this.useKycNINFlow();
        const isNinIdentitySource = useKycNINFlow && this.isNinIdentitySource();
        isNinIdentitySource ? this.updateKycDataWithNinVerificationStatus(status) : this.updateKycDataWithBvnVerificationStatus(status);
    }

    updateKycDataWithBvnOrNinStatus() {
        const useKycNINFlow = this.isAggregatorRole() ? this.useBrmKycNINFlow() : this.useKycNINFlow();
        const key = useKycNINFlow ? KYCFormKeys.BVN_NIN_VERIFIED : KYCFormKeys.BVN_COMPLETED;
        this.setKycFormProgress(key, true);
    }

    updateKycDataWithBvnVerificationStatus(status) {
        this.setKycFormProgress(KYCFormKeys.BVN_COMPLETED, true);
        this.setKycFormProgress(KYCFormKeys.bvnIdentityVerificationStatus, status);
    }

    updateKycDataWithNinVerificationStatus(status) {
        this.setKycFormProgress(KYCFormKeys.NIN_COMPLETED, true);
        this.setKycFormProgress(KYCFormKeys.ninIdentityVerificationStatus, status);
    }

    updateKycIdentityData(status) {
        this.setKycFormProgress(KYCFormKeys.IDENTITY_VERIFICATION, true);
        this.setKycFormProgress(KYCFormKeys.bvnIdentityVerificationStatus, status);
        this.setKycFormProgress(KYCFormKeys.providerIdentityVerificationStatus, status);
    }

    handleSuspensionError(params, suspensionReleaseTime, route) {
        params.description = params.description || 'Oops, it seems you have too many failed identity verification attempts. ';
        this.alertService.setIdVerificationSuspensionDate(suspensionReleaseTime);
        this.alertService.setRoute(route);
        this.alertService.setModalMessage(params?.description);
        this.routeToPage(this.alertService.failedVerificationPage);
    }

    getErrorTitle(responseCode) {
        let title;
        switch (responseCode) {
            case ErrorCode.LIVELINESS_IN_PROGRESS:
                title = KycDictionary.Verification_in_Progress;
                break;
            case ErrorCode.LIVELINESS_IN_REVIEW:
            case ErrorCode.IDENTITY_REVIEW:
                title = KycDictionary.Verification_in_Review;
                break;
            case ErrorCode.LIVELINESS_SUCCESSFUL:
                title = KycDictionary.Verification_Successful;
        }
        return title;
    }

    getAlertTypeByResponseCode(responseCode) {
        switch (responseCode) {
            case ErrorCode.LIVELINESS_IN_PROGRESS:
                return 'info';
            case ErrorCode.LIVELINESS_IN_REVIEW:
            case ErrorCode.IDENTITY_REVIEW:
                return 'warning';
            case ErrorCode.LIVELINESS_SUCCESSFUL:
                return 'success';
            default:
                return 'error';
        }
    }

    getModalCallbackNameByResponseCode(responseCode) {
        switch (responseCode) {
            case ErrorCode.LIVELINESS_IN_PROGRESS:
            case ErrorCode.LIVELINESS_IN_REVIEW:
            case ErrorCode.IDENTITY_REVIEW:
                return 'Proceed';
            default:
                return 'Close';
        }
    }

    hasDoneLiveliness(responseCode) {
        return this.successfulLiveliness(responseCode);
    }

    hasDoneIdentity(responseCode) {
        return this.successfulIdentity(responseCode) || this.identityInReview(responseCode) || this.identityInProgress(responseCode);
    }

    successfulIdentity(responseCode) {
        return responseCode === ErrorCode.IDENTITY_SUCCESSFUL;
    }

    identityInReview(responseCode) {
        return responseCode === ErrorCode.IDENTITY_REVIEW;
    }

    identityInProgress(responseCode) {
        return responseCode === ErrorCode.IDENTITY_PROGRESS;
    }

    successfulLiveliness(responseCode) {
        return responseCode === ErrorCode.LIVELINESS_SUCCESSFUL;
    }

    livelinessInReview(responseCode) {
        return responseCode === ErrorCode.LIVELINESS_IN_REVIEW;
    }

    handleDoneLivelinessError(responseCode, params: any, callbackName = 'Close'): Promise<any> {
        return new Promise((resolve) => {
            params.callbackName = callbackName;
            this.launchErrorModalV2(params).then(() => {
                resolve(true);
            });
        });
    }

    getBrmLevel1Timeline() {
        if (this.isBranchBrm) {
            return this.getBranchBrmLevel1Timeline();
        }
        return this.getNonBranchBrmLevel1Timeline();
    }

    getBranchBrmLevel1Timeline() {
        if (this.useBrmEnhancedKycLvl1Flow()) {
            if (this.useBrmKycLvl1PreventHybridMerchant()) {
                return BranchBrmKycWBOLvl1StepsV6;
            }
            if (this.useAdditionBusinessDetailsKycLvl1()) {
                return BranchBrmKycWBOLvl1StepsV5;
            }
            return this.useBrmKycBvnNationality() ? BranchBrmKycWBOLvl1StepsV4 : BranchBrmKycWBOLvl1StepsV3;
        }
        return this.useBrmKycNINFlow() ? BrmKycWBOLvl1StepsBBRMV2 : BrmKycWBOLvl1StepsBBRM;
    }

    getNonBranchBrmLevel1Timeline() {
        if (this.useBrmEnhancedKycLvl1Flow()) {
            if (this.useBrmKycLvl1PreventHybridMerchant()) {
                return BrmKycWBOLvl1StepsV6;
            }
            if (this.useAdditionBusinessDetailsKycLvl1()) {
                return BrmKycWBOLvl1StepsV5;
            }
            return this.useBrmKycBvnNationality() ? BrmKycWBOLvl1StepsV4 : BrmKycWBOLvl1StepsV3;
        }
        return this.useBrmKycNINFlow() ? BrmKycWBOLvl1StepsV2 : BrmKycWBOLvl1Steps;
    }

    getBrmLevel2Timeline() {
        if (!this.useBrmKycNINFlow()) {
            return BrmKycWBOLvl2Steps;
        }
        const steps = this.useSimplifiedBrmKycLevel2Flow() ? BrmKycWBOLvl2StepsV3 : BrmKycWBOLvl2StepsV2;
        return this.getKycLevel2TimelineUpdatedWithNinFlow(steps);
    }

    getBrmTimeline(lvl: number) {
        switch (lvl) {
            case KYCLevel.LVL_2:
                return this.getBrmLevel2Timeline();
            case KYCLevel.LVL_3:
                return this.getBrmKycLvl3Timeline();
        }
    }

    getBrmKycLvl3Timeline() {
        const step = BrmKycBOLvl3Steps;
        if (this.useSimplifiedBrmKycLevel3Flow()) {
            step[0].description = KYCLvl3PhysicalAddressTimelines[0].description;
        }
        this.updateResidentialPhysicalAddressTimeline(step);
        return step;
    }

    getCurrentRoute({ lvl, defaultStep, lastStep, currentStep }) {
        const justStarted = StringHelper.isNullOrEmptyOrUndefined(this.getStartedLvl());
        if (justStarted) {
            return currentStep;
        }
        return this.getUnfilledForm({ lvl, defaultStep, lastStep });
    }

    routeBrmToContinueBoKyc(userData) {
        this.setHasProfile(userData?.hasProfile);
        this.setKycDataV2(userData);
        this.savedBvnData(userData);
        const rejectedLvl = this.getKycRejectedLvl();
        if (!StringHelper.isNullOrEmptyOrUndefined(rejectedLvl)) {
            this.routeToPage(KycRoutes.BRM_KYC_REJECTION_ROUTE);
            return;
        }
        const reviewLvl = this.getKycReviewLvl();
        if (reviewLvl) {
            this.routeToPage(KycRoutes.BRM_KYC_REVIEW_ROUTE);
            return;
        }
        this.routeToKyc();
    }

    routeBrmBackToKYCPrimer() {
        const rejectedLvl = this.getKycRejectedLvl();
        if (!StringHelper.isNullOrEmptyOrUndefined(rejectedLvl)) {
            this.routeToPage(KycRoutes.BRM_KYC_REJECTION_ROUTE);
            return;
        }
        const reviewLvl = this.getKycReviewLvl();
        if (reviewLvl) {
            this.routeToPage(KycRoutes.BRM_KYC_REVIEW_ROUTE);
            return;
        }
        this.routeToKyc();
    }

    async buildLivenessDataLayerPayload(event:string, error?: { errorCode?: string; errorMessage: string; }){
        const payload = await this.dataLayerHelper.buildOnboardingDataLayerPayload(event, error)
        const livelinessProvider = await this.getFaceVerificationProvider()
        const datalayerPayload = {...payload, auth_type_provider: livelinessProvider } satisfies typeof payload
        return datalayerPayload
    }

    async getFaceVerificationProvider() {
        if(this.useFacetecLiveliness() && !this.isAggregatorRole()){
            return IdentityProvider.FACETEC;
        }
        return await this.getLivelinessProvider()
    }
    getDataLayerPayload(event, data?: DatalayerPayload) {
        let payload = initializeDatalayer(event);
        if (!ObjectHelper.isEmpty(data)) {
            payload = {
                ...payload,
                ...data,
            };
        }
        return payload;
    }

    logDataLayerEvent(event, data?: DatalayerPayload) {
        const payload = this.getDataLayerPayload(event, data);
        this.dataLayerHelper.logEvent(payload);
    }

    private getUnfilledForm({ lvl, defaultStep, lastStep }) {
        const timeLine = this.getBrmTimeline(lvl);
        const kycData = this.getKycDataV2();
        if (StringHelper.isNullOrEmptyOrUndefined(kycData)) {
            return defaultStep;
        }
        const currentTime = timeLine.find((x) => !kycData[x.key]);
        if (StringHelper.isNullOrEmptyOrUndefined(currentTime)) {
            return lastStep;
        }
        return currentTime?.step;
    }

    private getKycLvlStep(steps: TimelineModel[]) {
        return steps?.find((x) => !x.isStepCompleted)?.step || this.DEFAULT_KYC_LVL_STEP; // improve
    }

    private navigateKycLvlForm({ lvl, step, isBrmBoOnboardingMode }) {
        switch (lvl) {
            case KYCLevel.LVL_1:
                this.navigateKycLvl1Form(step, isBrmBoOnboardingMode);
                break;
            case KYCLevel.LVL_2:
                this.navigateKycLvl2Form(step, isBrmBoOnboardingMode);
                break;
            case KYCLevel.LVL_3:
                this.navigateKycLvl3Form(step, isBrmBoOnboardingMode);
                break;
            case KYCLevel.LVL_4:
                this.navigateKycLvl4Form(step);
                break;
        }
    }

    private getUpdatedCurrentLvl(params): number {
        let currentLvl: any = KYCLevelStatusV2.kycLevelOneStatus;
        const keys = Object.keys(params);
        currentLvl = keys.find((key) => this.getCurrentKey(key, params)) || currentLvl;
        return Number(KYCLevelV2[currentLvl]);
    }

    private logMixpanelErrorEvent(params: any) {
        if (!params?.event) {
            return;
        }
        const mixpanelData = this.getMixpanelErrorData(params);
        if (params?.error) this.updateMixpanelEventWithApiErrorData(mixpanelData, params?.error);
        const mixpanelPayLoad = this.buildMixpanelPayload(mixpanelData);
        this.dataLayerHelper.logEvent(mixpanelPayLoad);
    }

    getMixpanelErrorData(params: any) {
        return {
            event: params?.event,
            step: params?.step,
            error_message: params?.description,
        };
    }

    updateMixpanelEventWithApiErrorData(mixpanelData: any, error: any) {
        mixpanelData.api_error_message = StringHelper.getMixpanelErrorMessage(error);
        mixpanelData.api_error_code = error?.status;
    }

    logMixpanelEvent(params: any) {
        const eventNotFound = StringHelper.isNullOrEmptyOrUndefined(params?.event);
        if (eventNotFound) {
            return;
        }
        const mixpanelPayLoad = this.buildMixpanelPayload(params);
        this.dataLayerHelper.logEvent(mixpanelPayLoad);
    }

    logEventForPhysicalAddressVerification(data: any) {
        const kyc_level = this.localStorage.get(StorageKeys.kyc_level);
        this.logMixpanelEvent({ ...data, kyc_level });
    }

    private buildMixpanelPayload(params: any) {
        let mixpanelPayLoad = initializeDatalayer('');
        mixpanelPayLoad = { ...mixpanelPayLoad, ...params };
        return mixpanelPayLoad;
    }

    logKycLevel3MixpanelEvent({event, params, kycStandingSteps}: KycLvl3LogMixpanelOptions) {
        const userEventData = this.getKycLvl3MixpanelUserEventData();

        let kycStandingStates = {}
        if(kycStandingSteps && this.kycStandingData){

            const level3Requirements = this.kycStandingData?.levels.find((level) => level.level === KYCLevel.LVL_3);

            for (let index in kycStandingSteps) {
                let kycStep = kycStandingSteps[index]
                const itemStatus = level3Requirements.requirements.find((item) => item.code === kycStep)?.status;
                kycStandingStates[KYCLvl3StepV3EventNames[kycStep]] = itemStatus
            }
        }

        const eventParams = {
            ...userEventData,
            ...(params ?? {}),
            ...kycStandingStates
        };
        const eventPayload = { ...eventParams, event };
        this.logMixpanelEvent(eventPayload);
    }


    canShowBRMCacIncompliantBo() {
        return this.config.SHOW_BRM_CAC_INCOMPLIANT_BO;
    }

    routeToDuplicateMergeFlow(res: any, type: string) {
        if (!this.config.USE_MERGE_DUPLICATE_PROFILE_FLOW) {
            return;
        }
        const bredCrumbs = MergeAccountProfileBreadCrumbs[type];
        res.breadCrumbs = bredCrumbs;
        this.localStorage.save(StorageKeys.DUPLICATE_PROFILE, JSON.stringify(res));
        this.router.navigateByUrl('/main-app/profile/merge-accounts');
    }

    canUseDuplicateProfileMergeFlow() {
        return this.config.USE_MERGE_DUPLICATE_PROFILE_FLOW;
    }

    getBusinessesWithRejectedAddressVerification(payload: any): Promise<any> {
        const urlString = StringHelper.toUrlString(payload);
        const url = this.config.MONIEPOINT_HOST + `/api/v2/business-owners/rejected-kycs?${urlString}`;
        return this.apiClientHelper.getForPromise(url);
    }

    saveSelectedBusinessOwnerWithRejectedAddress(businessOwner: any) {
        if (businessOwner) this.localStorage.save('selected_BusinessOwner_With_RejectedAddress', JSON.stringify(businessOwner));
    }

    getSelectedBusinessOwnerWithRejectedAddress() {
        const savedData = this.localStorage.get('selected_BusinessOwner_With_RejectedAddress');
        return savedData ? JSON.parse(savedData) : null;
    }

    isLivelinessFailureCauseByBvnOrNin(statusCode: string) {
        return (
            statusCode === AsyncLivenessStatusCode.INVALID_BVN_NIN ||
            statusCode === AsyncLivenessStatusCode.NIN_INVALID ||
            statusCode === AsyncLivenessStatusCode.BVN_INVALID ||
            statusCode === AsyncLivenessStatusCode.FACE_MATCH_FAILED ||
            statusCode === AsyncLivenessStatusCode.FIRST_TIME_USER_FOR_ASYNC_LIVELINESS
        );
    }

    canShowBrmKycCorrections() {
        return this.canShowKycCorrections() && this.config.SHOW_BRM_INCOMPLIANT_KYC_BANNER;
    }

    canShowKycCorrections() {
        return this.config.SHOW_INCOMPLIANT_KYC_BANNER;
    }

    private updateBusinessNameStorage(business: string) {
        this.localStorage.save(StorageKeys.businessName, business);
    }

    public saveNameFromBusinessDetails(businessNameDetails: BusinessNameDetail[]) {
        const businessId = this.getMoniepointAgentId();
        const business = businessNameDetails.find((business) => business.businessId === Number(businessId));
        this.updateBusinessNameStorage(business.currentBusinessName);
    }

    residentialAddressVerificationPopup(isClicked: boolean) {
        if (this.config.SHOW_ADDRESS_VERIFICATION_POP_UP_EVERY_LOGIN) return this.residentialAddressVerificationPopupV2(isClicked);

        this.cookieService.set('residential_address_verification_popup', JSON.stringify(isClicked), 360);
    }

    residentialAddressVerificationPopupV2(isClicked: boolean) {
        this.localStorage.save('residential_address_verification_popup', JSON.stringify(isClicked));
    }

    isClickedResidentialAddressVerificationPopup() {
        if (this.config.SHOW_ADDRESS_VERIFICATION_POP_UP_EVERY_LOGIN) return this.isClickedResidentialAddressVerificationPopupV2();

        const popup = this.cookieService.get('residential_address_verification_popup');
        if (!popup) return false;
        return JSON.parse(popup);
    }

    isClickedResidentialAddressVerificationPopupV2() {
        const popup = this.localStorage.get('residential_address_verification_popup');
        if (!popup) return false;
        return JSON.parse(popup);
    }

    businessAddressVerificationPopup(isClicked: boolean) {
        if (this.config.SHOW_ADDRESS_VERIFICATION_POP_UP_EVERY_LOGIN) return this.businessAddressVerificationPopupV2(isClicked);

        this.cookieService.set('business_address_verification_popup', JSON.stringify(isClicked), 360);
    }

    businessAddressVerificationPopupV2(isClicked: boolean) {
        this.localStorage.save('business_address_verification_popup', JSON.stringify(isClicked));
    }

    isClickedBusinessAddressVerificationPopup() {
        if (this.config.SHOW_ADDRESS_VERIFICATION_POP_UP_EVERY_LOGIN) return this.isClickedBusinessAddressVerificationPopupV2();

        const popup = this.cookieService.get('business_address_verification_popup');
        if (!popup) return false;
        return JSON.parse(popup);
    }

    isClickedBusinessAddressVerificationPopupV2() {
        const popup = this.localStorage.get('business_address_verification_popup');
        if (!popup) return false;
        return JSON.parse(popup);
    }

    residentialAddressNotSameAsBusinessForAddressRevalidation(isResidentialAddressSameAsBusiness: boolean) {
        this.localStorage.save('residential_address_not_same_as_business_for_address_revalidation', isResidentialAddressSameAsBusiness);
    }

    isResidentialAddressNotSameAsBusiness() {
        const isResidentialAddressSameAsBusiness = this.localStorage.get('residential_address_not_same_as_business_for_address_revalidation');
        if (!isResidentialAddressSameAsBusiness) return false;
        return JSON.parse(isResidentialAddressSameAsBusiness);
    }

    isResidentialAddressSameAsBusiness() {
        const kycData = this.getKycDataV2();
        const businessKycInformation = kycData?.businessKycInformation;
        return businessKycInformation?.isPersonalAddressForBusiness;
    }

    getFormatedAddress(res: OnboardingAddress) {
        const addressLineOne = res?.addressLineOne;
        const city = res?.city;
        const lga = res?.lga?.name;
        const state = res?.state?.name;
        return this.mergeAddressDetails(addressLineOne, city, lga, state);
    }

    mergeAddressDetails(addressLineOne: string, city: string, lga: string, state: string) {
        return `${addressLineOne}, ${city ? `${city},` : ''} ${lga}, ${state} State`;
    }

    submitTinDetails(payload): Promise<any> {
        const requestId = this.getKycRequestIdForBrmOnboardedUser();
        let url = this.config.MONIEPOINT_ONBOARDING + `/api/v2/business-owner-onboarding/level-4/tin-verification`;
        if (requestId) {
            url = `${url}?requestId=${requestId}`;
        }
        return this.apiClientHelper.postForPromise(url, payload);
    }

    getBusinessAffiliates(): Promise<any> {
        const requestId = this.getKycRequestIdForBrmOnboardedUser();

        if (!this.useBusinessAffiliateFlow()) {
            return requestId ? this.getBusinessAffiliateV2(requestId) : this.getBusinessAffiliate();
        }

        let url = this.config.MONIEPOINT_ONBOARDING + `/api/v1/business-owner-onboarding/level-4/affiliates-details`;
        if (requestId) {
            url = `${url}?requestId=${requestId}`;
        }
        return this.apiClientHelper.getForPromise(url);
    }

    getKycRequestIdForBrmOnboardedUser() {
        if (!this.isAggregatorRole()) {
            return null;
        }
        return this.getKycRequestId();
    }

    updateAffiliateDetail(payload): Promise<any> {
        const requestId = this.getKycRequestIdForBrmOnboardedUser();
        let url = this.config.MONIEPOINT_ONBOARDING + `/api/v1/business-owner-onboarding/level-4/confirm-affiliates-details`;
        if (requestId) {
            url = `${url}?requestId=${requestId}`;
        }
        return this.apiClientHelper.postForPromise(url, payload);
    }

    deleteAffiliateV2(id): Promise<any> {
        const url = this.config.MONIEPOINT_ONBOARDING + `/api/v2/business-kycs/business-affiliate/${id}`;
        return this.apiClientHelper.delete(url);
    }

    updateAffiliatePEPDetail(payload): Promise<any> {
        const requestId = this.getKycRequestIdForBrmOnboardedUser();
        let url = this.config.MONIEPOINT_ONBOARDING + `/api/v1/pep-details/business-affiliate`;
        if (requestId) {
            url = `${url}?requestId=${requestId}`;
        }
        return this.apiClientHelper.postForPromise(url, payload);
    }

    getBusinessAffiliateIssues(payload): Promise<any> {
        const requestId = this.getKycRequestIdForBrmOnboardedUser();
        let url = this.config.MONIEPOINT_ONBOARDING + `/api/v1/business-owner-onboarding/level-4/affiliates-details-status`;
        if (requestId) {
            url = `${url}?requestId=${requestId}`;
        }
        return this.apiClientHelper.postForPromise(url, payload);
    }

    addPartner(payload, type: string): Promise<any> {
        const requestId = this.getKycRequestIdForBrmOnboardedUser();
        let url = this.config.MONIEPOINT_ONBOARDING + `/api/v2/business-kycs/business-affiliate/` + type;
        if (requestId) {
            url = `${url}?requestId=${requestId}`;
        }
        return this.apiClientHelper.postForPromise(url, payload);
    }

    addSCUMLDocuments(payload): Promise<any> {
        const requestId = this.getKycRequestIdForBrmOnboardedUser();
        let url = this.config.MONIEPOINT_ONBOARDING + `/api/v2/business-kycs/upload-scuml-details`;
        if (requestId) {
            url = `${url}?requestId=${requestId}`;
        }
        return this.apiClientHelper.postForPromise(url, payload);
    }

    getSCUMLDetails(): Promise<any> {
        const requestId = this.getKycRequestIdForBrmOnboardedUser();
        let url = this.config.MONIEPOINT_ONBOARDING + `/api/v2/business-kycs/scuml-details`;
        if (requestId) {
            url = `${url}?requestId=${requestId}`;
        }
        return this.apiClientHelper.getForPromise(url);
    }

    updateBusinessDetails(payload): Promise<any> {
        const requestId = this.getKycRequestIdForBrmOnboardedUser();
        let url = this.config.MONIEPOINT_ONBOARDING + `/api/v2/business-kycs/business-details-update`;
        if (requestId) {
            url = `${url}?requestId=${requestId}`;
        }
        return this.apiClientHelper.postForPromise(url, payload);
    }

    useBusinessAffiliateFlow() {
        return this.config.USE_CAC_BUSINESS_AFFILIATE_FLOW;
    }

    updateTINTimeline(timelines: TimelineModel[]) {
        const timeline = timelines.find((t) => t.key === KYCFormKeys.TIN_DETAIL);
        if (!timeline) {
            return;
        }
        const hasCompletedNin = true;
        timeline.isStepCompleted = true;
        timeline.isStepInReview = false;
        timeline.state = 'completed';
    }

    updateAffiliateTimeline(timelines: TimelineModel[]) {
        const kycData = this.getKycDataV2();
        const completed = false; // (kycData.bvnNinAffiliatesCheckStatus !== BusinessAffiliateStatus.PENDING) || (kycData.bvnNinAffiliatesCheckStatus !== BusinessAffiliateStatus.FAILED);
        const timeline = timelines.find((t) => t.key === KYCFormKeys.AFFILIATE_DETAIL);
        if (!timeline) {
            return;
        }
        const hasCompletedNin = true;
        timeline.isStepCompleted = completed;
        timeline.isStepInReview = false;
        timeline.state = TimelineStatus.completed;
        kycData.has_completed_affiliate_detail = completed;
        this.setKycDataV2(kycData);
    }

    canShowAddressRevalidationPopupDismissBtn() {
        return !this.config.SHOW_ADDRESS_VERIFICATION_POP_UP_EVERY_LOGIN;
    }

    updateNationality(params: OnboardingCreateNationality, isDashboardFlow = false): Promise<any> {
        const url = this.config.MONIEPOINT_ONBOARDING + `/api/v2/business-owner-onboarding/level-1/nationality?isFromBanner=${isDashboardFlow}`;
        return this.apiClientHelper.postForPromise(url, params);
    }

    updateSourceOfWealth(params: OnboardingCreateSourceOfWealth, isDashboardFlow = false): Promise<any> {
        params.userType = 'BUSINESS';
        const url = this.config.MONIEPOINT_ONBOARDING + `/api/v2/business-owner-onboarding/level-1/source-of-wealth?isFromBanner=${isDashboardFlow}`;
        return this.apiClientHelper.postForPromise(url, params);
    }

    updateAdditionalBusinessDetails(payload, preferredRequestId?: string): Promise<OnboardingAdditionalBusinessDetailsResponse> {
        const baseUrl = this.config.MONIEPOINT_ONBOARDING;
        const isBrm = this.isAggregatorRole();
        const requestId = preferredRequestId || (isBrm ? this.getKycRequestId() : null);
        const url = isBrm
            ? `${baseUrl}/api/v1/business-owner-onboarding/level-1/additional-business-details?requestId=${requestId}`
            : `${baseUrl}/api/v1/business-kycs/additional-business-details`;
        return this.apiClientHelper.postForPromise(url, payload);
    }

    getBusinessCategories() {
        const url = `${this.config.MONIEPOINT_ONBOARDING}/api/v1/business-category`;
        return this.apiClientHelper.getForPromise(url);
    }

    getPepScreening(requestId?: string): Promise<PepScreeningStatus> {
        const url = this.config.MONIEPOINT_ONBOARDING + `/api/v1/pep/screening${requestId ? `?requestId=${requestId}` : ''}`;
        return this.apiClientHelper.getForPromise(url);
    }

    updatePep(params: OnboardingCreatePepInfo, isDashboardFlow = false, requestId?: string): Promise<any> {
        const url = this.config.MONIEPOINT_ONBOARDING + `/api/v1/pep?isFromBanner=${isDashboardFlow}${requestId ? `&requestId=${requestId}` : ''}`;
        return this.apiClientHelper.postForPromise(url, params);
    }

    updatePepDeclaration(isPep: boolean, isDashboardFlow = false, requestId?: string): Promise<any> {
        const url =
            this.config.MONIEPOINT_ONBOARDING +
            `/api/v1/pep/declaration?isFromBanner=${isDashboardFlow}${requestId ? `&requestId=${requestId}` : ''}`;
        return this.apiClientHelper.postForPromise(url, { isPep });
    }

    clearKycLevel4Data() {
        this.setCurrentKycLvl4Step(null);
    }

    clearKycLevel1Data() {
        this.setCurrentKycLvl1Step(null);
    }

    clearKycLevel2Data() {
        this.setCurrentKycLvl2Step(null);
    }

    clearKycLevel3Data() {
        this.setCurrentKycLvl3Step(null);
    }

    hasScuml() {
        const kycData = this.getKycDataV2();
        const isScuml = kycData?.businessKycInformation?.businessSubCategory?.scuml;
        const isOperatingLicense = kycData?.businessKycInformation?.businessSubCategory?.operatingLicense;
        return isScuml || isOperatingLicense;
    }

    getKycLevel4StepsForAffiliateFlow(isFromBanner = false) {
        const canUseBusinessNameChange = this.canUseBusinessNameChange();
        const hasScuml = this.hasScuml();

        if (isFromBanner) {
            return KycLevel4StepForAffiliateFlow;
        }

        if (!this.isTINVerificationRequired()) {
            return this.getKycLevel4StepsWithoutTIN();
        }

        if (hasScuml && !canUseBusinessNameChange) {
            return KycLevel4StepForAffiliateFlowWithoutBusinessName;
        }

        if (!hasScuml && canUseBusinessNameChange) {
            return KycLevel4StepForAffiliateFlowWithoutScuml;
        }

        return KycLevel4StepForAffiliateFlow;
    }

    getKycLevel4StepsWithoutTIN() {
        const canUseBusinessNameChange = this.canUseBusinessNameChange();
        const hasScuml = this.hasScuml();

        if (hasScuml && !canUseBusinessNameChange) {
            return KycLevel4StepForAffiliateFlowWithoutBusinessNameAndTIN;
        }

        if (!hasScuml && canUseBusinessNameChange) {
            return KycLevel4StepForAffiliateFlowWithoutScumlAndTIN;
        }

        return KycLevel4StepForAffiliateFlowWithoutTIN;
    }

    getKycLevel4Steps(fromBanner = false) {
        const useBusinessAffiliateFlow = this.useBusinessAffiliateFlow();
        const canUseBusinessNameChange = this.canUseBusinessNameChange();
        const isFromBanner = fromBanner || this.isFromKYCBannerOnKycLevel4();

        if (useBusinessAffiliateFlow || isFromBanner) {
            return this.getKycLevel4StepsForAffiliateFlow(isFromBanner);
        }

        if (canUseBusinessNameChange) {
            return KycLevel4StepWithBusinessNameFlow;
        }

        return KycLevel4Step;
    }

    getKycLevel4TotalSteps() {
        const keys = Object.values(this.getKycLevel4Steps())
            .filter((value) => typeof value === 'string')
            .map((value) => ({ value: value as string }));
        return keys.length;
    }

    markTimelineAsActive(timelines: TimelineModel[], step: number) {
        timelines.forEach((timeline) => {
            const inactive = timeline.state === TimelineStatus.inactive;
            const isCurrentStep = step === timeline?.step;
            if (isCurrentStep && inactive) {
                timeline.state = TimelineStatus.active;
            }

            if (step > timeline?.step && inactive) {
                timeline.state = TimelineStatus.completed;
            }
        });
    }

    navigateToNextKycLevel4Form() {
        const currentStep = this.getCurrentKycLevel4Step();
        this.navigateKycLvl4Form(currentStep);
    }

    getCurrentKycLevel4Step() {
        const timelines = this.getUpdatedKycLvl4Timeline();
        const currentTimeline = timelines.find((timeline) => this.isFailedOrInactive(timeline.state));
        let currentStep = currentTimeline?.step;
        if (!currentStep) {
            currentStep = timelines.pop()?.step;
        }
        return currentStep;
    }

    isFailedOrInactive(status: string) {
        return status === TimelineStatus.failed || status === TimelineStatus.inactive;
    }

    navigateToPreviousKycLevel4Form(currentStep: number) {
        const previousStep = currentStep - 1;
        this.navigateKycLvl4Form(previousStep);
    }

    isFromKYCBannerOnKycLevel4() {
        if (this.failedBusinessNameRegistration()) {
            this.updateBusinessNameRejectionQueryParams();
        }

        if (this.hasKYCBannerKey()) {
            return this.isUserFromKycBanner();
        }

        return false;
    }

    private updateBusinessNameRejectionQueryParams() {
        this.router.navigate([], {
            relativeTo: this.route,
            queryParams: { fromKycBanner: false },
            queryParamsHandling: 'merge',
            replaceUrl: true,
        });
    }

    private hasKYCBannerKey(): boolean {
        const queryParams = this.route.snapshot.queryParams;
        return queryParams.hasOwnProperty(FROM_KYC_BANNER_KEY);
    }

    private isUserFromKycBanner(): boolean {
        const IS_USER_FROM_KYC_BANNER = 'true';
        const queryParams = this.route.snapshot.queryParams;
        const isFromKycBanner = queryParams[FROM_KYC_BANNER_KEY];
        return isFromKycBanner.toString() === IS_USER_FROM_KYC_BANNER;
    }

    private async addCustomGeoHeaders() {
        const isHeadersEnabled = this.config.ENABLE_ONBOARDING_LOCATION_HEADERS;
        const hasLocationPermission = await this.locationHelper.hasPermission();
        const additionalHeaderParams: Record<string, string> = {};

        if(isHeadersEnabled && hasLocationPermission) {
            const {longitude, latitude} = await this.locationHelper.getCoordinates();

            additionalHeaderParams['X-Longitude'] = String(longitude);
            additionalHeaderParams['X-Latitude'] = String(latitude);
        }

        return additionalHeaderParams;
    }

    failedBusinessNameRegistration() {
        const kycData = this.getKycDataV2();
        const hasCACRejection = this.hasRejectedCACVerification(kycData) || this.hasFailedCACVerification(kycData);
        return hasCACRejection;
    }

    routeToKycCorrections() {
        const isBrm = this.isAggregatorRole();
        this.router.navigateByUrl(getKycCorrectionRoute(isBrm));
    }

    isNationalityNigeria(kycData = null) {
        if (!kycData) kycData = this.getKycDataV2();
        return kycData?.personalInformation?.nationality?.code === NIGERIA_COUNTRY_CODE;
    }

    hasSubmittedNationality(kycData = null) {
        if (!kycData) kycData = this.getKycDataV2();
        return kycData?.personalInformation?.nationality?.code || kycData[KYCFormKeys.NATIONALITY];
    }

    getNationalityFromPersonalInformation() {
        const kycData = this.getKycDataV2();
        const personalInformation = kycData?.personalInformation || {};
        const { nationality = null, nationalityIsReadOnly = null } = personalInformation;
        return { ...nationality, isReadOnly: nationalityIsReadOnly };
    }

    //update BRM logic lvl 1

    getBrmKycLvl1FormParameters(key: KYCFormKeys) {
        const steps = this.getBrmCurrentTimeline(KYCLevel.LVL_1);
        const totalStep = steps?.length ?? 1;
        const currentStep = steps?.find((timeline) => timeline?.key === key)?.step;
        const step = this.getBrmCurrentSteps(currentStep, KYCLevel.LVL_1);
        const brmKycLevel1Steps = this.getBrmKycLevelOneStep();

        this.updateStepper(steps, currentStep);
        return {
            totalStep,
            step,
            steps,
            brmKycLevel1Steps,
        };
    }

    isBusinessNameRegisteredBusinessType() {
        const kycData = this.getKycDataV2();
        const businessKycInformation = kycData?.businessKycInformation;
        return businessKycInformation?.registeredBusinessType === KycBusinessType.BUSINESS_NAME;
    }

    useMockPepIssuesData() {
        return this.config.USE_MOCK_PEP_ISSUES_DATA;
    }

    usePhysicalAddressVerificationForKyc() {
        return this.config.USE_PHYSICAL_ADDRESS_VERIFICATION_FOR_KYC && !this.isAggregatorRole();
    }

    usePhysicalAddressVerificationForBrmKyc() {
        return this.config.USE_PHYSICAL_ADDRESS_VERIFICATION_FOR_BRM_KYC;
    }

    saveToLocalStorage(key: string, value: any) {
        this.localStorage.save(key, JSON.stringify(value));
    }

    useRegisterBusinessPrimerLabel() {
        return this.config.USE_REGISTERED_BUSINESS_PRIMER_LABEL;
    }

    formatAffiliateToUpperCase(affiliate: any) {
        if (affiliate?.designation) {
            return { ...affiliate, designation: affiliate?.designation?.toUpperCase() };
        }
        return { ...affiliate, affiliateType: affiliate?.affiliateType?.toUpperCase() };
    }

    getMoniebookOnBoardingStatus(boCode: string): Promise<BOMoniebookOnboardingStatusResponse> {
        const encodedBOCode = encodeURIComponent(boCode ?? '');
        const url = this.config.MONIEBOOK_SERVICE_URL + `/business/api/v1/onboarding/status?boCode=${encodedBOCode}`;
        return this.apiClientHelper.getForPromise(url);
    }

    onBoardOnMoniebook(data: BOMoniebookOnboardingRequest) {
        const url = this.config.MONIEBOOK_SERVICE_URL + `/business/api/v1/onboarding/business`;
        return this.apiClientHelper.postForPromise(url, data);
    }

    getMoniebookLoginCode(boCode: string): Promise<{ tokenIdentifier: string }> {
        const encodedBOCode = encodeURIComponent(boCode ?? '');
        const url = this.config.MONIEBOOK_SERVICE_URL + `/business/api/v1/onboard/user/${encodedBOCode}`;
        return this.apiClientHelper.postForPromise(url, {});
    }

    getMoniebookUserOnboardingStatus(boCode: string): Promise<MoniebookBusinessOnboardingStatusResponse> {
        const encodedBOCode = encodeURIComponent(boCode ?? '');
        const url = this.config.MONIEBOOK_SERVICE_URL + `/business/api/v1/onboard/user/${encodedBOCode}/status`;
        return this.apiClientHelper.getForPromise(url);
    }

    routeToVerifyIdentity(
        from: string,
        to: string,
        identityNumber: string,
        isFromMergeDuplicateProfile = false,
        pendingKycId = null,
        identitySource = null,
    ) {
        this.router.navigate([to], {
            queryParams: { from: encodeURIComponent(from), identityNumber, isFromMergeDuplicateProfile, pendingKycId, identitySource },
        });
    }

    getKycLvl2Status(preferredRequestId?: string): Promise<Response<KycBvnNinMistmatchV2>> {
        const baseUrl = this.config.MONIEPOINT_ONBOARDING + `/api/v1/kyc-upgrade/level-2/status`;
        const isBrm = this.isAggregatorRole();
        const requestId = preferredRequestId || (isBrm ? this.getKycRequestId() : null);
        const url = requestId ? `${baseUrl}?requestId=${requestId}` : baseUrl;
        return this.apiClientHelper.getForPromise(url);
    }

    useMoniepointMFBLogo() {
        return this.config.USE_MONIEPOINT_MFB_LOGO;
    }

    useAdditionBusinessDetailsKycLvl1() {
        return this.config.USE_ADDITIONAL_BUSINESS_KYC_LEVEL1;
    }

    useBrmAdditionalBusinessDetailsKycLvl1() {
        return this.config.BRM_USE_ADDITIONAL_BUSINESS_KYC_LEVEL1;
    }

    setShouldPreserveScumlFiles(value) {
        this.localStorage.save(StorageKeys.SHOULD_PRESERVE_SCUML_FILES, value);
    }

    getShouldPreserveScumlFiles() {
        return this.localStorage.get(StorageKeys.SHOULD_PRESERVE_SCUML_FILES) ?? true;
    }

    useFacetecLiveliness() {
        return this.config.USE_FACETEC_LIVELINESS
    }

    useBrmFacetecLiveliness() {
        return this.config.USE_BRM_FACETEC_LIVELINESS
    }


    useUpdatedKycLimitsFlow() {
        return this.config.USE_UPDATED_KYC_LIMITS_FLOW;
    }

    useKycLvl1PreventHybridMerchant() {
        return this.config.USE_KYC_LVL_1_PREVENT_HYBRID_MERCHANT
    }

    useBrmKycLvl1PreventHybridMerchant() {
        return this.useKycLvl1PreventHybridMerchant() && this.config.USE_BRM_KYC_LVL_1_PREVENT_HYBRID_MERCHANT
    }

    useSoftOnboardingPreventHybridMerchant() {
        return this.config.USE_SOFT_ONBOARDING_PREVENT_HYBRID_MERCHANT;
    }

    isLevelThreeCompleted(){
        const kycLevelThreeStatus = this.getKycDataV2()?.kycDashboardData?.kycLevelStatus?.kycLevelThreeStatus;
        const currentBusinessKycLvl = this.getCurrentBusinessKycLvlV2();
        return kycLevelThreeStatus === KycLvlState.COMPLETED && currentBusinessKycLvl >= 3;
    }

}
